/* eslint-disable */
import {
  $DomainEntity,
  $DomainEntityReflection,
  AttributeSelectionComponentState,
  ChildEntitySelectionComponentState,
  ComponentSystemFilterProps,
  DimensionIndicatorComponentState,
  DistanceDimensionComponentState,
  EnhancedAliasReflection,
  MorphTargetInfluence,
  PriceComponentState,
  SceneEntityObjectPropertiesComponentState,
  SceneEntityObjectRemoteMaterialOverrideComponentState,
  SceneEntityRemoteMaterialOverrideComponentState,
  SceneEntityRemoteObjectComponentState,
  Violation,
} from '@salsita-ai/platform-project-sdk/domain'

import {
  AnchorBase,
  AnchorSingleFeetBase,
  AnchorSinglePlatformBase,
  AnglePictureFrameBase,
  AnglePictureFrameCTCBase,
  AnglePictureFrameSingleBase,
  ApronBasic,
  ApronNone,
  ArchBase,
  ArchSingleBase,
  BellhouseBase,
  BellhouseSingleFeetBase,
  BellhouseSinglePlatformBase,
  BellyStretchedBase,
  BenchBasic,
  BoatShapeTop,
  BoxFrameBase,
  BrewerBase,
  BrewerSingleBase,
  CaseyBase,
  ConnectedXBase,
  CraftsmanBase,
  CraftsmanSingleBase,
  CrescentBase,
  CrescentSingleBase,
  CrossbraceTypes,
  DanaBase,
  DanaSingleBase,
  DremorTurnedBase,
  EllipticalOvalTop,
  FranklinBase,
  FranklinSingleFeetBase,
  FranklinSinglePlatformBase,
  HerricksonTurnedBase,
  HershBase,
  IvyBase,
  MantisBase,
  MarksBase,
  MeredithBase,
  MeredithSingleFeetBase,
  MeredithSinglePlatformBase,
  MidModernTaperBase,
  NarrowEnglishTurnedBase,
  OldEnglishTurnedBase,
  OswaldBase,
  OswaldSingleBase,
  PeruStretchedBase,
  RacetrackOvalTop,
  RectangleTop,
  ReededBase,
  ReflectionBase,
  ReflectionCTCBase,
  RishBase,
  RishSingleBase,
  RogersBase,
  RogersSinglePlatformBase,
  RoundTop,
  SinglePostBase,
  SinglePostSingleBase,
  SlagleTurnedBase,
  SlimConnectedXBase,
  SlimConnectedXSingleBase,
  SquareTop,
  Table,
  TamaraBase,
  TamaraSingleBase,
  TraditionalBase,
  TraditionalFlushBase,
  TriflectionBase,
  TuscanBase,
  TuscanSingleFeetBase,
  TuscanSinglePlatformBase,
  WaldenBase,
  WaldenSingleBase,
  XBase,
  XMetalBase,
  XMetalSingleBase,
  XSingleBase,
} from './model/index.js'

export const constants = {
  ApronBasic: {
    $apronThickness: 1.5,
    $insetFromEdge: 2,
    $apronThicknessWithFourLegs: 3,
    $insetFromEdgeWithFourLegs: 1.5,
    $apronDataMap: {
      RectangleTop: {
        objectName: 'APRON_RECTANGLE',
        sizing: {
          length: {
            scaleZero: 64,
            scaleOne: 120,
          },
          width: {
            scaleZero: 32,
            scaleOne: 52,
          },
          thickness: {
            scaleZero: 1.5,
            scaleOne: 2.5,
          },
        },
      },
      SquareTop: {
        objectName: 'APRON_RECTANGLE',
        sizing: {
          length: {
            scaleZero: 64,
            scaleOne: 120,
          },
          width: {
            scaleZero: 32,
            scaleOne: 52,
          },
          thickness: {
            scaleZero: 1.5,
            scaleOne: 2.5,
          },
        },
      },
      RoundTop: {
        objectName: 'APRON_ROUND',
        sizing: {
          width: {
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            scaleZero: 32,
            scaleOne: 52,
          },
          thickness: {
            scaleZero: 1.5,
            scaleOne: 2.5,
          },
          stretch: {
            scaleZero: 32,
            scaleOne: 42,
          },
        },
      },
      EllipticalOvalTop: {
        objectName: 'APRON_ROUND',
        sizing: {
          width: {
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            scaleZero: 32,
            scaleOne: 52,
          },
          thickness: {
            scaleZero: 1.5,
            scaleOne: 2.5,
          },
          stretch: {
            scaleZero: 32,
            scaleOne: 42,
          },
        },
      },
      RacetrackOvalTop: {
        objectName: 'APRON_ROUND',
        sizing: {
          width: {
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            scaleZero: 32,
            scaleOne: 52,
          },
          thickness: {
            scaleZero: 1.5,
            scaleOne: 2.5,
          },
          stretch: {
            scaleZero: 32,
            scaleOne: 42,
          },
        },
      },
      BoatShapeTop: {
        objectName: 'APRON_BOAT',
        sizing: {
          width: {
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            scaleZero: 64,
            scaleOne: 120,
          },
          thickness: {
            scaleZero: 1.41,
            scaleOne: 2.41,
          },
          stretch: {
            scaleZero: 64,
            scaleOne: 84,
          },
        },
      },
    },
  },
  BaseDoubleLeg: {
    $scaleLowerBreakpoint: 38,
    $scaleUpperBreakpoint: 46,
    $defaultCrossbraceObjectName: 'CROSS_BRACE',
    $crossbraceDataMap: {
      StandardCrossbrace: {
        objectName: 'CROSS_BRACE',
        sizing: {
          width: {
            scaleZero: 4.5,
            scaleOne: 6.5,
          },
          length: {
            scaleZero: 44,
            scaleOne: 54,
          },
          height: {
            scaleZero: 3,
            scaleOne: 6,
          },
          scale: {
            scaleZero: 4.5,
            scaleOne: 6.75,
            increment: 1.75,
          },
        },
      },
      NotchedCrossbrace: {
        objectName: 'CROSS_BRACE_NOTCHED',
        sizing: {
          width: {
            scaleZero: 4.5,
            scaleOne: 6.5,
          },
          length: {
            scaleZero: 44,
            scaleOne: 54,
          },
          height: {
            scaleZero: 3,
            scaleOne: 6,
          },
          scale: {
            scaleZero: 4.5,
            scaleOne: 6.75,
            increment: 1.75,
          },
        },
      },
    },
  },
  BaseFourLeg: {
    $widthIndicatorFixedY: 0,
    $widthIndicatorFixedZ: 0,
    $widthIndicatorExtrusionZ: 0,
  },
  BaseSingleLeg: {
    $platformHeight: 2.5,
    $platformToTopRatio: 0.55,
    $scaleLowerBreakpoint: 52,
    $scaleUpperBreakpoint: 76,
    $defaultTopWidthForSingleLeg: 60,
    $defaultTopLengthForSingleLeg: 60,
    $platformDataMap: {
      RectangleTop: {
        objectName: 'PLATFORM_SQUARE',
        sizing: {
          width: {
            scaleZero: 33,
            scaleOne: 43,
          },
          length: {
            scaleZero: 33,
            scaleOne: 43,
          },
        },
      },
      SquareTop: {
        objectName: 'PLATFORM_SQUARE',
        sizing: {
          width: {
            scaleZero: 33,
            scaleOne: 43,
          },
          length: {
            scaleZero: 33,
            scaleOne: 43,
          },
        },
      },
      RoundTop: {
        objectName: 'PLATFORM_ROUND',
        sizing: {
          width: {
            scaleZero: 31,
            scaleOne: 41,
          },
          length: {
            scaleZero: 31,
            scaleOne: 41,
          },
        },
      },
      EllipticalOvalTop: {
        objectName: 'PLATFORM_ELLIPSE',
        sizing: {
          width: {
            scaleZero: 25,
            scaleOne: 35,
          },
          length: {
            scaleZero: 42,
            scaleOne: 52,
          },
        },
      },
      RacetrackOvalTop: {
        objectName: 'PLATFORM_RACETRACK',
        sizing: {
          width: {
            scaleZero: 25,
            scaleOne: 35,
          },
          length: {
            scaleZero: 42,
            scaleOne: 52,
          },
        },
      },
      BoatShapeTop: {
        objectName: 'PLATFORM_BOAT',
        sizing: {
          width: {
            scaleZero: 26,
            scaleOne: 36,
          },
          length: {
            scaleZero: 42,
            scaleOne: 52,
          },
        },
      },
    },
  },
  Base: {
    $topWidthLowerLimitForBaseWidth: 28,
    $metalRepeatRatio: 6,
    $defaultHeight: 30,
    $defaultHeightWithPlatform: 27.5,
    $breakpointScaleIncrement: 1.75,
    $baseDataMap: {
      AnchorBase: {
        type: 'AnchorBase',
        label: 'Anchor',
        objectName: 'SUPPORT_ANCHOR',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/anchor.png',
        baseType: 'Pedestal',
        supportsCrossBrace: true,
        crossbraceType: 'NotchedCrossbrace',
        crossbraceData: {
          offsetY: 0,
          height: 3,
          width: 4.5,
          lengthExtension: -2.5,
        },
        sizing: {
          width: {
            scaleZero: 25,
            scaleOne: 35,
          },
          scale: {
            scaleZero: 25,
            scaleOne: 37.5,
            increment: 1.75,
          },
          feetThickness: 6,
          feetThicknessScaleOne: 9,
          baseThickness: 8.75,
          baseThicknessScaleOne: 13.125,
          baseThicknessCenterY: 10.9,
          baseThicknessCenterYScaleOne: 10.9,
        },
        pricing: {
          basePrice: 0,
        },
      },
      AnchorSingleFeetBase: {
        type: 'AnchorSingleFeetBase',
        label: 'Anchor with Feet',
        objectName: 'SUPPORT_ANCHOR_SINGLE_FEET',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/anchor-feet.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36,
            scaleOne: 46,
          },
          length: {
            scaleZero: 36,
            scaleOne: 46,
          },
          scale: {
            scaleZero: 36,
            scaleOne: 54,
            increment: 1.75,
          },
          feetThickness: 7,
          feetThicknessScaleOne: 10.5,
          baseThickness: 10.5,
          baseThicknessScaleOne: 15.75,
          baseThicknessCenterY: 11,
          baseThicknessCenterYScaleOne: 11,
        },
        pricing: {
          basePrice: 0,
        },
      },
      AnchorSinglePlatformBase: {
        type: 'AnchorSinglePlatformBase',
        label: 'Anchor with Platform',
        objectName: 'SUPPORT_ANCHOR_SINGLE_PLATFORM',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/anchor-platform.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 26,
            scaleOne: 36,
          },
          length: {
            scaleZero: 9.75,
            scaleOne: 0,
          },
          scale: {
            scaleZero: 26,
            scaleOne: 39,
            increment: 1.75,
          },
          baseThickness: 8.75,
          baseThicknessScaleOne: 13.125,
          baseThicknessCenterY: 9.25,
          baseThicknessCenterYScaleOne: 9.25,
        },
        pricing: {
          basePrice: 0,
        },
      },
      BellhouseBase: {
        type: 'BellhouseBase',
        label: 'Bellhouse',
        objectName: 'SUPPORT_BELLHOUSE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/bellhouse.png',
        baseType: 'Pedestal',
        supportsCrossBrace: true,
        crossbraceType: 'StandardCrossbrace',
        crossbraceData: {
          offsetY: 1.75,
          height: 1.75,
          width: 5,
          lengthExtension: -2,
        },
        sizing: {
          width: {
            scaleZero: 23.6,
            scaleOne: 43.6,
          },
          scale: {
            scaleZero: 23.6,
            scaleOne: 35.4,
            increment: 1.75,
          },
          feetThickness: 6,
          feetThicknessScaleOne: 9,
          baseThickness: 8.75,
          baseThicknessScaleOne: 13.125,
          baseThicknessCenterY: 13.5,
          baseThicknessCenterYScaleOne: 13.5,
        },
        pricing: {
          basePrice: 0,
        },
      },
      BellhouseSingleFeetBase: {
        type: 'BellhouseSingleFeetBase',
        label: 'Bellhouse with Feet',
        objectName: 'SUPPORT_BELLHOUSE_SINGLE_FEET',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/bellhouse-feet.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 35.9,
            scaleOne: 55.9,
          },
          length: {
            scaleZero: 35.9,
            scaleOne: 55.9,
          },
          scale: {
            scaleZero: 35.9,
            scaleOne: 53.85,
            increment: 1.75,
          },
          feetThickness: 6,
          feetThicknessScaleOne: 9,
          baseThickness: 8.75,
          baseThicknessScaleOne: 13.125,
          baseThicknessCenterY: 13.75,
          baseThicknessCenterYScaleOne: 13.75,
        },
        pricing: {
          basePrice: 0,
        },
      },
      BellhouseSinglePlatformBase: {
        type: 'BellhouseSinglePlatformBase',
        label: 'Bellhouse with Platform',
        objectName: 'SUPPORT_BELLHOUSE_SINGLE_PLATFORM',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/bellhouse-platform.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 30,
            scaleOne: 50,
          },
          length: {
            scaleZero: 9,
            scaleOne: 0,
          },
          scale: {
            scaleZero: 30,
            scaleOne: 45,
            increment: 1.75,
          },
          baseThickness: 8.75,
          baseThicknessScaleOne: 13.125,
          baseThicknessCenterY: 11.75,
          baseThicknessCenterYScaleOne: 11.75,
        },
        pricing: {
          basePrice: 0,
        },
      },
      BellyStretchedBase: {
        type: 'BellyStretchedBase',
        label: 'Belly Stretched',
        objectName: 'SUPPORT_BELLY_STRETCHED',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/belly-stretched.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 9.96,
            scaleOne: 19.96,
          },
          length: {
            scaleZero: 18.24,
            scaleOne: 28.24,
          },
          scale: {
            scaleZero: 9.96,
            scaleOne: 14.94,
            increment: 1.75,
          },
          baseThickness: 18.24,
          baseThicknessScaleOne: 27.36,
          baseThicknessCenterY: 9,
          baseThicknessCenterYScaleOne: 9,
        },
        pricing: {
          basePrice: 0,
        },
      },
      BrewerBase: {
        type: 'BrewerBase',
        label: 'Brewer',
        objectName: 'SUPPORT_BREWER',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/brewer.png',
        baseType: 'Pedestal',
        supportsCrossBrace: true,
        crossbraceType: 'StandardCrossbrace',
        crossbraceData: {
          offsetY: 12,
          height: 5,
          width: 1,
          lengthExtension: 0,
        },
        sizing: {
          width: {
            scaleZero: 25.28,
            scaleOne: 35.28,
          },
          scale: {
            scaleZero: 25.28,
            scaleOne: 37.92,
            increment: 1,
            scaleUpOnly: true,
          },
          feetThickness: 3.505,
          feetThicknessScaleOne: 5.257,
          baseThickness: 3.505,
          baseThicknessScaleOne: 5.257,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      BrewerSingleBase: {
        type: 'BrewerSingleBase',
        label: 'Brewer',
        objectName: 'SUPPORT_BREWER_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/brewer-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 39,
            scaleOne: 59,
          },
          length: {
            scaleZero: 39,
            scaleOne: 59,
          },
          scale: {
            scaleZero: 39,
            scaleOne: 58.5,
            increment: 1,
            scaleUpOnly: true,
          },
          feetThickness: 2.25,
          feetThicknessScaleOne: 3.375,
          baseThickness: 2.25,
          baseThicknessScaleOne: 3.375,
          baseThicknessCenterY: 11.75,
          baseThicknessCenterYScaleOne: 11.75,
        },
        pricing: {
          basePrice: 0,
        },
      },
      CaseyBase: {
        type: 'CaseyBase',
        label: 'Casey',
        objectName: 'SUPPORT_CASEY',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/casey.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 21.7,
            scaleOne: 25.7,
          },
          scale: {
            scaleZero: 21.7,
            scaleOne: 32.55,
            increment: 0,
          },
          feetThickness: 8.059,
          feetThicknessScaleOne: 13.712,
          baseThickness: 8.059,
          baseThicknessScaleOne: 12.088,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      CraftsmanBase: {
        type: 'CraftsmanBase',
        label: 'Craftsman',
        objectName: 'SUPPORT_CRAFTSMAN',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/craftsman.png',
        baseType: 'Pedestal',
        supportsCrossBrace: true,
        crossbraceType: 'StandardCrossbrace',
        crossbraceData: {
          offsetY: 12,
          height: 6,
          width: 1,
          lengthExtension: 0,
        },
        sizing: {
          width: {
            scaleZero: 26.01,
            scaleOne: 30.1,
          },
          scale: {
            scaleZero: 26.01,
            scaleOne: 39.02,
            increment: 1.25,
          },
          feetThickness: 4.5,
          feetThicknessScaleOne: 6.75,
          baseThickness: 4.5,
          baseThicknessScaleOne: 6.75,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      CraftsmanSingleBase: {
        type: 'CraftsmanSingleBase',
        label: 'Craftsman',
        objectName: 'SUPPORT_CRAFTSMAN_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/craftsman-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36.3,
            scaleOne: 46.3,
          },
          length: {
            scaleZero: 36.3,
            scaleOne: 46.3,
          },
          scale: {
            scaleZero: 36.3,
            scaleOne: 54.45,
            increment: 1.25,
          },
          feetThickness: 4.5,
          feetThicknessScaleOne: 6.75,
          baseThickness: 3.5,
          baseThicknessScaleOne: 5.25,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      CrescentBase: {
        type: 'CrescentBase',
        label: 'Crescent',
        objectName: 'SUPPORT_CRESCENT',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/crescent.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 25,
            scaleOne: 35,
          },
          scale: {
            scaleZero: 25,
            scaleOne: 37.5,
            increment: 1.25,
          },
          feetThickness: 5,
          feetThicknessScaleOne: 7.5,
          baseThickness: 4,
          baseThicknessScaleOne: 6,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      CrescentSingleBase: {
        type: 'CrescentSingleBase',
        label: 'Crescent',
        objectName: 'SUPPORT_CRESCENT_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/crescent-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 35.8,
            scaleOne: 45.8,
          },
          length: {
            scaleZero: 35.8,
            scaleOne: 45.8,
          },
          scale: {
            scaleZero: 35.8,
            scaleOne: 53.7,
            increment: 1.25,
          },
          feetThickness: 4.35,
          feetThicknessScaleOne: 6.525,
          baseThickness: 3.85,
          baseThicknessScaleOne: 5.775,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      DanaBase: {
        type: 'DanaBase',
        label: 'Dana',
        objectName: 'SUPPORT_DANA',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/dana.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 21,
            scaleOne: 25,
          },
          scale: {
            scaleZero: 21,
            scaleOne: 31.5,
            increment: 1.25,
          },
          feetThickness: 1.75,
          feetThicknessScaleOne: 2.625,
          baseThickness: 1.75,
          baseThicknessScaleOne: 2.625,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      DanaSingleBase: {
        type: 'DanaSingleBase',
        label: 'Dana',
        objectName: 'SUPPORT_DANA_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/dana-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36.12,
            scaleOne: 40.12,
          },
          length: {
            scaleZero: 36.12,
            scaleOne: 40.12,
          },
          scale: {
            scaleZero: 36.12,
            scaleOne: 54.18,
            increment: 1.25,
          },
          feetThickness: 1.75,
          feetThicknessScaleOne: 2.625,
          baseThickness: 1.75,
          baseThicknessScaleOne: 2.625,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      FranklinBase: {
        type: 'FranklinBase',
        label: 'Franklin',
        objectName: 'SUPPORT_FRANKLIN',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/franklin.png',
        baseType: 'Pedestal',
        supportsCrossBrace: true,
        crossbraceType: 'StandardCrossbrace',
        crossbraceData: {
          offsetY: 0.3,
          height: 2,
          width: 8,
          lengthExtension: 0,
        },
        sizing: {
          width: {
            scaleZero: 24.9,
            scaleOne: 34.9,
          },
          scale: {
            scaleZero: 24.9,
            scaleOne: 37.35,
            increment: 1.75,
          },
          feetThickness: 6.5,
          feetThicknessScaleOne: 9.75,
          baseThickness: 7,
          baseThicknessScaleOne: 10.5,
          baseThicknessCenterY: 13.1,
          baseThicknessCenterYScaleOne: 13.1,
        },
        pricing: {
          basePrice: 0,
        },
      },
      FranklinSingleFeetBase: {
        type: 'FranklinSingleFeetBase',
        label: 'Franklin with Feet',
        objectName: 'SUPPORT_FRANKLIN_SINGLE_FEET',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/franklin-feet.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36.2,
            scaleOne: 46.2,
          },
          length: {
            scaleZero: 36.2,
            scaleOne: 40.2,
          },
          scale: {
            scaleZero: 36.2,
            scaleOne: 54.3,
            increment: 1.75,
          },
          feetThickness: 8.785,
          feetThicknessScaleOne: 13.178,
          baseThickness: 10.5,
          baseThicknessScaleOne: 15.75,
          baseThicknessCenterY: 13.25,
          baseThicknessCenterYScaleOne: 13.25,
        },
        pricing: {
          basePrice: 0,
        },
      },
      FranklinSinglePlatformBase: {
        type: 'FranklinSinglePlatformBase',
        label: 'Franklin with Platform',
        objectName: 'SUPPORT_FRANKLIN_SINGLE_PLATFORM',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/franklin-platform.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 38.2,
            scaleOne: 48.2,
          },
          length: {
            scaleZero: 12.3,
            scaleOne: 0,
          },
          scale: {
            scaleZero: 38.2,
            scaleOne: 57.3,
            increment: 1.75,
          },
          baseThickness: 10.5,
          baseThicknessScaleOne: 15.75,
          baseThicknessCenterY: 12.75,
          baseThicknessCenterYScaleOne: 12.75,
        },
        pricing: {
          basePrice: 0,
        },
      },
      HershBase: {
        type: 'HershBase',
        label: 'Hersh',
        objectName: 'SUPPORT_HERSH_HIRSH',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/hersh.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 23,
            scaleOne: 33,
          },
          scale: {
            scaleZero: 23,
            scaleOne: 34.5,
            increment: 1,
          },
          feetThickness: 5,
          feetThicknessScaleOne: 7.5,
          baseThickness: 5,
          baseThicknessScaleOne: 7.5,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      MarksBase: {
        type: 'MarksBase',
        label: 'Marks',
        objectName: 'SUPPORT_MARKS',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/marks.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 26,
            scaleOne: 36,
          },
          length: {
            scaleZero: 50,
            scaleOne: 60.0463,
          },
          scale: {
            scaleZero: 26,
            scaleOne: 39,
            increment: 0,
          },
          feetThickness: 50,
          feetThicknessScaleOne: 75,
        },
        pricing: {
          basePrice: 0,
        },
      },
      MeredithBase: {
        type: 'MeredithBase',
        label: 'Meredith',
        objectName: 'SUPPORT_MEREDITH',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/meredith.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 25,
            scaleOne: 35,
          },
          scale: {
            scaleZero: 25,
            scaleOne: 37.5,
            increment: 1.75,
          },
          feetThickness: 5.5,
          feetThicknessScaleOne: 8.25,
          baseThickness: 8.75,
          baseThicknessScaleOne: 13.125,
          baseThicknessCenterY: 26.5,
          baseThicknessCenterYScaleOne: 26.5,
        },
        pricing: {
          basePrice: 0,
        },
      },
      MeredithSingleFeetBase: {
        type: 'MeredithSingleFeetBase',
        label: 'Meredith with Feet',
        objectName: 'SUPPORT_MEREDITH_SINGLE_FEET',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/meredith-feet.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 34,
            scaleOne: 44,
          },
          length: {
            scaleZero: 34,
            scaleOne: 44,
          },
          scale: {
            scaleZero: 34,
            scaleOne: 51,
            increment: 1.75,
          },
          feetThickness: 6,
          feetThicknessScaleOne: 9,
          baseThickness: 9.75,
          baseThicknessScaleOne: 14.625,
          baseThicknessCenterY: 26.25,
          baseThicknessCenterYScaleOne: 26.25,
        },
        pricing: {
          basePrice: 0,
        },
      },
      MeredithSinglePlatformBase: {
        type: 'MeredithSinglePlatformBase',
        label: 'Meredith with Platform',
        objectName: 'SUPPORT_MEREDITH_SINGLE_PLATFORM',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/meredith-platform.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 30,
            scaleOne: 40,
          },
          length: {
            scaleZero: 14.5,
            scaleOne: 0,
          },
          scale: {
            scaleZero: 40,
            scaleOne: 60,
            increment: 1.75,
          },
          baseThickness: 10.5,
          baseThicknessScaleOne: 15.75,
          baseThicknessCenterY: 27.25,
          baseThicknessCenterYScaleOne: 27.25,
        },
        pricing: {
          basePrice: 0,
        },
      },
      OswaldBase: {
        type: 'OswaldBase',
        label: 'Oswald',
        objectName: 'SUPPORT_OSWALD',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/oswald.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 21,
            scaleOne: 28,
          },
          scale: {
            scaleZero: 21,
            scaleOne: 31.5,
            increment: 1.25,
          },
          feetThickness: 3.5,
          feetThicknessScaleOne: 5.25,
          baseThickness: 7.5,
          baseThicknessScaleOne: 11.25,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      OswaldSingleBase: {
        type: 'OswaldSingleBase',
        label: 'Oswald',
        objectName: 'SUPPORT_OSWALD_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/oswald-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 28.3,
            scaleOne: 38.3,
          },
          length: {
            scaleZero: 32.3,
            scaleOne: 43.7,
          },
          scale: {
            scaleZero: 28.3,
            scaleOne: 42.45,
            increment: 0,
          },
          feetThickness: 3.5,
          feetThicknessScaleOne: 5.25,
          baseThickness: 3.5,
          baseThicknessScaleOne: 5.25,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      PeruStretchedBase: {
        type: 'PeruStretchedBase',
        label: 'Peru Stretched',
        objectName: 'SUPPORT_PERU_STRETCHED',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/peru-stretched.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 10.5,
            scaleOne: 20.5,
          },
          length: {
            scaleZero: 17.5,
            scaleOne: 27.5,
          },
          scale: {
            scaleZero: 10.5,
            scaleOne: 15.75,
            increment: 1.75,
          },
          baseThickness: 17.5,
          baseThicknessScaleOne: 26.25,
          baseThicknessCenterY: 4.5,
          baseThicknessCenterYScaleOne: 4.5,
        },
        pricing: {
          basePrice: 0,
        },
      },
      ReededBase: {
        type: 'ReededBase',
        label: 'Reeded',
        objectName: 'SUPPORT_REEDED_SINGLE_MEDIUM',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/reeded.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 22.75,
            scaleOne: 32.77,
          },
          length: {
            scaleZero: 22.75,
            scaleOne: 32.77,
          },
          scale: {
            scaleZero: 22.75,
            scaleOne: 34.12,
            increment: 1.75,
          },
        },
        pricing: {
          basePrice: 0,
        },
      },
      RishBase: {
        type: 'RishBase',
        label: 'Rish',
        objectName: 'SUPPORT_RISH',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/rish.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 23,
            scaleOne: 33,
          },
          scale: {
            scaleZero: 23,
            scaleOne: 34.5,
            increment: 1,
          },
          feetThickness: 4.5,
          feetThicknessScaleOne: 6.75,
          baseThickness: 4.5,
          baseThicknessScaleOne: 6.75,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      RishSingleBase: {
        type: 'RishSingleBase',
        label: 'Rish',
        objectName: 'SUPPORT_RISH_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/rish-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36,
            scaleOne: 46,
          },
          length: {
            scaleZero: 36,
            scaleOne: 46,
          },
          scale: {
            scaleZero: 36,
            scaleOne: 54,
            increment: 1,
          },
          feetThickness: 3,
          feetThicknessScaleOne: 4.5,
          baseThickness: 3,
          baseThicknessScaleOne: 4.5,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      RogersBase: {
        type: 'RogersBase',
        label: 'Rogers',
        objectName: 'SUPPORT_ROGERS_9_INCHES',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/rogers-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 25.4,
            scaleOne: 35.4,
          },
          scale: {
            scaleZero: 25.4,
            scaleOne: 38.1,
            increment: 1.75,
          },
          feetThickness: 25.364,
          feetThicknessScaleOne: 48.045,
          baseThickness: 9,
          baseThicknessScaleOne: 13.5,
          baseThicknessCenterY: 15.5,
          baseThicknessCenterYScaleOne: 15.5,
        },
        pricing: {
          basePrice: 0,
        },
      },
      RogersSinglePlatformBase: {
        type: 'RogersSinglePlatformBase',
        label: 'Rogers',
        objectName: 'SUPPORT_ROGERS_SINGLE_MEDIUM',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/rogers-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 25.36,
            scaleOne: 35.51,
          },
          length: {
            scaleZero: 14.18,
            scaleOne: 17.73,
          },
          scale: {
            scaleZero: 25.36,
            scaleOne: 39.76,
            increment: 1.75,
          },
        },
        pricing: {
          basePrice: 0,
        },
      },
      TamaraBase: {
        type: 'TamaraBase',
        label: 'Tamara',
        objectName: 'SUPPORT_TAMARA',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/tamara.png',
        baseType: 'Pedestal',
        supportsCrossBrace: true,
        crossbraceType: 'StandardCrossbrace',
        crossbraceData: {
          offsetY: 12,
          height: 6,
          width: 1,
          lengthExtension: 0,
        },
        sizing: {
          width: {
            scaleZero: 25.1,
            scaleOne: 37.59,
          },
          scale: {
            scaleZero: 25.1,
            scaleOne: 37.65,
            increment: 1.25,
          },
          feetThickness: 5.49,
          feetThicknessScaleOne: 8.234,
          baseThickness: 5.49,
          baseThicknessScaleOne: 8.234,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      TamaraSingleBase: {
        type: 'TamaraSingleBase',
        label: 'Tamara',
        objectName: 'SUPPORT_TAMARA_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/tamara-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 37.12,
            scaleOne: 49.52,
          },
          length: {
            scaleZero: 37.08,
            scaleOne: 49.47,
          },
          scale: {
            scaleZero: 37.12,
            scaleOne: 55.68,
            increment: 1.25,
          },
          feetThickness: 5.5,
          feetThicknessScaleOne: 8.25,
          baseThickness: 5.25,
          baseThicknessScaleOne: 7.875,
          baseThicknessCenterY: 10,
          baseThicknessCenterYScaleOne: 10,
        },
        pricing: {
          basePrice: 0,
        },
      },
      TuscanBase: {
        type: 'TuscanBase',
        label: 'Tuscan',
        objectName: 'SUPPORT_TUSCAN',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/tuscan.png',
        baseType: 'Pedestal',
        supportsCrossBrace: true,
        crossbraceType: 'NotchedCrossbrace',
        crossbraceData: {
          offsetY: 1,
          height: 3,
          width: 4.5,
          lengthExtension: -2.5,
        },
        sizing: {
          width: {
            scaleZero: 26.1,
            scaleOne: 36.1,
          },
          scale: {
            scaleZero: 26.1,
            scaleOne: 39.15,
            increment: 1.75,
          },
          feetThickness: 6,
          feetThicknessScaleOne: 9,
          baseThickness: 8.5,
          baseThicknessScaleOne: 12.75,
          baseThicknessCenterY: 9.6,
          baseThicknessCenterYScaleOne: 9.6,
        },
        pricing: {
          basePrice: 0,
        },
      },
      TuscanSingleFeetBase: {
        type: 'TuscanSingleFeetBase',
        label: 'Tuscan with Feet',
        objectName: 'SUPPORT_TUSCAN_SINGLE_FEET',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/tuscan-feet.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36.1,
            scaleOne: 46.1,
          },
          length: {
            scaleZero: 36.1,
            scaleOne: 46.1,
          },
          scale: {
            scaleZero: 36.1,
            scaleOne: 54.15,
            increment: 1.75,
          },
          feetThickness: 6.48,
          feetThicknessScaleOne: 9.72,
          baseThickness: 10.54,
          baseThicknessScaleOne: 15.81,
          baseThicknessCenterY: 8.5,
          baseThicknessCenterYScaleOne: 8.5,
        },
        pricing: {
          basePrice: 0,
        },
      },
      TuscanSinglePlatformBase: {
        type: 'TuscanSinglePlatformBase',
        label: 'Tuscan with Platform',
        objectName: 'SUPPORT_TUSCAN_SINGLE_PLATFORM',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/tuscan-platform.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 30,
            scaleOne: 40,
          },
          length: {
            scaleZero: 14.5,
            scaleOne: 24.6,
          },
          scale: {
            scaleZero: 42,
            scaleOne: 63,
            increment: 1.75,
          },
          baseThickness: 10.54,
          baseThicknessScaleOne: 15.81,
          baseThicknessCenterY: 7,
          baseThicknessCenterYScaleOne: 7,
        },
        pricing: {
          basePrice: 0,
        },
      },
      WaldenBase: {
        type: 'WaldenBase',
        label: 'Walden',
        objectName: 'SUPPORT_WALDEN',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/walden.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 25,
            scaleOne: 35,
          },
          scale: {
            scaleZero: 25,
            scaleOne: 37.5,
            increment: 0,
          },
          feetThickness: 5.5,
          feetThicknessScaleOne: 8.25,
          baseThickness: 5.5,
          baseThicknessScaleOne: 8.25,
          baseThicknessCenterY: 2.1,
          baseThicknessCenterYScaleOne: 2.1,
        },
        pricing: {
          basePrice: 0,
        },
      },
      WaldenSingleBase: {
        type: 'WaldenSingleBase',
        label: 'Walden',
        objectName: 'SUPPORT_WALDEN_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/walden-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 37,
            scaleOne: 47,
          },
          length: {
            scaleZero: 37,
            scaleOne: 47,
          },
          scale: {
            scaleZero: 37,
            scaleOne: 55.5,
            increment: 1.75,
          },
          feetThickness: 6.5,
          feetThicknessScaleOne: 11.375,
          baseThickness: 5.5,
          baseThicknessScaleOne: 8.25,
          baseThicknessCenterY: 28.6,
          baseThicknessCenterYScaleOne: 28.6,
        },
        pricing: {
          basePrice: 0,
        },
      },
      XBase: {
        type: 'XBase',
        label: 'X',
        objectName: 'SUPPORT_X',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/x.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 25,
            scaleOne: 33.62,
          },
          scale: {
            scaleZero: 25,
            scaleOne: 37.5,
            increment: 0,
          },
          feetThickness: 3,
          feetThicknessScaleOne: 4.5,
          baseThickness: 3,
          baseThicknessScaleOne: 4.5,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      XSingleBase: {
        type: 'XSingleBase',
        label: 'X',
        objectName: 'SUPPORT_X_DOUBLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/x-single.png',
        baseType: 'Pedestal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36,
            scaleOne: 46.7249,
          },
          length: {
            scaleZero: 36,
            scaleOne: 46.6761,
          },
          scale: {
            scaleZero: 36,
            scaleOne: 54,
            increment: 0,
          },
          feetThickness: 1.75,
          feetThicknessScaleOne: 2.625,
          baseThickness: 1.75,
          baseThicknessScaleOne: 2.625,
          baseThicknessCenterY: 14.25,
          baseThicknessCenterYScaleOne: 14.25,
        },
        pricing: {
          basePrice: 0,
        },
      },
      AnglePictureFrameBase: {
        type: 'AnglePictureFrameBase',
        label: 'Angle Picture Frame',
        objectName: 'SUPPORT_METAL_ANGLE_PICTURE_FRAME',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/angle-picture-frame.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 23,
            scaleOne: 33,
          },
          scale: {
            scaleZero: 23,
            scaleOne: 34.5,
            increment: 1,
          },
          feetThickness: 3.5,
          feetThicknessScaleOne: 5.25,
          baseThickness: 3.5,
          baseThicknessScaleOne: 5.25,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      AnglePictureFrameSingleBase: {
        type: 'AnglePictureFrameSingleBase',
        label: 'Angle Picture Frame',
        objectName: 'SUPPORT_METAL_ANGLE_PICTURE_FRAME_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/angle-picture-frame-single.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36.3,
            scaleOne: 46.3,
          },
          length: {
            scaleZero: 36.3,
            scaleOne: 46.3,
          },
          scale: {
            scaleZero: 36.3,
            scaleOne: 54.45,
            increment: 1,
          },
          feetThickness: 2,
          feetThicknessScaleOne: 3,
          baseThickness: 2,
          baseThicknessScaleOne: 3,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      AnglePictureFrameCTCBase: {
        type: 'AnglePictureFrameCTCBase',
        label: 'Angle Picture Frame',
        objectName: 'SUPPORT_METAL_ANGLE_PICTURE_FRAME_CTC',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/angle-picture-frame-ctc.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 31.3,
            scaleOne: 41.3,
          },
          length: {
            scaleZero: 31.3,
            scaleOne: 41.3,
          },
          scale: {
            scaleZero: 31.3,
            scaleOne: 46.95,
            increment: 1,
          },
          feetThickness: 2.868,
          feetThicknessScaleOne: 4.302,
          baseThickness: 2.868,
          baseThicknessScaleOne: 4.302,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      ArchBase: {
        type: 'ArchBase',
        label: 'Arch',
        objectName: 'SUPPORT_METAL_ARCH',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/arch.png',
        baseType: 'Metal',
        supportsCrossBrace: true,
        crossbraceType: 'StandardCrossbrace',
        crossbraceData: {
          offsetY: 12,
          height: 6,
          width: 1,
          lengthExtension: 0,
        },
        sizing: {
          width: {
            scaleZero: 23,
            scaleOne: 33,
          },
          scale: {
            scaleZero: 23,
            scaleOne: 34.5,
            increment: 1,
          },
          feetThickness: 3,
          feetThicknessScaleOne: 4.5,
          baseThickness: 3,
          baseThicknessScaleOne: 4.5,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      ArchSingleBase: {
        type: 'ArchSingleBase',
        label: 'Arch',
        objectName: 'SUPPORT_METAL_ARCH_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/arch-single.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36,
            scaleOne: 46,
          },
          length: {
            scaleZero: 36,
            scaleOne: 46,
          },
          scale: {
            scaleZero: 36,
            scaleOne: 54,
            increment: 1,
          },
          feetThickness: 4,
          feetThicknessScaleOne: 6,
          baseThickness: 4,
          baseThicknessScaleOne: 6,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      BoxFrameBase: {
        type: 'BoxFrameBase',
        label: 'Box Frame',
        objectName: 'SUPPORT_METAL_BOX_FRAME',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/box-frame.png',
        baseType: 'Metal',
        supportsCrossBrace: true,
        crossbraceType: 'StandardCrossbrace',
        crossbraceData: {
          offsetY: 13.25,
          height: 3.5,
          width: 3.5,
          lengthExtension: 0,
        },
        sizing: {
          width: {
            scaleZero: 23,
            scaleOne: 33,
          },
          scale: {
            scaleZero: 23,
            scaleOne: 34.5,
            increment: 1,
          },
          feetThickness: 3,
          feetThicknessScaleOne: 4.5,
          baseThickness: 3.5,
          baseThicknessScaleOne: 5.25,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      MantisBase: {
        type: 'MantisBase',
        label: 'Mantis',
        objectName: 'SUPPORT_METAL_MANTIS',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/mantis-single.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 27.3,
            scaleOne: 37.3,
          },
          length: {
            scaleZero: 48.7,
            scaleOne: 58.7,
          },
          scale: {
            scaleZero: 27.3,
            scaleOne: 40.95,
            increment: 0,
          },
          feetThickness: 1.5,
          feetThicknessScaleOne: 2.25,
          baseThickness: 3.064,
          baseThicknessScaleOne: 4.596,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      ConnectedXBase: {
        type: 'ConnectedXBase',
        label: 'Connected X',
        objectName: 'SUPPORT_METAL_CONNECTED_X',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/connected-x.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 25,
            scaleOne: 35,
          },
          scale: {
            scaleZero: 25,
            scaleOne: 37.5,
            increment: 1,
          },
          feetThickness: 4,
          feetThicknessScaleOne: 6,
          baseThickness: 4,
          baseThicknessScaleOne: 6,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      SlimConnectedXBase: {
        type: 'SlimConnectedXBase',
        label: 'Slim Connected X',
        objectName: 'SUPPORT_METAL_CONNECTED_SLIM_X',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/slim-connected-x.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 23,
            scaleOne: 33,
          },
          scale: {
            scaleZero: 23,
            scaleOne: 34.5,
            increment: 1,
          },
          feetThickness: 1,
          feetThicknessScaleOne: 1.5,
          baseThickness: 1,
          baseThicknessScaleOne: 1.5,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      SlimConnectedXSingleBase: {
        type: 'SlimConnectedXSingleBase',
        label: 'Slim Connected X',
        objectName: 'SUPPORT_METAL_CONNECTED_SLIM_X_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/slim-connected-x-single.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36,
            scaleOne: 51.7,
          },
          length: {
            scaleZero: 36,
            scaleOne: 51.7,
          },
          scale: {
            scaleZero: 36,
            scaleOne: 54,
            increment: 1,
          },
          feetThickness: 1,
          feetThicknessScaleOne: 1.935,
          baseThickness: 1,
          baseThicknessScaleOne: 1.935,
          baseThicknessCenterY: 14.75,
          baseThicknessCenterYScaleOne: 14.75,
        },
        pricing: {
          basePrice: 0,
        },
      },
      ReflectionBase: {
        type: 'ReflectionBase',
        label: 'Reflection',
        objectName: 'SUPPORT_METAL_REFLECTION',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/reflection.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 23.2,
            scaleOne: 33.2,
          },
          length: {
            scaleZero: 56,
            scaleOne: 66,
          },
          scale: {
            scaleZero: 23.2,
            scaleOne: 34.8,
            increment: 1,
          },
          feetThickness: 3.535,
          feetThicknessScaleOne: 5.303,
          baseThickness: 3.535,
          baseThicknessScaleOne: 5.303,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      ReflectionCTCBase: {
        type: 'ReflectionCTCBase',
        label: 'Reflection',
        objectName: 'SUPPORT_METAL_REFLECTION_CTC',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/reflection-ctc.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 26.2,
            scaleOne: 36.2,
          },
          length: {
            scaleZero: 26.2,
            scaleOne: 36.2,
          },
          scale: {
            scaleZero: 26.2,
            scaleOne: 39.3,
            increment: 1,
          },
          feetThickness: 1.414,
          feetThicknessScaleOne: 2.121,
          baseThickness: 1.414,
          baseThicknessScaleOne: 2.121,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      SinglePostBase: {
        type: 'SinglePostBase',
        label: 'Single Post',
        objectName: 'SUPPORT_METAL_SINGLE_POST',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/single-post.png',
        baseType: 'Metal',
        supportsCrossBrace: true,
        crossbraceType: 'StandardCrossbrace',
        crossbraceData: {
          offsetY: 12,
          height: 6,
          width: 1,
          lengthExtension: 0,
        },
        sizing: {
          width: {
            scaleZero: 23.5,
            scaleOne: 33.5,
          },
          scale: {
            scaleZero: 23.5,
            scaleOne: 35.25,
            increment: 1,
          },
          feetThickness: 3,
          feetThicknessScaleOne: 4.5,
          baseThickness: 3,
          baseThicknessScaleOne: 4.5,
          baseThicknessCenterY: 13.7,
          baseThicknessCenterYScaleOne: 13.7,
        },
        pricing: {
          basePrice: 0,
        },
      },
      SinglePostSingleBase: {
        type: 'SinglePostSingleBase',
        label: 'Single Post',
        objectName: 'SUPPORT_METAL_SINGLE_POST_SINGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/single-post-single.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 33,
            scaleOne: 43,
          },
          length: {
            scaleZero: 33,
            scaleOne: 43,
          },
          scale: {
            scaleZero: 33,
            scaleOne: 49.5,
            increment: 1,
          },
          feetThickness: 3,
          feetThicknessScaleOne: 4.5,
          baseThickness: 3,
          baseThicknessScaleOne: 4.5,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      XMetalBase: {
        type: 'XMetalBase',
        label: 'X',
        objectName: 'SUPPORT_METAL_X',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/x-metal.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 26,
            scaleOne: 36,
          },
          length: {
            scaleZero: 0,
            scaleOne: 0,
          },
          scale: {
            scaleZero: 26,
            scaleOne: 39,
            increment: 1,
          },
          feetThickness: 4,
          feetThicknessScaleOne: 6,
          baseThickness: 4,
          baseThicknessScaleOne: 6,
          baseThicknessCenterY: 15,
          baseThicknessCenterYScaleOne: 15,
        },
        pricing: {
          basePrice: 0,
        },
      },
      XMetalSingleBase: {
        type: 'XMetalSingleBase',
        label: 'X',
        objectName: 'SUPPORT_METAL_X_DOUBLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/x-metal-single.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 36,
            scaleOne: 46,
          },
          length: {
            scaleZero: 36,
            scaleOne: 46,
          },
          scale: {
            scaleZero: 36,
            scaleOne: 54,
            increment: 1,
          },
          feetThickness: 3,
          feetThicknessScaleOne: 4.5,
          baseThickness: 4.624,
          baseThicknessScaleOne: 6.936,
          baseThicknessCenterY: 14.75,
          baseThicknessCenterYScaleOne: 14.75,
        },
        pricing: {
          basePrice: 0,
        },
      },
      TriflectionBase: {
        type: 'TriflectionBase',
        label: 'Triflection',
        objectName: 'SUPPORT_METAL_TRIFLECTION',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/triflection.png',
        baseType: 'Metal',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 22.9,
            scaleOne: 34.5,
          },
          scale: {
            scaleZero: 22.9,
            scaleOne: 34.35,
            increment: 1,
          },
          feetThickness: 19.855,
          feetThicknessScaleOne: 39.783,
        },
        pricing: {
          basePrice: 0,
        },
      },
      IvyBase: {
        type: 'IvyBase',
        label: 'Ivy',
        objectName: 'SUPPORT_IVY',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/ivy.png',
        baseType: 'FourLeg',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: {
            scaleZero: 41,
            scaleOne: 51,
          },
          length: {
            scaleZero: 83,
            scaleOne: 93,
          },
        },
        pricing: {
          basePrice: 0,
        },
      },
      DremorTurnedBase: {
        type: 'DremorTurnedBase',
        label: 'Dremor Turned',
        objectName: 'SUPPORT_TURNED_DREMOR',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/dremor-turned.png',
        baseType: 'FourLeg',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: 3,
        },
        positioning: {
          legInset: 1,
        },
        pricing: {
          basePrice: 0,
        },
      },
      HerricksonTurnedBase: {
        type: 'HerricksonTurnedBase',
        label: 'Herrickson Turned',
        objectName: 'SUPPORT_TURNED_HERRICKSON',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/herrickson-turned.png',
        baseType: 'FourLeg',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: 3.5,
        },
        positioning: {
          legInset: 1,
        },
        pricing: {
          basePrice: 0,
        },
      },
      MidModernTaperBase: {
        type: 'MidModernTaperBase',
        label: 'Mid-Modern',
        objectName: 'SUPPORT_MID_MODERN_TAPER_ROUNDED',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/mid-modern.png',
        baseType: 'FourLeg',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: 3.5,
        },
        positioning: {
          legInset: 1,
        },
        pricing: {
          basePrice: 0,
        },
      },
      NarrowEnglishTurnedBase: {
        type: 'NarrowEnglishTurnedBase',
        label: 'Narrow English Turned',
        objectName: 'SUPPORT_TURNED_ENGLISH_NARROW',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/narrow-english-turned.png',
        baseType: 'FourLeg',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: 3,
        },
        positioning: {
          legInset: 1,
        },
        pricing: {
          basePrice: 0,
        },
      },
      OldEnglishTurnedBase: {
        type: 'OldEnglishTurnedBase',
        label: 'Old English Turned',
        objectName: 'SUPPORT_TURNED_OLD_ENGLISH',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/old-english-turned.png',
        baseType: 'FourLeg',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: 3.5,
        },
        positioning: {
          legInset: 1,
        },
        pricing: {
          basePrice: 0,
        },
      },
      SlagleTurnedBase: {
        type: 'SlagleTurnedBase',
        label: 'Slagle Turned',
        objectName: 'SUPPORT_TURNED_SLAGLE',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/slagle-turned.png',
        baseType: 'FourLeg',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          width: 5,
        },
        positioning: {
          legInset: 1,
        },
        pricing: {
          basePrice: 0,
        },
      },
      TraditionalBase: {
        type: 'TraditionalBase',
        label: 'Traditional',
        objectName: 'SUPPORT_FLUSH_LEG',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/traditional.png',
        baseType: 'FourLeg',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          height: {
            scaleZero: 30,
            scaleOne: 32,
          },
          width: 3.5,
        },
        positioning: {
          legInset: 0,
        },
        pricing: {
          basePrice: 0,
        },
      },
      TraditionalFlushBase: {
        type: 'TraditionalFlushBase',
        label: 'Traditional Flush',
        objectName: 'SUPPORT_FLUSH_LEG',
        importDimensionUnit: 'inch',
        thumbnailUrl: '/images/legs/traditional-flush.png',
        baseType: 'FourLeg',
        supportsCrossBrace: false,
        crossbraceType: null,
        crossbraceData: null,
        sizing: {
          height: {
            scaleZero: 30,
            scaleOne: 32,
          },
          width: 3.5,
        },
        positioning: {
          legInset: -0.04,
        },
        pricing: {
          basePrice: 0,
        },
      },
    },
  },
  BenchBasic: {
    $benchHeight: 18,
    $benchTopThickness: 1.25,
    $benchTopWidth: 16,
    $benchBaseFootprint: 14,
    $benchInsetFromTable: 6,
    $benchApronThickness: 2,
    $benchApronInset: 1,
    $benchGap: 4,
    $benchLegInsetDefault: 6,
    $bevelScaleZero: 0,
    $bevelScaleOne: 1,
    $crossbraceDataMap: {
      StandardCrossbrace: {
        objectName: 'CROSS_BRACE',
        sizing: {
          width: {
            scaleZero: 4.5,
            scaleOne: 6.5,
          },
          length: {
            scaleZero: 44,
            scaleOne: 54,
          },
          height: {
            scaleZero: 3,
            scaleOne: 6,
          },
          scale: {
            scaleZero: 4.5,
            scaleOne: 6.75,
            increment: 1.75,
          },
        },
      },
      NotchedCrossbrace: {
        objectName: 'CROSS_BRACE_NOTCHED',
        sizing: {
          width: {
            scaleZero: 4.5,
            scaleOne: 6.5,
          },
          length: {
            scaleZero: 44,
            scaleOne: 54,
          },
          height: {
            scaleZero: 3,
            scaleOne: 6,
          },
          scale: {
            scaleZero: 4.5,
            scaleOne: 6.75,
            increment: 1.75,
          },
        },
      },
    },
  },
  RootEntity: {
    $glbFileUrl: '/models/element-furniture.glb',
    $emailSubject: 'Element Furniture - Custom Table Estimate',
    $emailBodyText:
      'Thank you for submitting a design request for your custom table. Your estimate details are included below.\n\nPlease note that prices shown in our "Design Your Table" tool are estimates and may change after our team reviews your request.\n\nWe will get back to you as soon as possible. We look forward to connecting with you!',
    $emailFooterNote: 'Estimate price is approximate and may change at any time.',
    $emailFooterAddress: '18558 NW Frontage Road, Joliet, IL 60404',
    $emailFooterPhone: '847-401-7753',
    $emailFooterEmail: 'info@elementfurniture.com',
    $tableColumns: ['Item', 'Description', 'Price'],
  },
  Table: {},
  TopWithWidthAndLength: {
    $leafBevelScaleZero: 0,
    $leafBevelScaleOne: 0.05,
  },
  Top: {
    $minLeafAmount: 1,
    $minTopLengthForExtraBase: 144,
    $minTopLengthForDoubleBase: 55,
    $straightPartOfBevelTopThickness: 0.25,
    $minBeveledTopThickness: 1,
    $bevelScaleZero: 0,
    $bevelScaleOne: 1,
    $topDataMap: {
      RectangleTop: {
        type: 'RectangleTop',
        label: 'Rectangle',
        description: 'Rectangular tabletop',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameCornerRadius: 'TOP_RECTANGLE_ROUND_CORNERS',
        objectNameWavy: 'TOP_RECTANGLE_WAVY_EDGE',
        objectNameDupont: 'TOP_RECTANGLE_OGEE',
        thumbnailUrl: '/images/shapes/rectangle.png',
        sizing: {
          width: {
            min: 30,
            max: 60,
            default: 42,
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            min: 40,
            max: 180,
            default: 84,
            scaleZero: 64,
            scaleOne: 120,
          },
          thickness: {
            thicknessTypes: ['Standard', 'Rolled'],
            scaleZero: 0.5,
            scaleOne: 2.5,
          },
          distance: {
            scaleDelta: 20,
          },
        },
        pricing: {
          basePrice: 5909,
          compoundingRate: 0.05,
          pricingStep: 6,
        },
        fatals: {
          edgeStyleAvailableForThisTop: {
            allowedValues: ['Clean', 'NaturalWavy', 'Tumbled', 'Dupont', 'Beveled'],
          },
        },
        warnings: {
          lengthMightNotBeAvailableForThisTop: {
            minValue: 144,
          },
          thicknessTypeMightNotBeAvailableForThisTop: {
            value: 'Thick',
          },
        },
        notices: {
          widthMaybeTooBigForDoor: {
            minValue: 78,
          },
        },
      },
      SquareTop: {
        type: 'SquareTop',
        label: 'Square',
        description: 'Square tabletop',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameCornerRadius: 'TOP_RECTANGLE_ROUND_CORNERS',
        objectNameWavy: 'TOP_RECTANGLE_WAVY_EDGE',
        objectNameDupont: 'TOP_RECTANGLE_OGEE',
        thumbnailUrl: '/images/shapes/square.png',
        sizing: {
          width: {
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            scaleZero: 64,
            scaleOne: 120,
          },
          side: {
            min: 36,
            max: 96,
            default: 60,
          },
          thickness: {
            thicknessTypes: ['Standard', 'Rolled'],
            scaleZero: 0.5,
            scaleOne: 2.5,
          },
          distance: {
            scaleDelta: 20,
          },
        },
        pricing: {
          basePrice: 5241,
          compoundingRate: 0.05,
          pricingStep: 6,
        },
        fatals: {
          edgeStyleAvailableForThisTop: {
            allowedValues: ['Clean', 'NaturalWavy', 'Tumbled', 'Dupont', 'Beveled'],
          },
        },
        warnings: {
          lengthMightNotBeAvailableForThisTop: {
            minValue: null,
          },
          thicknessTypeMightNotBeAvailableForThisTop: {
            value: 'Thick',
          },
        },
        notices: {
          widthMaybeTooBigForDoor: {
            minValue: 78,
          },
        },
      },
      RoundTop: {
        type: 'RoundTop',
        label: 'Round',
        description: 'Round tabletop',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_ROUND',
        objectNameCornerRadius: 'TOP_ROUND',
        objectNameWavy: 'TOP_ROUND',
        objectNameDupont: 'TOP_ROUND_OGEE',
        thumbnailUrl: '/images/shapes/round.png',
        sizing: {
          width: {
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            scaleZero: 32,
            scaleOne: 120,
          },
          diameter: {
            min: 36,
            max: 96,
            default: 60,
          },
          thickness: {
            thicknessTypes: ['Standard', 'Thick'],
            scaleZero: 0.5,
            scaleOne: 2.5,
          },
          distance: {
            scaleDelta: 20,
          },
        },
        pricing: {
          basePrice: 3801,
          compoundingRate: 0.05,
          pricingStep: 6,
        },
        fatals: {
          edgeStyleAvailableForThisTop: {
            allowedValues: ['Clean', 'Tumbled', 'Dupont', 'Beveled'],
          },
        },
        warnings: {
          lengthMightNotBeAvailableForThisTop: {
            minValue: null,
          },
          thicknessTypeMightNotBeAvailableForThisTop: {
            value: 'Thick',
          },
        },
        notices: {
          widthMaybeTooBigForDoor: {
            minValue: 78,
          },
        },
      },
      EllipticalOvalTop: {
        type: 'EllipticalOvalTop',
        label: 'Elliptical Oval',
        description: 'Elliptical Oval tabletop',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_ROUND',
        objectNameCornerRadius: 'TOP_ROUND',
        objectNameWavy: 'TOP_ROUND',
        objectNameDupont: 'TOP_ROUND_OGEE',
        thumbnailUrl: '/images/shapes/elliptical-oval.png',
        sizing: {
          width: {
            min: 30,
            max: 60,
            default: 42,
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            min: 40,
            max: 180,
            default: 84,
            scaleZero: 32,
            scaleOne: 120,
          },
          thickness: {
            thicknessTypes: ['Standard', 'Thick'],
            scaleZero: 0.5,
            scaleOne: 2.5,
          },
          distance: {
            scaleDelta: 20,
          },
        },
        pricing: {
          basePrice: 6195,
          compoundingRate: 0.05,
          pricingStep: 6,
        },
        fatals: {
          edgeStyleAvailableForThisTop: {
            allowedValues: ['Clean', 'Tumbled', 'Dupont'],
          },
        },
        warnings: {
          lengthMightNotBeAvailableForThisTop: {
            minValue: 144,
          },
          thicknessTypeMightNotBeAvailableForThisTop: {
            value: 'Thick',
          },
        },
        notices: {
          widthMaybeTooBigForDoor: {
            minValue: 78,
          },
        },
      },
      RacetrackOvalTop: {
        type: 'RacetrackOvalTop',
        label: 'Racetrack Oval',
        description: 'Racetrack Oval tabletop',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_HALF_CIRCLE',
        objectNameCornerRadius: 'TOP_HALF_CIRCLE',
        objectNameWavy: 'TOP_HALF_CIRCLE',
        objectNameDupont: 'TOP_HALF_CIRCLE_OGEE',
        thumbnailUrl: '/images/shapes/racetrack-oval.png',
        sizing: {
          width: {
            min: 30,
            max: 60,
            default: 42,
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            min: 40,
            max: 180,
            default: 84,
            scaleZero: 64,
            scaleOne: 120,
          },
          thickness: {
            thicknessTypes: ['Standard', 'Thick'],
            scaleZero: 0.5,
            scaleOne: 2.5,
          },
          endRadius: 16,
          distance: {
            scaleDelta: 20,
          },
        },
        pricing: {
          basePrice: 6195,
          compoundingRate: 0.05,
          pricingStep: 6,
        },
        fatals: {
          edgeStyleAvailableForThisTop: {
            allowedValues: ['Clean', 'Tumbled', 'Dupont'],
          },
        },
        warnings: {
          lengthMightNotBeAvailableForThisTop: {
            minValue: 144,
          },
          thicknessTypeMightNotBeAvailableForThisTop: {
            value: 'Thick',
          },
        },
        notices: {
          widthMaybeTooBigForDoor: {
            minValue: 78,
          },
        },
      },
      BoatShapeTop: {
        type: 'BoatShapeTop',
        label: 'Boat Shape',
        description: 'Boat Shape tabletop',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_BOAT',
        objectNameCornerRadius: 'TOP_BOAT',
        objectNameWavy: 'TOP_BOAT',
        objectNameDupont: 'TOP_BOAT_OGEE',
        thumbnailUrl: '/images/shapes/boat-shape.png',
        sizing: {
          width: {
            min: 30,
            max: 60,
            default: 42,
            scaleZero: 32,
            scaleOne: 52,
          },
          length: {
            min: 40,
            max: 180,
            default: 84,
            scaleZero: 64,
            scaleOne: 120,
          },
          thickness: {
            thicknessTypes: ['Standard', 'Thick'],
            scaleZero: 0.5,
            scaleOne: 2.5,
          },
          distance: {
            scaleDelta: 20,
          },
        },
        pricing: {
          basePrice: 6195,
          compoundingRate: 0.05,
          pricingStep: 6,
        },
        fatals: {
          edgeStyleAvailableForThisTop: {
            allowedValues: ['Clean', 'Tumbled', 'Dupont'],
          },
        },
        warnings: {
          lengthMightNotBeAvailableForThisTop: {
            minValue: 144,
          },
          thicknessTypeMightNotBeAvailableForThisTop: {
            value: 'Thick',
          },
        },
        notices: {
          widthMaybeTooBigForDoor: {
            minValue: 78,
          },
        },
      },
    },
    $leafDataMap: {
      NoLeaf: {
        type: 'NoLeaf',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameDupont: 'LEAVE_OGEE',
        objectNameWavy: 'LEAVE_WAVY_EDGE',
        importDimensionUnit: 'inch',
        label: 'No Leaf',
        length: 0,
        minTopLength: null,
        pricing: {
          price: 0,
        },
        purchasableAmounts: [0],
      },
      Standard: {
        type: 'Standard',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameDupont: 'LEAVE_OGEE',
        objectNameWavy: 'LEAVE_WAVY_EDGE',
        importDimensionUnit: 'inch',
        label: 'Standard Leaf',
        length: 12,
        minTopLength: null,
        pricing: {
          price: 753,
        },
        purchasableAmounts: [1, 2],
      },
      Medium: {
        type: 'Medium',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameDupont: 'LEAVE_OGEE',
        objectNameWavy: 'LEAVE_WAVY_EDGE',
        importDimensionUnit: 'inch',
        label: 'Medium Leaf',
        length: 18,
        minTopLength: null,
        pricing: {
          price: 823,
        },
        purchasableAmounts: [1, 2],
      },
      Large: {
        type: 'Large',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameDupont: 'LEAVE_OGEE',
        objectNameWavy: 'LEAVE_WAVY_EDGE',
        importDimensionUnit: 'inch',
        label: 'Large Leaf',
        length: 24,
        minTopLength: null,
        pricing: {
          price: 894,
        },
        purchasableAmounts: [1, 2],
      },
      Perimeter: {
        type: 'Perimeter',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'LEAVE_PEREMITER',
        importDimensionUnit: 'inch',
        label: 'Perimeter Leaf',
        length: 12,
        minTopLength: 42,
        sizing: {
          innerDiameter: {
            scaleZero: 32,
            scaleOne: 42,
          },
          outerDiameter: {
            scaleZero: 64,
            scaleOne: 120,
          },
          thickness: {
            scaleZero: 0.5,
            scaleOne: 2.5,
          },
        },
        pricing: {
          price: 1880,
        },
        purchasableAmounts: [1],
      },
      StandardDropIn: {
        type: 'StandardDropIn',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameDupont: 'LEAVE_OGEE',
        objectNameWavy: 'LEAVE_WAVY_EDGE',
        importDimensionUnit: 'inch',
        label: 'Standard Drop-In Leaf',
        length: 12,
        minTopLength: 42,
        pricing: {
          price: 1003,
        },
        purchasableAmounts: [1, 2],
      },
      MediumDropIn: {
        type: 'MediumDropIn',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameDupont: 'LEAVE_OGEE',
        objectNameWavy: 'LEAVE_WAVY_EDGE',
        importDimensionUnit: 'inch',
        label: 'Medium Drop-In Leaf',
        length: 18,
        minTopLength: 42,
        pricing: {
          price: 1073,
        },
        purchasableAmounts: [1, 2],
      },
      LargeDropIn: {
        type: 'LargeDropIn',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameDupont: 'LEAVE_OGEE',
        objectNameWavy: 'LEAVE_WAVY_EDGE',
        importDimensionUnit: 'inch',
        label: 'Large Drop-In Leaf',
        length: 24,
        minTopLength: 42,
        pricing: {
          price: 1144,
        },
        purchasableAmounts: [1, 2],
      },
      CustomLeaf: {
        type: 'CustomLeaf',
        fileUrl: '/models/element-furniture.glb',
        objectName: 'TOP_RECTANGLE',
        objectNameDupont: 'LEAVE_OGEE',
        objectNameWavy: 'LEAVE_WAVY_EDGE',
        importDimensionUnit: 'inch',
        label: 'Custom Leaf',
        length: 0,
        minTopLength: null,
        pricing: {
          price: 0,
        },
        purchasableAmounts: [1, 2],
      },
    },
    $modelDataMap: {
      WavyLeaf: {
        width: {
          scaleZero: 32,
          scaleOne: 52,
        },
        length: {
          scaleZero: 10,
          scaleOne: 20,
        },
        thickness: {
          scaleZero: 0.5,
          scaleOne: 2.5,
        },
      },
      DupontLeaf: {
        width: {
          scaleZero: 32,
          scaleOne: 52,
        },
        length: {
          scaleZero: 10,
          scaleOne: 20,
        },
        thickness: {
          scaleZero: 1.75,
          scaleOne: 2.75,
        },
      },
      DupontTop: {
        thickness: {
          scaleZero: 1.75,
          scaleOne: 2.75,
        },
      },
    },
  },
} as const

interface ApronBasicExpressions {
  readonly $repeatX: number & SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $repeatY: number & SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $materialRoughness: number & SceneEntityObjectRemoteMaterialOverrideComponentState['roughness']
  readonly $materialMetalness: number & SceneEntityObjectRemoteMaterialOverrideComponentState['metalness']
  readonly $materialEnvMapIntensity: number & SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $materialSpecularIntensity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $materialNormalScale: number & SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale']
  readonly $materialReflectivity: number & SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity']
  readonly $beveledEdgeConsideration: number
  readonly $apronFilter: ComponentSystemFilterProps['active']
  readonly $fileUrl: SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl']
  readonly $objectName: SceneEntityRemoteObjectComponentState['objectName']
  readonly $offsetY: SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $length: MorphTargetInfluence['value']
  readonly $lengthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $lengthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $width: MorphTargetInfluence['value']
  readonly $widthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $widthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $thickness: MorphTargetInfluence['value']
  readonly $thicknessScaleZero: MorphTargetInfluence['scaleZero']
  readonly $thicknessScaleOne: MorphTargetInfluence['scaleOne']
  readonly $stretch: MorphTargetInfluence['value']
  readonly $stretchScaleZero: MorphTargetInfluence['scaleZero']
  readonly $stretchScaleOne: MorphTargetInfluence['scaleOne']
  readonly $finishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color']
  readonly $textureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl']
  readonly $normalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $roughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $aoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $apronThickness: typeof constants.ApronBasic.$apronThickness
  readonly $insetFromEdge: typeof constants.ApronBasic.$insetFromEdge
  readonly $apronThicknessWithFourLegs: typeof constants.ApronBasic.$apronThicknessWithFourLegs
  readonly $insetFromEdgeWithFourLegs: typeof constants.ApronBasic.$insetFromEdgeWithFourLegs
  readonly $apronDataMap: typeof constants.ApronBasic.$apronDataMap
}
const ApronBasicExpressions = [
  '$repeatX',
  '$repeatY',
  '$materialRoughness',
  '$materialMetalness',
  '$materialEnvMapIntensity',
  '$materialSpecularIntensity',
  '$materialNormalScale',
  '$materialReflectivity',
  '$beveledEdgeConsideration',
  '$apronFilter',
  '$fileUrl',
  '$objectName',
  '$offsetY',
  '$length',
  '$lengthScaleZero',
  '$lengthScaleOne',
  '$width',
  '$widthScaleZero',
  '$widthScaleOne',
  '$thickness',
  '$thicknessScaleZero',
  '$thicknessScaleOne',
  '$stretch',
  '$stretchScaleZero',
  '$stretchScaleOne',
  '$finishColor',
  '$textureUrl',
  '$normalMapUrl',
  '$roughnessMapUrl',
  '$aoMapUrl',
  '$apronThickness',
  '$insetFromEdge',
  '$apronThicknessWithFourLegs',
  '$insetFromEdgeWithFourLegs',
  '$apronDataMap',
]

interface BaseDoubleLegExpressions {
  readonly $feetThickness: number
  readonly $baseThickness: number
  readonly $singleLegAlternative: string
  readonly $baseWidthMultiplier: number
  readonly $width: number
  readonly $centerWidth: number
  readonly $activeScaleIncrement: number
  readonly $crossbraceType: CrossbraceTypes
  readonly $visibleCenter: boolean & ComponentSystemFilterProps['active']
  readonly $needTwoCrossbraces: boolean & ComponentSystemFilterProps['active']
  readonly $fileUrl: SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['fileUrl']
  readonly $objectName: SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName']
  readonly $centerObjectName: SceneEntityRemoteObjectComponentState['objectName']
  readonly $crossbraceObjectName: SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName']
  readonly $offsetZLeft: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $widthShapekeyValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $widthScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $widthScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $scaleShapekeyValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $scaleScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $scaleScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $offsetZRight: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $centerWidthShapekeyValue: MorphTargetInfluence['value']
  readonly $centerWidthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $centerWidthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $centerScaleShapekeyValue: MorphTargetInfluence['value']
  readonly $centerScaleScaleZero: MorphTargetInfluence['scaleZero']
  readonly $centerScaleScaleOne: MorphTargetInfluence['scaleOne']
  readonly $crossbraceOffsetY: SceneEntityObjectPropertiesComponentState['offsetY'] &
    SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $crossbraceOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $crossbraceWidthShapekeyValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $crossbraceWidthScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $crossbraceWidthScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $crossbraceLengthShapekeyValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $crossbraceLengthScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $crossbraceLengthScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $crossbraceHeightShapekeyValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $crossbraceHeightScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $crossbraceHeightScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $crossbraceScaleShapekeyValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $crossbraceScaleScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $crossbraceScaleScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $crossbraceSecondaryOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $finishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color']
  readonly $textureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl']
  readonly $normalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $roughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $aoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $materialRoughness: SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness']
  readonly $materialMetalness: SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness']
  readonly $materialEnvMapIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $materialSpecularIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $materialNormalScale: SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale']
  readonly $materialReflectivity: SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity']
  readonly $repeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $repeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $crossbraceFinishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityRemoteMaterialOverrideComponentState['color']
  readonly $crossbraceTextureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['textureUrl']
  readonly $crossbraceNormalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $crossbraceRoughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $crossbraceAoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $crossbraceRoughness: SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityRemoteMaterialOverrideComponentState['roughness']
  readonly $crossbraceMetalness: SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityRemoteMaterialOverrideComponentState['metalness']
  readonly $crossbraceEnvMapIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $crossbraceSpecularIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $crossbraceNormalScale: SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityRemoteMaterialOverrideComponentState['normalScale']
  readonly $crossbraceReflectivity: SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityRemoteMaterialOverrideComponentState['reflectivity']
  readonly $crossbraceRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $crossbraceRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $feetThicknessIndicatorFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $feetThicknessIndicatorStartZ: DimensionIndicatorComponentState['startZ']
  readonly $feetThicknessIndicatorEndZ: DimensionIndicatorComponentState['endZ']
  readonly $baseThicknessIndicatorVisible: ComponentSystemFilterProps['active']
  readonly $baseThicknessIndicatorFixedY: DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY']
  readonly $baseThicknessIndicatorStartZ: DimensionIndicatorComponentState['startZ']
  readonly $baseThicknessIndicatorEndZ: DimensionIndicatorComponentState['endZ']
  readonly $baseThicknessIndicatorExtrusionX: DimensionIndicatorComponentState['extrusionX']
  readonly $scaleLowerBreakpoint: typeof constants.BaseDoubleLeg.$scaleLowerBreakpoint
  readonly $scaleUpperBreakpoint: typeof constants.BaseDoubleLeg.$scaleUpperBreakpoint
  readonly $defaultCrossbraceObjectName: typeof constants.BaseDoubleLeg.$defaultCrossbraceObjectName
  readonly $crossbraceDataMap: typeof constants.BaseDoubleLeg.$crossbraceDataMap
}
const BaseDoubleLegExpressions = [
  '$feetThickness',
  '$baseThickness',
  '$singleLegAlternative',
  '$baseWidthMultiplier',
  '$width',
  '$centerWidth',
  '$activeScaleIncrement',
  '$crossbraceType',
  '$visibleCenter',
  '$needTwoCrossbraces',
  '$fileUrl',
  '$objectName',
  '$centerObjectName',
  '$crossbraceObjectName',
  '$offsetZLeft',
  '$widthShapekeyValue',
  '$widthScaleZero',
  '$widthScaleOne',
  '$scaleShapekeyValue',
  '$scaleScaleZero',
  '$scaleScaleOne',
  '$offsetZRight',
  '$centerWidthShapekeyValue',
  '$centerWidthScaleZero',
  '$centerWidthScaleOne',
  '$centerScaleShapekeyValue',
  '$centerScaleScaleZero',
  '$centerScaleScaleOne',
  '$crossbraceOffsetY',
  '$crossbraceOffsetZ',
  '$crossbraceWidthShapekeyValue',
  '$crossbraceWidthScaleZero',
  '$crossbraceWidthScaleOne',
  '$crossbraceLengthShapekeyValue',
  '$crossbraceLengthScaleZero',
  '$crossbraceLengthScaleOne',
  '$crossbraceHeightShapekeyValue',
  '$crossbraceHeightScaleZero',
  '$crossbraceHeightScaleOne',
  '$crossbraceScaleShapekeyValue',
  '$crossbraceScaleScaleZero',
  '$crossbraceScaleScaleOne',
  '$crossbraceSecondaryOffsetZ',
  '$finishColor',
  '$textureUrl',
  '$normalMapUrl',
  '$roughnessMapUrl',
  '$aoMapUrl',
  '$materialRoughness',
  '$materialMetalness',
  '$materialEnvMapIntensity',
  '$materialSpecularIntensity',
  '$materialNormalScale',
  '$materialReflectivity',
  '$repeatX',
  '$repeatY',
  '$crossbraceFinishColor',
  '$crossbraceTextureUrl',
  '$crossbraceNormalMapUrl',
  '$crossbraceRoughnessMapUrl',
  '$crossbraceAoMapUrl',
  '$crossbraceRoughness',
  '$crossbraceMetalness',
  '$crossbraceEnvMapIntensity',
  '$crossbraceSpecularIntensity',
  '$crossbraceNormalScale',
  '$crossbraceReflectivity',
  '$crossbraceRepeatX',
  '$crossbraceRepeatY',
  '$feetThicknessIndicatorFixedX',
  '$feetThicknessIndicatorStartZ',
  '$feetThicknessIndicatorEndZ',
  '$baseThicknessIndicatorVisible',
  '$baseThicknessIndicatorFixedY',
  '$baseThicknessIndicatorStartZ',
  '$baseThicknessIndicatorEndZ',
  '$baseThicknessIndicatorExtrusionX',
  '$scaleLowerBreakpoint',
  '$scaleUpperBreakpoint',
  '$defaultCrossbraceObjectName',
  '$crossbraceDataMap',
]

interface BaseFourLegExpressions {
  readonly $beveledEdgeConsideration: number
  readonly $widthIndicatorFixedY: typeof constants.BaseFourLeg.$widthIndicatorFixedY
  readonly $widthIndicatorFixedZ: typeof constants.BaseFourLeg.$widthIndicatorFixedZ
  readonly $widthIndicatorExtrusionZ: typeof constants.BaseFourLeg.$widthIndicatorExtrusionZ
}
const BaseFourLegExpressions = [
  '$beveledEdgeConsideration',
  '$widthIndicatorFixedY',
  '$widthIndicatorFixedZ',
  '$widthIndicatorExtrusionZ',
]

interface BaseFourLegSeparateExpressions {
  readonly $width: number
  readonly $length: number
  readonly $legWidth: number
  readonly $dropInLeafAdditionalOffset: number
  readonly $fileUrl: SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl']
  readonly $objectName: SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName']
  readonly $offsetXTopLeft: SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $offsetZTopLeft: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $height: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $heightScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero']
  readonly $heightScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne']
  readonly $offsetXBottomLeft: SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $offsetZBottomLeft: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $offsetXTopRight: SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $offsetZTopRight: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $offsetXBottomRight: SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $offsetZBottomRight: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $finishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color']
  readonly $textureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl']
  readonly $normalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $roughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $aoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $materialRoughness: SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness']
  readonly $materialMetalness: SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness']
  readonly $materialEnvMapIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $materialSpecularIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $materialNormalScale: SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale']
  readonly $materialReflectivity: SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity']
  readonly $separateLegRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $separateLegRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
}
const BaseFourLegSeparateExpressions = [
  '$width',
  '$length',
  '$legWidth',
  '$dropInLeafAdditionalOffset',
  '$fileUrl',
  '$objectName',
  '$offsetXTopLeft',
  '$offsetZTopLeft',
  '$height',
  '$heightScaleZero',
  '$heightScaleOne',
  '$offsetXBottomLeft',
  '$offsetZBottomLeft',
  '$offsetXTopRight',
  '$offsetZTopRight',
  '$offsetXBottomRight',
  '$offsetZBottomRight',
  '$finishColor',
  '$textureUrl',
  '$normalMapUrl',
  '$roughnessMapUrl',
  '$aoMapUrl',
  '$materialRoughness',
  '$materialMetalness',
  '$materialEnvMapIntensity',
  '$materialSpecularIntensity',
  '$materialNormalScale',
  '$materialReflectivity',
  '$separateLegRepeatX',
  '$separateLegRepeatY',
]

interface BaseSingleLegExpressions {
  readonly $baseWidthMultiplier: number
  readonly $baseLengthMultiplier: number
  readonly $activeScaleIncrement: number
  readonly $width: number
  readonly $length: number
  readonly $feetThickness: number
  readonly $baseThickness: number
  readonly $fileUrl: SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl']
  readonly $objectName: SceneEntityRemoteObjectComponentState['objectName']
  readonly $platformFilter: ComponentSystemFilterProps['active']
  readonly $platformObjectName: SceneEntityRemoteObjectComponentState['objectName']
  readonly $offsetY: SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $widthShapekeyValue: MorphTargetInfluence['value']
  readonly $widthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $widthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $lengthShapekeyValue: MorphTargetInfluence['value']
  readonly $lengthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $lengthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $scaleShapekeyValue: MorphTargetInfluence['value']
  readonly $scaleScaleZero: MorphTargetInfluence['scaleZero']
  readonly $scaleScaleOne: MorphTargetInfluence['scaleOne']
  readonly $platformWidth: MorphTargetInfluence['value']
  readonly $platformWidthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $platformWidthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $platformLength: MorphTargetInfluence['value']
  readonly $platformLengthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $platformLengthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $finishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color']
  readonly $textureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl']
  readonly $normalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $roughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $aoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $materialRoughness: SceneEntityObjectRemoteMaterialOverrideComponentState['roughness']
  readonly $materialMetalness: SceneEntityObjectRemoteMaterialOverrideComponentState['metalness']
  readonly $materialEnvMapIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $materialSpecularIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $materialNormalScale: SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale']
  readonly $materialReflectivity: SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity']
  readonly $platformRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $platformRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $feetThicknessIndicatorVisible: ComponentSystemFilterProps['active']
  readonly $feetThicknessIndicatorFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $feetThicknessIndicatorStartZ: DimensionIndicatorComponentState['startZ']
  readonly $feetThicknessIndicatorEndZ: DimensionIndicatorComponentState['endZ']
  readonly $baseThicknessIndicatorVisible: ComponentSystemFilterProps['active']
  readonly $baseThicknessIndicatorFixedY: DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY']
  readonly $baseThicknessIndicatorStartZ: DimensionIndicatorComponentState['startZ']
  readonly $baseThicknessIndicatorEndZ: DimensionIndicatorComponentState['endZ']
  readonly $baseThicknessIndicatorExtrusionX: DimensionIndicatorComponentState['extrusionX']
  readonly $platformWidthIndicatorVisible: ComponentSystemFilterProps['active']
  readonly $platformWidthIndicatorStartX: DimensionIndicatorComponentState['startX']
  readonly $platformWidthIndicatorEndX: DimensionIndicatorComponentState['endX']
  readonly $platformWidthIndicatorExtrusionZ: DimensionIndicatorComponentState['extrusionZ']
  readonly $platformLengthIndicatorVisible: ComponentSystemFilterProps['active']
  readonly $platformLengthIndicatorStartZ: DimensionIndicatorComponentState['startZ']
  readonly $platformLengthIndicatorEndZ: DimensionIndicatorComponentState['endZ']
  readonly $platformLengthIndicatorExtrusionX: DimensionIndicatorComponentState['extrusionX']
  readonly $platformHeight: typeof constants.BaseSingleLeg.$platformHeight
  readonly $platformToTopRatio: typeof constants.BaseSingleLeg.$platformToTopRatio
  readonly $scaleLowerBreakpoint: typeof constants.BaseSingleLeg.$scaleLowerBreakpoint
  readonly $scaleUpperBreakpoint: typeof constants.BaseSingleLeg.$scaleUpperBreakpoint
  readonly $defaultTopWidthForSingleLeg: typeof constants.BaseSingleLeg.$defaultTopWidthForSingleLeg
  readonly $defaultTopLengthForSingleLeg: typeof constants.BaseSingleLeg.$defaultTopLengthForSingleLeg
  readonly $platformDataMap: typeof constants.BaseSingleLeg.$platformDataMap
}
const BaseSingleLegExpressions = [
  '$baseWidthMultiplier',
  '$baseLengthMultiplier',
  '$activeScaleIncrement',
  '$width',
  '$length',
  '$feetThickness',
  '$baseThickness',
  '$fileUrl',
  '$objectName',
  '$platformFilter',
  '$platformObjectName',
  '$offsetY',
  '$widthShapekeyValue',
  '$widthScaleZero',
  '$widthScaleOne',
  '$lengthShapekeyValue',
  '$lengthScaleZero',
  '$lengthScaleOne',
  '$scaleShapekeyValue',
  '$scaleScaleZero',
  '$scaleScaleOne',
  '$platformWidth',
  '$platformWidthScaleZero',
  '$platformWidthScaleOne',
  '$platformLength',
  '$platformLengthScaleZero',
  '$platformLengthScaleOne',
  '$finishColor',
  '$textureUrl',
  '$normalMapUrl',
  '$roughnessMapUrl',
  '$aoMapUrl',
  '$materialRoughness',
  '$materialMetalness',
  '$materialEnvMapIntensity',
  '$materialSpecularIntensity',
  '$materialNormalScale',
  '$materialReflectivity',
  '$platformRepeatX',
  '$platformRepeatY',
  '$feetThicknessIndicatorVisible',
  '$feetThicknessIndicatorFixedX',
  '$feetThicknessIndicatorStartZ',
  '$feetThicknessIndicatorEndZ',
  '$baseThicknessIndicatorVisible',
  '$baseThicknessIndicatorFixedY',
  '$baseThicknessIndicatorStartZ',
  '$baseThicknessIndicatorEndZ',
  '$baseThicknessIndicatorExtrusionX',
  '$platformWidthIndicatorVisible',
  '$platformWidthIndicatorStartX',
  '$platformWidthIndicatorEndX',
  '$platformWidthIndicatorExtrusionZ',
  '$platformLengthIndicatorVisible',
  '$platformLengthIndicatorStartZ',
  '$platformLengthIndicatorEndZ',
  '$platformLengthIndicatorExtrusionX',
  '$platformHeight',
  '$platformToTopRatio',
  '$scaleLowerBreakpoint',
  '$scaleUpperBreakpoint',
  '$defaultTopWidthForSingleLeg',
  '$defaultTopLengthForSingleLeg',
  '$platformDataMap',
]

interface BaseExpressions {
  readonly $fileUrl: string & SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl']
  readonly $objectName: string
  readonly $height: number
  readonly $price: number
  readonly $supportsCrossBrace: boolean
  readonly $customProductBaseDescription: string
  readonly $repeatX: number & SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $repeatY: number & SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $materialRoughness: number & SceneEntityObjectRemoteMaterialOverrideComponentState['roughness']
  readonly $materialMetalness: number & SceneEntityObjectRemoteMaterialOverrideComponentState['metalness']
  readonly $materialEnvMapIntensity: number & SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $materialSpecularIntensity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $materialNormalScale: number & SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale']
  readonly $materialReflectivity: number & SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity']
  readonly $widthIndicatorVisible: ComponentSystemFilterProps['active']
  readonly $widthIndicatorStartX: DimensionIndicatorComponentState['startX']
  readonly $widthIndicatorFixedY: DimensionIndicatorComponentState['startY'] & DimensionIndicatorComponentState['endY']
  readonly $widthIndicatorFixedZ: DimensionIndicatorComponentState['startZ'] & DimensionIndicatorComponentState['endZ']
  readonly $widthIndicatorEndX: DimensionIndicatorComponentState['endX']
  readonly $widthIndicatorExtrusionZ: DimensionIndicatorComponentState['extrusionZ']
  readonly $finishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color']
  readonly $textureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl']
  readonly $normalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $roughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $aoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $table: $Table
  readonly $topWidthLowerLimitForBaseWidth: typeof constants.Base.$topWidthLowerLimitForBaseWidth
  readonly $metalRepeatRatio: typeof constants.Base.$metalRepeatRatio
  readonly $defaultHeight: typeof constants.Base.$defaultHeight
  readonly $defaultHeightWithPlatform: typeof constants.Base.$defaultHeightWithPlatform
  readonly $breakpointScaleIncrement: typeof constants.Base.$breakpointScaleIncrement
  readonly $baseDataMap: typeof constants.Base.$baseDataMap
}
const BaseExpressions = [
  '$fileUrl',
  '$objectName',
  '$height',
  '$price',
  '$supportsCrossBrace',
  '$customProductBaseDescription',
  '$repeatX',
  '$repeatY',
  '$materialRoughness',
  '$materialMetalness',
  '$materialEnvMapIntensity',
  '$materialSpecularIntensity',
  '$materialNormalScale',
  '$materialReflectivity',
  '$widthIndicatorVisible',
  '$widthIndicatorStartX',
  '$widthIndicatorFixedY',
  '$widthIndicatorFixedZ',
  '$widthIndicatorEndX',
  '$widthIndicatorExtrusionZ',
  '$finishColor',
  '$textureUrl',
  '$normalMapUrl',
  '$roughnessMapUrl',
  '$aoMapUrl',
  '$table',
  '$topWidthLowerLimitForBaseWidth',
  '$metalRepeatRatio',
  '$defaultHeight',
  '$defaultHeightWithPlatform',
  '$breakpointScaleIncrement',
  '$baseDataMap',
]

interface BenchBasicExpressions {
  readonly $benchLegScale: number
  readonly $benchCenterLegScale: number
  readonly $benchBaseHeight: number
  readonly $isFourLegSeparateBase: boolean
  readonly $isFourLegCombinedBase: boolean
  readonly $isReflectionBase: boolean
  readonly $woodMaterialRoughness: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityRemoteMaterialOverrideComponentState['roughness']
  readonly $woodMaterialMetalness: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityRemoteMaterialOverrideComponentState['metalness']
  readonly $woodMaterialEnvMapIntensity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $woodMaterialSpecularIntensity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $woodMaterialNormalScale: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale']
  readonly $woodMaterialReflectivity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityRemoteMaterialOverrideComponentState['reflectivity']
  readonly $baseMaterialRoughness: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness']
  readonly $baseMaterialMetalness: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness']
  readonly $baseMaterialEnvMapIntensity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $baseMaterialSpecularIntensity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $baseMaterialNormalScale: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale']
  readonly $baseMaterialReflectivity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity']
  readonly $benchCrossbraceType: CrossbraceTypes
  readonly $benchNeedTwoCrossbraces: boolean
  readonly $benchLegScaleY: number &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY']
  readonly $benchNearVisible: ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active']
  readonly $fileUrl: SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['fileUrl']
  readonly $benchTopObjectName: SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName']
  readonly $benchNearApronVisible: ComponentSystemFilterProps['active']
  readonly $benchNearDoubleLegVisible: ComponentSystemFilterProps['active'] & ComponentSystemFilterProps['active']
  readonly $benchBaseObjectName: SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName']
  readonly $benchNearCenterLegVisible: ComponentSystemFilterProps['active']
  readonly $benchCenterBaseObjectName: SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName']
  readonly $benchFarVisible: ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active']
  readonly $benchFarApronVisible: ComponentSystemFilterProps['active']
  readonly $benchFarDoubleLegVisible: ComponentSystemFilterProps['active'] & ComponentSystemFilterProps['active']
  readonly $benchFarCenterLegVisible: ComponentSystemFilterProps['active']
  readonly $benchNearFourLegVisible: ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active']
  readonly $benchFourLegObjectName: SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName']
  readonly $benchFarFourLegVisible: ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active'] &
    ComponentSystemFilterProps['active']
  readonly $benchNearFourLegCombinedVisible: ComponentSystemFilterProps['active']
  readonly $benchFarFourLegCombinedVisible: ComponentSystemFilterProps['active']
  readonly $benchNearReflectionVisible: ComponentSystemFilterProps['active']
  readonly $benchFarReflectionVisible: ComponentSystemFilterProps['active']
  readonly $benchNearCrossbraceVisible: ComponentSystemFilterProps['active']
  readonly $benchCrossbraceObjectName: SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName']
  readonly $benchNearCrossbraceSecondaryVisible: ComponentSystemFilterProps['active']
  readonly $benchFarCrossbraceVisible: ComponentSystemFilterProps['active']
  readonly $benchFarCrossbraceSecondaryVisible: ComponentSystemFilterProps['active']
  readonly $benchNearOffsetX: SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $benchTopOffsetY: SceneEntityObjectPropertiesComponentState['offsetY'] &
    SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $benchTopWidthValue: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $benchLength: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $benchTopThicknessValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $benchBevelThickness: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $bevelScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    typeof constants.BenchBasic.$bevelScaleZero
  readonly $bevelScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    typeof constants.BenchBasic.$bevelScaleOne
  readonly $benchApronOffsetY: SceneEntityObjectPropertiesComponentState['offsetY'] &
    SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $benchApronWidth: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $benchApronLength: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $benchApronThicknessValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $benchLegLeftOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $benchLegScaleX: SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX']
  readonly $benchLegScaleZ: SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ']
  readonly $benchBaseFootprintValue: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $benchBaseWidthScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero']
  readonly $benchBaseWidthScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne']
  readonly $benchLegRightOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $benchCenterLegScaleX: SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX']
  readonly $benchCenterLegScaleZ: SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ']
  readonly $benchCenterBaseFootprintValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $benchCenterBaseWidthScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $benchCenterBaseWidthScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $benchFarOffsetX: SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $benchCenterLegVisible: ComponentSystemFilterProps['active']
  readonly $benchNearFourLegOuterOffsetX: SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $benchFourLegLeftOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $benchFourLegScaleX: SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX']
  readonly $benchFourLegScaleY: SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY']
  readonly $benchFourLegScaleZ: SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ']
  readonly $benchFourLegRightOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $benchNearFourLegInnerOffsetX: SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $benchFarFourLegOuterOffsetX: SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $benchFarFourLegInnerOffsetX: SceneEntityObjectPropertiesComponentState['offsetX'] &
    SceneEntityObjectPropertiesComponentState['offsetX']
  readonly $benchFourLegCombinedWidthScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $benchFourLegCombinedWidthScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $benchFourLegCombinedLengthScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $benchFourLegCombinedLengthScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $benchReflectionScaleX: SceneEntityObjectPropertiesComponentState['scaleX'] &
    SceneEntityObjectPropertiesComponentState['scaleX']
  readonly $benchReflectionScaleY: SceneEntityObjectPropertiesComponentState['scaleY'] &
    SceneEntityObjectPropertiesComponentState['scaleY']
  readonly $benchReflectionScaleZ: SceneEntityObjectPropertiesComponentState['scaleZ'] &
    SceneEntityObjectPropertiesComponentState['scaleZ']
  readonly $benchReflectionLength: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $benchReflectionLengthScaleZero: MorphTargetInfluence['scaleZero'] & MorphTargetInfluence['scaleZero']
  readonly $benchReflectionLengthScaleOne: MorphTargetInfluence['scaleOne'] & MorphTargetInfluence['scaleOne']
  readonly $benchCrossbraceOffsetY: SceneEntityObjectPropertiesComponentState['offsetY'] &
    SceneEntityObjectPropertiesComponentState['offsetY'] &
    SceneEntityObjectPropertiesComponentState['offsetY'] &
    SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $benchCrossbraceOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $benchCrossbraceWidthShapekeyValue: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $benchCrossbraceWidthScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero']
  readonly $benchCrossbraceWidthScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne']
  readonly $benchCrossbraceLengthShapekeyValue: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $benchCrossbraceLengthScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero']
  readonly $benchCrossbraceLengthScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne']
  readonly $benchCrossbraceHeightShapekeyValue: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $benchCrossbraceHeightScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero']
  readonly $benchCrossbraceHeightScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne']
  readonly $benchCrossbraceScaleShapekeyValue: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $benchCrossbraceScaleScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero']
  readonly $benchCrossbraceScaleScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne']
  readonly $benchCrossbraceSecondaryOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ'] &
    SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $topFinishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityRemoteMaterialOverrideComponentState['color']
  readonly $textureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['textureUrl']
  readonly $normalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $roughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $aoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $benchTopRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $benchTopRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $benchApronFinishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color']
  readonly $benchApronRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $benchApronRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $baseFinishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color']
  readonly $baseTextureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl']
  readonly $baseNormalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $baseRoughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $baseAoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $benchBaseRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $benchBaseRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $benchFourLegRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $benchFourLegRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $benchCrossbraceFinishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityRemoteMaterialOverrideComponentState['color']
  readonly $benchCrossbraceTextureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['textureUrl']
  readonly $benchCrossbraceNormalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $benchCrossbraceRoughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $benchCrossbraceAoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $benchCrossbraceRoughness: SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityRemoteMaterialOverrideComponentState['roughness']
  readonly $benchCrossbraceMetalness: SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityRemoteMaterialOverrideComponentState['metalness']
  readonly $benchCrossbraceEnvMapIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $benchCrossbraceSpecularIntensity: SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $benchCrossbraceNormalScale: SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityRemoteMaterialOverrideComponentState['normalScale']
  readonly $benchCrossbraceReflectivity: SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityRemoteMaterialOverrideComponentState['reflectivity']
  readonly $benchCrossbraceRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $benchCrossbraceRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $benchEdgeNormalMapUrl: SceneEntityRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $benchEdgeNormalScale: SceneEntityRemoteMaterialOverrideComponentState['normalScale']
  readonly $benchEdgeRepeatX: SceneEntityRemoteMaterialOverrideComponentState['repeatX']
  readonly $benchEdgeRepeatY: SceneEntityRemoteMaterialOverrideComponentState['repeatY']
  readonly $benchNearLengthDimIndFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $benchDimIndFixedY: DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY'] &
    DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY'] &
    DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY'] &
    DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY']
  readonly $benchNearLengthDimIndStartZ: DimensionIndicatorComponentState['startZ']
  readonly $benchNearLengthDimIndEndZ: DimensionIndicatorComponentState['endZ']
  readonly $benchNearWidthDimIndStartX: DimensionIndicatorComponentState['startX']
  readonly $benchNearWidthDimIndFixedZ: DimensionIndicatorComponentState['startZ'] &
    DimensionIndicatorComponentState['endZ']
  readonly $benchNearWidthDimIndEndX: DimensionIndicatorComponentState['endX']
  readonly $benchFarLengthDimIndFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $benchFarLengthDimIndStartZ: DimensionIndicatorComponentState['startZ']
  readonly $benchFarLengthDimIndEndZ: DimensionIndicatorComponentState['endZ']
  readonly $benchFarWidthDimIndStartX: DimensionIndicatorComponentState['startX']
  readonly $benchFarWidthDimIndFixedZ: DimensionIndicatorComponentState['startZ'] &
    DimensionIndicatorComponentState['endZ']
  readonly $benchFarWidthDimIndEndX: DimensionIndicatorComponentState['endX']
  readonly $benchHeight: typeof constants.BenchBasic.$benchHeight
  readonly $benchTopThickness: typeof constants.BenchBasic.$benchTopThickness
  readonly $benchTopWidth: typeof constants.BenchBasic.$benchTopWidth
  readonly $benchBaseFootprint: typeof constants.BenchBasic.$benchBaseFootprint
  readonly $benchInsetFromTable: typeof constants.BenchBasic.$benchInsetFromTable
  readonly $benchApronThickness: typeof constants.BenchBasic.$benchApronThickness
  readonly $benchApronInset: typeof constants.BenchBasic.$benchApronInset
  readonly $benchGap: typeof constants.BenchBasic.$benchGap
  readonly $benchLegInsetDefault: typeof constants.BenchBasic.$benchLegInsetDefault
  readonly $crossbraceDataMap: typeof constants.BenchBasic.$crossbraceDataMap
}
const BenchBasicExpressions = [
  '$benchLegScale',
  '$benchCenterLegScale',
  '$benchBaseHeight',
  '$isFourLegSeparateBase',
  '$isFourLegCombinedBase',
  '$isReflectionBase',
  '$woodMaterialRoughness',
  '$woodMaterialMetalness',
  '$woodMaterialEnvMapIntensity',
  '$woodMaterialSpecularIntensity',
  '$woodMaterialNormalScale',
  '$woodMaterialReflectivity',
  '$baseMaterialRoughness',
  '$baseMaterialMetalness',
  '$baseMaterialEnvMapIntensity',
  '$baseMaterialSpecularIntensity',
  '$baseMaterialNormalScale',
  '$baseMaterialReflectivity',
  '$benchCrossbraceType',
  '$benchNeedTwoCrossbraces',
  '$benchLegScaleY',
  '$benchNearVisible',
  '$fileUrl',
  '$benchTopObjectName',
  '$benchNearApronVisible',
  '$benchNearDoubleLegVisible',
  '$benchBaseObjectName',
  '$benchNearCenterLegVisible',
  '$benchCenterBaseObjectName',
  '$benchFarVisible',
  '$benchFarApronVisible',
  '$benchFarDoubleLegVisible',
  '$benchFarCenterLegVisible',
  '$benchNearFourLegVisible',
  '$benchFourLegObjectName',
  '$benchFarFourLegVisible',
  '$benchNearFourLegCombinedVisible',
  '$benchFarFourLegCombinedVisible',
  '$benchNearReflectionVisible',
  '$benchFarReflectionVisible',
  '$benchNearCrossbraceVisible',
  '$benchCrossbraceObjectName',
  '$benchNearCrossbraceSecondaryVisible',
  '$benchFarCrossbraceVisible',
  '$benchFarCrossbraceSecondaryVisible',
  '$benchNearOffsetX',
  '$benchTopOffsetY',
  '$benchTopWidthValue',
  '$benchLength',
  '$benchTopThicknessValue',
  '$benchBevelThickness',
  '$bevelScaleZero',
  '$bevelScaleOne',
  '$benchApronOffsetY',
  '$benchApronWidth',
  '$benchApronLength',
  '$benchApronThicknessValue',
  '$benchLegLeftOffsetZ',
  '$benchLegScaleX',
  '$benchLegScaleZ',
  '$benchBaseFootprintValue',
  '$benchBaseWidthScaleZero',
  '$benchBaseWidthScaleOne',
  '$benchLegRightOffsetZ',
  '$benchCenterLegScaleX',
  '$benchCenterLegScaleZ',
  '$benchCenterBaseFootprintValue',
  '$benchCenterBaseWidthScaleZero',
  '$benchCenterBaseWidthScaleOne',
  '$benchFarOffsetX',
  '$benchCenterLegVisible',
  '$benchNearFourLegOuterOffsetX',
  '$benchFourLegLeftOffsetZ',
  '$benchFourLegScaleX',
  '$benchFourLegScaleY',
  '$benchFourLegScaleZ',
  '$benchFourLegRightOffsetZ',
  '$benchNearFourLegInnerOffsetX',
  '$benchFarFourLegOuterOffsetX',
  '$benchFarFourLegInnerOffsetX',
  '$benchFourLegCombinedWidthScaleZero',
  '$benchFourLegCombinedWidthScaleOne',
  '$benchFourLegCombinedLengthScaleZero',
  '$benchFourLegCombinedLengthScaleOne',
  '$benchReflectionScaleX',
  '$benchReflectionScaleY',
  '$benchReflectionScaleZ',
  '$benchReflectionLength',
  '$benchReflectionLengthScaleZero',
  '$benchReflectionLengthScaleOne',
  '$benchCrossbraceOffsetY',
  '$benchCrossbraceOffsetZ',
  '$benchCrossbraceWidthShapekeyValue',
  '$benchCrossbraceWidthScaleZero',
  '$benchCrossbraceWidthScaleOne',
  '$benchCrossbraceLengthShapekeyValue',
  '$benchCrossbraceLengthScaleZero',
  '$benchCrossbraceLengthScaleOne',
  '$benchCrossbraceHeightShapekeyValue',
  '$benchCrossbraceHeightScaleZero',
  '$benchCrossbraceHeightScaleOne',
  '$benchCrossbraceScaleShapekeyValue',
  '$benchCrossbraceScaleScaleZero',
  '$benchCrossbraceScaleScaleOne',
  '$benchCrossbraceSecondaryOffsetZ',
  '$topFinishColor',
  '$textureUrl',
  '$normalMapUrl',
  '$roughnessMapUrl',
  '$aoMapUrl',
  '$benchTopRepeatX',
  '$benchTopRepeatY',
  '$benchApronFinishColor',
  '$benchApronRepeatX',
  '$benchApronRepeatY',
  '$baseFinishColor',
  '$baseTextureUrl',
  '$baseNormalMapUrl',
  '$baseRoughnessMapUrl',
  '$baseAoMapUrl',
  '$benchBaseRepeatX',
  '$benchBaseRepeatY',
  '$benchFourLegRepeatX',
  '$benchFourLegRepeatY',
  '$benchCrossbraceFinishColor',
  '$benchCrossbraceTextureUrl',
  '$benchCrossbraceNormalMapUrl',
  '$benchCrossbraceRoughnessMapUrl',
  '$benchCrossbraceAoMapUrl',
  '$benchCrossbraceRoughness',
  '$benchCrossbraceMetalness',
  '$benchCrossbraceEnvMapIntensity',
  '$benchCrossbraceSpecularIntensity',
  '$benchCrossbraceNormalScale',
  '$benchCrossbraceReflectivity',
  '$benchCrossbraceRepeatX',
  '$benchCrossbraceRepeatY',
  '$benchEdgeNormalMapUrl',
  '$benchEdgeNormalScale',
  '$benchEdgeRepeatX',
  '$benchEdgeRepeatY',
  '$benchNearLengthDimIndFixedX',
  '$benchDimIndFixedY',
  '$benchNearLengthDimIndStartZ',
  '$benchNearLengthDimIndEndZ',
  '$benchNearWidthDimIndStartX',
  '$benchNearWidthDimIndFixedZ',
  '$benchNearWidthDimIndEndX',
  '$benchFarLengthDimIndFixedX',
  '$benchFarLengthDimIndStartZ',
  '$benchFarLengthDimIndEndZ',
  '$benchFarWidthDimIndStartX',
  '$benchFarWidthDimIndFixedZ',
  '$benchFarWidthDimIndEndX',
  '$benchHeight',
  '$benchTopThickness',
  '$benchTopWidth',
  '$benchBaseFootprint',
  '$benchInsetFromTable',
  '$benchApronThickness',
  '$benchApronInset',
  '$benchGap',
  '$benchLegInsetDefault',
  '$crossbraceDataMap',
]

interface RootEntityExpressions {
  readonly $customProductTitle: string
  readonly $customProductDescription: string
  readonly $accessoriesDescriptionHTML: string
  readonly $materialAndFinishesDescriptionHTML: string
  readonly $glbFileUrl: typeof constants.RootEntity.$glbFileUrl
  readonly $emailSubject: typeof constants.RootEntity.$emailSubject
  readonly $emailBodyText: typeof constants.RootEntity.$emailBodyText
  readonly $emailFooterNote: typeof constants.RootEntity.$emailFooterNote
  readonly $emailFooterAddress: typeof constants.RootEntity.$emailFooterAddress
  readonly $emailFooterPhone: typeof constants.RootEntity.$emailFooterPhone
  readonly $emailFooterEmail: typeof constants.RootEntity.$emailFooterEmail
  readonly $tableColumns: typeof constants.RootEntity.$tableColumns
}
const RootEntityExpressions = [
  '$customProductTitle',
  '$customProductDescription',
  '$accessoriesDescriptionHTML',
  '$materialAndFinishesDescriptionHTML',
  '$glbFileUrl',
  '$emailSubject',
  '$emailBodyText',
  '$emailFooterNote',
  '$emailFooterAddress',
  '$emailFooterPhone',
  '$emailFooterEmail',
  '$tableColumns',
]

interface TableExpressions {
  readonly $pricingConfig: {
    [k: string]: unknown
  }
  readonly $fullWidth: number
  readonly $fullLength: number
  readonly $woodTextureSize: number
  readonly $apronIsMandatory: boolean
  readonly $thicknessPrice: number
  readonly $edgeStylePrice: number
  readonly $leafPrice: number
  readonly $apronPrice: number
  readonly $seatingPrice: number
  readonly $distressPrice: number
  readonly $topFinishPrice: number
  readonly $baseFinishPrice: number
  readonly $sheenPrice: number
  readonly $groovesPrice: number
  readonly $cornerRadiusPrice: number
  readonly $crossbracePrice: number
  readonly $woodSpeciesRate: number
  readonly $woodPartsTotal: number
  readonly $woodSpeciesPrice: number
  readonly $topSubtotal: number
  readonly $baseSubtotal: number
  readonly $materialsSubtotal: number
  readonly $accessoriesSubtotal: number
  readonly $tableData: {
    readonly item?: string
    readonly description?: string
    readonly price?: number
    [k: string]: unknown
  }[]
  readonly $price: PriceComponentState['price']
  readonly $topOptions: ChildEntitySelectionComponentState['options']
  readonly $baseStyleOptions: ChildEntitySelectionComponentState['options']
  readonly $seatingAmountOptions: AttributeSelectionComponentState['options']
  readonly $top: $Top
  readonly $base: $Base
  readonly $bench: $Bench
  readonly $violations: ReadonlyArray<Violation<'seatingAmountNotAvailableForThisSeatingType'>>
}
const TableExpressions = [
  '$pricingConfig',
  '$fullWidth',
  '$fullLength',
  '$woodTextureSize',
  '$apronIsMandatory',
  '$thicknessPrice',
  '$edgeStylePrice',
  '$leafPrice',
  '$apronPrice',
  '$seatingPrice',
  '$distressPrice',
  '$topFinishPrice',
  '$baseFinishPrice',
  '$sheenPrice',
  '$groovesPrice',
  '$cornerRadiusPrice',
  '$crossbracePrice',
  '$woodSpeciesRate',
  '$woodPartsTotal',
  '$woodSpeciesPrice',
  '$topSubtotal',
  '$baseSubtotal',
  '$materialsSubtotal',
  '$accessoriesSubtotal',
  '$tableData',
  '$price',
  '$topOptions',
  '$baseStyleOptions',
  '$seatingAmountOptions',
  '$top',
  '$base',
  '$bench',
  '$violations',
]

interface TopWithDiameterExpressions {
  readonly $defaultDiameter: number
  readonly $offsetY: SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $thicknessValue: MorphTargetInfluence['value']
  readonly $thicknessScaleZero: MorphTargetInfluence['scaleZero']
  readonly $thicknessScaleOne: MorphTargetInfluence['scaleOne']
  readonly $widthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $widthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $lengthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $lengthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $distance: MorphTargetInfluence['value']
  readonly $distanceScaleZero: MorphTargetInfluence['scaleZero']
  readonly $distanceScaleOne: MorphTargetInfluence['scaleOne']
  readonly $leafBevel: MorphTargetInfluence['value']
  readonly $leafBevelScaleZero: MorphTargetInfluence['scaleZero']
  readonly $leafBevelScaleOne: MorphTargetInfluence['scaleOne']
  readonly $bevelThickness: MorphTargetInfluence['value']
  readonly $bevelScaleZero: MorphTargetInfluence['scaleZero']
  readonly $bevelScaleOne: MorphTargetInfluence['scaleOne']
  readonly $minWidth: DistanceDimensionComponentState['min']
  readonly $maxWidth: DistanceDimensionComponentState['max']
}
const TopWithDiameterExpressions = [
  '$defaultDiameter',
  '$offsetY',
  '$thicknessValue',
  '$thicknessScaleZero',
  '$thicknessScaleOne',
  '$widthScaleZero',
  '$widthScaleOne',
  '$lengthScaleZero',
  '$lengthScaleOne',
  '$distance',
  '$distanceScaleZero',
  '$distanceScaleOne',
  '$leafBevel',
  '$leafBevelScaleZero',
  '$leafBevelScaleOne',
  '$bevelThickness',
  '$bevelScaleZero',
  '$bevelScaleOne',
  '$minWidth',
  '$maxWidth',
]

interface TopExpressions {
  readonly $width: number
  readonly $length: number
  readonly $fileUrl: string &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityRemoteObjectComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['fileUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['fileUrl']
  readonly $objectName: string & SceneEntityRemoteObjectComponentState['objectName']
  readonly $availableThicknessTypes: readonly string[]
  readonly $availableBaseStyles: readonly string[]
  readonly $availableLeafTypes: readonly string[]
  readonly $sizeDescription: string
  readonly $price: number
  readonly $customProductTopDescription: string
  readonly $topDimensionsHTML: {
    readonly label?: string
    readonly value?: string
    [k: string]: unknown
  }[]
  readonly $defaultWidth: number
  readonly $defaultLength: number
  readonly $materialRoughness: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughness'] &
    SceneEntityRemoteMaterialOverrideComponentState['roughness']
  readonly $materialMetalness: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['metalness'] &
    SceneEntityRemoteMaterialOverrideComponentState['metalness']
  readonly $materialEnvMapIntensity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['envMapIntensity'] &
    SceneEntityRemoteMaterialOverrideComponentState['envMapIntensity']
  readonly $materialSpecularIntensity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['specularIntensity'] &
    SceneEntityRemoteMaterialOverrideComponentState['specularIntensity']
  readonly $materialNormalScale: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalScale']
  readonly $materialReflectivity: number &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['reflectivity'] &
    SceneEntityRemoteMaterialOverrideComponentState['reflectivity']
  readonly $withBevel: boolean
  readonly $leafWidth: number
  readonly $leafLength: number
  readonly $leafThickness: number
  readonly $bevelThicknessValue: number
  readonly $apronOptions: ChildEntitySelectionComponentState['options']
  readonly $minThickness: DistanceDimensionComponentState['min']
  readonly $maxThickness: DistanceDimensionComponentState['max']
  readonly $leafLeftVisible: ComponentSystemFilterProps['active'] & ComponentSystemFilterProps['active']
  readonly $leafObjectName: SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName'] &
    SceneEntityRemoteObjectComponentState['objectName']
  readonly $leafRightVisible: ComponentSystemFilterProps['active'] & ComponentSystemFilterProps['active']
  readonly $leafCenterVisible: ComponentSystemFilterProps['active'] & ComponentSystemFilterProps['active']
  readonly $leafCenter2Visible: ComponentSystemFilterProps['active'] & ComponentSystemFilterProps['active']
  readonly $leafPerimeterVisible: ComponentSystemFilterProps['active']
  readonly $leafPerimeterObjectName: SceneEntityRemoteObjectComponentState['objectName']
  readonly $offsetY: SceneEntityObjectPropertiesComponentState['offsetY'] &
    SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $leafLeftOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $leafLeftRotationY: SceneEntityObjectPropertiesComponentState['rotationY']
  readonly $leafLengthShapekeyValue: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $leafLengthScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero']
  readonly $leafLengthScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne']
  readonly $leafWidthShapekeyValue: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $leafWidthScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero']
  readonly $leafWidthScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne']
  readonly $leafThicknessShapekeyValue: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $leafThicknessScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne']
  readonly $leafThicknessScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero']
  readonly $leafDupontEdgeOnSideValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $leafWavyEdgeOnSideValue: MorphTargetInfluence['value'] & MorphTargetInfluence['value']
  readonly $bevelThickness: MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value'] &
    MorphTargetInfluence['value']
  readonly $bevelScaleZero: MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    MorphTargetInfluence['scaleZero'] &
    typeof constants.Top.$bevelScaleZero
  readonly $bevelScaleOne: MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    MorphTargetInfluence['scaleOne'] &
    typeof constants.Top.$bevelScaleOne
  readonly $leafRightOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $leafRightRotationY: SceneEntityObjectPropertiesComponentState['rotationY']
  readonly $leafCenterOffsetY: SceneEntityObjectPropertiesComponentState['offsetY'] &
    SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $leafCenterOffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $leafCenterRotationY: SceneEntityObjectPropertiesComponentState['rotationY']
  readonly $leafCenter2OffsetZ: SceneEntityObjectPropertiesComponentState['offsetZ']
  readonly $leafCenter2RotationY: SceneEntityObjectPropertiesComponentState['rotationY']
  readonly $leafPerimeterOffsetY: SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $leafPerimeterInnerDiameter: MorphTargetInfluence['value']
  readonly $leafPerimeterInnerDiameterScaleZero: MorphTargetInfluence['scaleZero']
  readonly $leafPerimeterInnerDiameterScaleOne: MorphTargetInfluence['scaleOne']
  readonly $leafPerimeterOuterDiameter: MorphTargetInfluence['value']
  readonly $leafPerimeterOuterDiameterScaleZero: MorphTargetInfluence['scaleZero']
  readonly $leafPerimeterOuterDiameterScaleOne: MorphTargetInfluence['scaleOne']
  readonly $leafPerimeterThickness: MorphTargetInfluence['value']
  readonly $leafPerimeterThicknessScaleOne: MorphTargetInfluence['scaleOne']
  readonly $leafPerimeterThicknessScaleZero: MorphTargetInfluence['scaleZero']
  readonly $thicknessTypeOptions: AttributeSelectionComponentState['options']
  readonly $leafTypeOptions: AttributeSelectionComponentState['options']
  readonly $leafAmountOptions: AttributeSelectionComponentState['options']
  readonly $finishColor: SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['color'] &
    SceneEntityRemoteMaterialOverrideComponentState['color']
  readonly $textureUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['textureUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['textureUrl']
  readonly $textureOffsetX: SceneEntityObjectRemoteMaterialOverrideComponentState['offsetX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['offsetX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['offsetX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['offsetX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['offsetX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['offsetX']
  readonly $normalMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $distressBumpMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['bumpMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpMapUrl']
  readonly $distressBumpScale: SceneEntityObjectRemoteMaterialOverrideComponentState['bumpScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpScale'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['bumpScale']
  readonly $roughnessMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['roughnessMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['roughnessMapUrl']
  readonly $aoMapUrl: SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['aoMapUrl'] &
    SceneEntityRemoteMaterialOverrideComponentState['aoMapUrl']
  readonly $repeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $repeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $leafRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $leafRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY'] &
    SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $leafPerimeterRepeatX: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatX']
  readonly $leafPerimeterRepeatY: SceneEntityObjectRemoteMaterialOverrideComponentState['repeatY']
  readonly $edgeNormalMapUrl: SceneEntityRemoteMaterialOverrideComponentState['normalMapUrl']
  readonly $edgeNormalScale: SceneEntityRemoteMaterialOverrideComponentState['normalScale']
  readonly $edgeRepeatX: SceneEntityRemoteMaterialOverrideComponentState['repeatX']
  readonly $edgeRepeatY: SceneEntityRemoteMaterialOverrideComponentState['repeatY']
  readonly $topIndicatorXVisible: ComponentSystemFilterProps['active']
  readonly $topIndicatorXStartX: DimensionIndicatorComponentState['startX']
  readonly $topIndicatorXFixedY: DimensionIndicatorComponentState['startY'] & DimensionIndicatorComponentState['endY']
  readonly $topIndicatorXFixedZ: DimensionIndicatorComponentState['startZ'] & DimensionIndicatorComponentState['endZ']
  readonly $topIndicatorXEndX: DimensionIndicatorComponentState['endX']
  readonly $topDimensionIndicatorZVisible: ComponentSystemFilterProps['active']
  readonly $topIndicatorZFixedX: DimensionIndicatorComponentState['startX'] & DimensionIndicatorComponentState['endX']
  readonly $topIndicatorZFixedY: DimensionIndicatorComponentState['startY'] & DimensionIndicatorComponentState['endY']
  readonly $topIndicatorZStartZ: DimensionIndicatorComponentState['startZ']
  readonly $topIndicatorZEndZ: DimensionIndicatorComponentState['endZ']
  readonly $shapeIndicatorXStartX: DimensionIndicatorComponentState['startX']
  readonly $shapeIndicatorXFixedY: DimensionIndicatorComponentState['startY'] & DimensionIndicatorComponentState['endY']
  readonly $shapeIndicatorXFixedZ: DimensionIndicatorComponentState['startZ'] & DimensionIndicatorComponentState['endZ']
  readonly $shapeIndicatorXEndX: DimensionIndicatorComponentState['endX']
  readonly $shapeDimensionIndicatorXExtrusionZ: DimensionIndicatorComponentState['extrusionZ']
  readonly $shapeDimensionIndicatorZVisible: ComponentSystemFilterProps['active']
  readonly $shapeIndicatorZFixedX: DimensionIndicatorComponentState['startX'] & DimensionIndicatorComponentState['endX']
  readonly $shapeIndicatorZFixedY: DimensionIndicatorComponentState['startY'] & DimensionIndicatorComponentState['endY']
  readonly $shapeIndicatorZStartZ: DimensionIndicatorComponentState['startZ']
  readonly $shapeIndicatorZEndZ: DimensionIndicatorComponentState['endZ']
  readonly $shapeDimensionIndicatorZExtrusionX: DimensionIndicatorComponentState['extrusionX']
  readonly $splitTableIndicatorZVisible: ComponentSystemFilterProps['active'] & ComponentSystemFilterProps['active']
  readonly $splitTableLeftIndicatorZFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $splitTableLeftIndicatorZFixedY: DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY']
  readonly $splitTableLeftIndicatorZStartZ: DimensionIndicatorComponentState['startZ']
  readonly $splitTableLeftIndicatorZEndZ: DimensionIndicatorComponentState['endZ']
  readonly $splitTableLeftDimensionIndicatorZExtrusionX: DimensionIndicatorComponentState['extrusionX']
  readonly $splitTableRightIndicatorZFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $splitTableRightIndicatorZFixedY: DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY']
  readonly $splitTableRightIndicatorZStartZ: DimensionIndicatorComponentState['startZ']
  readonly $splitTableRightIndicatorZEndZ: DimensionIndicatorComponentState['endZ']
  readonly $splitTableRightDimensionIndicatorZExtrusionX: DimensionIndicatorComponentState['extrusionX']
  readonly $leafLeftIndicatorZFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $leafLeftIndicatorZFixedY: DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY']
  readonly $leafLeftIndicatorZStartZ: DimensionIndicatorComponentState['startZ']
  readonly $leafLeftIndicatorZEndZ: DimensionIndicatorComponentState['endZ']
  readonly $leafRightIndicatorZFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $leafRightIndicatorZFixedY: DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY']
  readonly $leafRightIndicatorZStartZ: DimensionIndicatorComponentState['startZ']
  readonly $leafRightIndicatorZEndZ: DimensionIndicatorComponentState['endZ']
  readonly $leafCenterIndicatorZFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $leafCenterIndicatorZFixedY: DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY']
  readonly $leafCenterIndicatorZStartZ: DimensionIndicatorComponentState['startZ']
  readonly $leafCenterIndicatorZEndZ: DimensionIndicatorComponentState['endZ']
  readonly $leafCenter2IndicatorZFixedX: DimensionIndicatorComponentState['startX'] &
    DimensionIndicatorComponentState['endX']
  readonly $leafCenter2IndicatorZFixedY: DimensionIndicatorComponentState['startY'] &
    DimensionIndicatorComponentState['endY']
  readonly $leafCenter2IndicatorZStartZ: DimensionIndicatorComponentState['startZ']
  readonly $leafCenter2IndicatorZEndZ: DimensionIndicatorComponentState['endZ']
  readonly $table: $Table
  readonly $apron: $Apron
  readonly $minLeafAmount: typeof constants.Top.$minLeafAmount
  readonly $minTopLengthForExtraBase: typeof constants.Top.$minTopLengthForExtraBase
  readonly $minTopLengthForDoubleBase: typeof constants.Top.$minTopLengthForDoubleBase
  readonly $straightPartOfBevelTopThickness: typeof constants.Top.$straightPartOfBevelTopThickness
  readonly $minBeveledTopThickness: typeof constants.Top.$minBeveledTopThickness
  readonly $topDataMap: typeof constants.Top.$topDataMap
  readonly $leafDataMap: typeof constants.Top.$leafDataMap
  readonly $modelDataMap: typeof constants.Top.$modelDataMap
}
const TopExpressions = [
  '$width',
  '$length',
  '$fileUrl',
  '$objectName',
  '$availableThicknessTypes',
  '$availableBaseStyles',
  '$availableLeafTypes',
  '$sizeDescription',
  '$price',
  '$customProductTopDescription',
  '$topDimensionsHTML',
  '$defaultWidth',
  '$defaultLength',
  '$materialRoughness',
  '$materialMetalness',
  '$materialEnvMapIntensity',
  '$materialSpecularIntensity',
  '$materialNormalScale',
  '$materialReflectivity',
  '$withBevel',
  '$leafWidth',
  '$leafLength',
  '$leafThickness',
  '$bevelThicknessValue',
  '$apronOptions',
  '$minThickness',
  '$maxThickness',
  '$leafLeftVisible',
  '$leafObjectName',
  '$leafRightVisible',
  '$leafCenterVisible',
  '$leafCenter2Visible',
  '$leafPerimeterVisible',
  '$leafPerimeterObjectName',
  '$offsetY',
  '$leafLeftOffsetZ',
  '$leafLeftRotationY',
  '$leafLengthShapekeyValue',
  '$leafLengthScaleZero',
  '$leafLengthScaleOne',
  '$leafWidthShapekeyValue',
  '$leafWidthScaleZero',
  '$leafWidthScaleOne',
  '$leafThicknessShapekeyValue',
  '$leafThicknessScaleOne',
  '$leafThicknessScaleZero',
  '$leafDupontEdgeOnSideValue',
  '$leafWavyEdgeOnSideValue',
  '$bevelThickness',
  '$bevelScaleZero',
  '$bevelScaleOne',
  '$leafRightOffsetZ',
  '$leafRightRotationY',
  '$leafCenterOffsetY',
  '$leafCenterOffsetZ',
  '$leafCenterRotationY',
  '$leafCenter2OffsetZ',
  '$leafCenter2RotationY',
  '$leafPerimeterOffsetY',
  '$leafPerimeterInnerDiameter',
  '$leafPerimeterInnerDiameterScaleZero',
  '$leafPerimeterInnerDiameterScaleOne',
  '$leafPerimeterOuterDiameter',
  '$leafPerimeterOuterDiameterScaleZero',
  '$leafPerimeterOuterDiameterScaleOne',
  '$leafPerimeterThickness',
  '$leafPerimeterThicknessScaleOne',
  '$leafPerimeterThicknessScaleZero',
  '$thicknessTypeOptions',
  '$leafTypeOptions',
  '$leafAmountOptions',
  '$finishColor',
  '$textureUrl',
  '$textureOffsetX',
  '$normalMapUrl',
  '$distressBumpMapUrl',
  '$distressBumpScale',
  '$roughnessMapUrl',
  '$aoMapUrl',
  '$repeatX',
  '$repeatY',
  '$leafRepeatX',
  '$leafRepeatY',
  '$leafPerimeterRepeatX',
  '$leafPerimeterRepeatY',
  '$edgeNormalMapUrl',
  '$edgeNormalScale',
  '$edgeRepeatX',
  '$edgeRepeatY',
  '$topIndicatorXVisible',
  '$topIndicatorXStartX',
  '$topIndicatorXFixedY',
  '$topIndicatorXFixedZ',
  '$topIndicatorXEndX',
  '$topDimensionIndicatorZVisible',
  '$topIndicatorZFixedX',
  '$topIndicatorZFixedY',
  '$topIndicatorZStartZ',
  '$topIndicatorZEndZ',
  '$shapeIndicatorXStartX',
  '$shapeIndicatorXFixedY',
  '$shapeIndicatorXFixedZ',
  '$shapeIndicatorXEndX',
  '$shapeDimensionIndicatorXExtrusionZ',
  '$shapeDimensionIndicatorZVisible',
  '$shapeIndicatorZFixedX',
  '$shapeIndicatorZFixedY',
  '$shapeIndicatorZStartZ',
  '$shapeIndicatorZEndZ',
  '$shapeDimensionIndicatorZExtrusionX',
  '$splitTableIndicatorZVisible',
  '$splitTableLeftIndicatorZFixedX',
  '$splitTableLeftIndicatorZFixedY',
  '$splitTableLeftIndicatorZStartZ',
  '$splitTableLeftIndicatorZEndZ',
  '$splitTableLeftDimensionIndicatorZExtrusionX',
  '$splitTableRightIndicatorZFixedX',
  '$splitTableRightIndicatorZFixedY',
  '$splitTableRightIndicatorZStartZ',
  '$splitTableRightIndicatorZEndZ',
  '$splitTableRightDimensionIndicatorZExtrusionX',
  '$leafLeftIndicatorZFixedX',
  '$leafLeftIndicatorZFixedY',
  '$leafLeftIndicatorZStartZ',
  '$leafLeftIndicatorZEndZ',
  '$leafRightIndicatorZFixedX',
  '$leafRightIndicatorZFixedY',
  '$leafRightIndicatorZStartZ',
  '$leafRightIndicatorZEndZ',
  '$leafCenterIndicatorZFixedX',
  '$leafCenterIndicatorZFixedY',
  '$leafCenterIndicatorZStartZ',
  '$leafCenterIndicatorZEndZ',
  '$leafCenter2IndicatorZFixedX',
  '$leafCenter2IndicatorZFixedY',
  '$leafCenter2IndicatorZStartZ',
  '$leafCenter2IndicatorZEndZ',
  '$table',
  '$apron',
  '$minLeafAmount',
  '$minTopLengthForExtraBase',
  '$minTopLengthForDoubleBase',
  '$straightPartOfBevelTopThickness',
  '$minBeveledTopThickness',
  '$topDataMap',
  '$leafDataMap',
  '$modelDataMap',
]

interface BaseFourLegCombinedExpressions {
  readonly $fileUrl: SceneEntityRemoteObjectComponentState['fileUrl']
  readonly $objectName: SceneEntityRemoteObjectComponentState['objectName']
  readonly $width: MorphTargetInfluence['value']
  readonly $widthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $widthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $length: MorphTargetInfluence['value']
  readonly $lengthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $lengthScaleOne: MorphTargetInfluence['scaleOne']
}
const BaseFourLegCombinedExpressions = [
  '$fileUrl',
  '$objectName',
  '$width',
  '$widthScaleZero',
  '$widthScaleOne',
  '$length',
  '$lengthScaleZero',
  '$lengthScaleOne',
]

interface TopWithSideExpressions {
  readonly $offsetY: SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $thicknessValue: MorphTargetInfluence['value']
  readonly $thicknessScaleZero: MorphTargetInfluence['scaleZero']
  readonly $thicknessScaleOne: MorphTargetInfluence['scaleOne']
  readonly $widthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $widthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $lengthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $lengthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $distance: MorphTargetInfluence['value']
  readonly $distanceScaleZero: MorphTargetInfluence['scaleZero']
  readonly $distanceScaleOne: MorphTargetInfluence['scaleOne']
  readonly $leafBevel: MorphTargetInfluence['value']
  readonly $leafBevelScaleZero: MorphTargetInfluence['scaleZero']
  readonly $leafBevelScaleOne: MorphTargetInfluence['scaleOne']
  readonly $bevelThickness: MorphTargetInfluence['value']
  readonly $bevelScaleZero: MorphTargetInfluence['scaleZero']
  readonly $bevelScaleOne: MorphTargetInfluence['scaleOne']
  readonly $minWidth: DistanceDimensionComponentState['min']
  readonly $maxWidth: DistanceDimensionComponentState['max']
}
const TopWithSideExpressions = [
  '$offsetY',
  '$thicknessValue',
  '$thicknessScaleZero',
  '$thicknessScaleOne',
  '$widthScaleZero',
  '$widthScaleOne',
  '$lengthScaleZero',
  '$lengthScaleOne',
  '$distance',
  '$distanceScaleZero',
  '$distanceScaleOne',
  '$leafBevel',
  '$leafBevelScaleZero',
  '$leafBevelScaleOne',
  '$bevelThickness',
  '$bevelScaleZero',
  '$bevelScaleOne',
  '$minWidth',
  '$maxWidth',
]

interface TopWithWidthAndLengthExpressions {
  readonly $offsetY: SceneEntityObjectPropertiesComponentState['offsetY']
  readonly $thicknessValue: MorphTargetInfluence['value']
  readonly $thicknessScaleZero: MorphTargetInfluence['scaleZero']
  readonly $thicknessScaleOne: MorphTargetInfluence['scaleOne']
  readonly $widthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $widthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $lengthScaleZero: MorphTargetInfluence['scaleZero']
  readonly $lengthScaleOne: MorphTargetInfluence['scaleOne']
  readonly $distance: MorphTargetInfluence['value']
  readonly $distanceScaleZero: MorphTargetInfluence['scaleZero']
  readonly $distanceScaleOne: MorphTargetInfluence['scaleOne']
  readonly $leafBevel: MorphTargetInfluence['value']
  readonly $leafBevelScaleZero: MorphTargetInfluence['scaleZero'] &
    typeof constants.TopWithWidthAndLength.$leafBevelScaleZero
  readonly $leafBevelScaleOne: MorphTargetInfluence['scaleOne'] &
    typeof constants.TopWithWidthAndLength.$leafBevelScaleOne
  readonly $bevelThickness: MorphTargetInfluence['value']
  readonly $bevelScaleZero: MorphTargetInfluence['scaleZero']
  readonly $bevelScaleOne: MorphTargetInfluence['scaleOne']
  readonly $minWidth: DistanceDimensionComponentState['min']
  readonly $maxWidth: DistanceDimensionComponentState['max']
  readonly $minLength: DistanceDimensionComponentState['min']
  readonly $maxLength: DistanceDimensionComponentState['max']
}
const TopWithWidthAndLengthExpressions = [
  '$offsetY',
  '$thicknessValue',
  '$thicknessScaleZero',
  '$thicknessScaleOne',
  '$widthScaleZero',
  '$widthScaleOne',
  '$lengthScaleZero',
  '$lengthScaleOne',
  '$distance',
  '$distanceScaleZero',
  '$distanceScaleOne',
  '$leafBevel',
  '$leafBevelScaleZero',
  '$leafBevelScaleOne',
  '$bevelThickness',
  '$bevelScaleZero',
  '$bevelScaleOne',
  '$minWidth',
  '$maxWidth',
  '$minLength',
  '$maxLength',
]

interface BenchExpressions {
  readonly $table: $Table
}
const BenchExpressions = ['$table']

interface ApronExpressions {
  readonly $top: $Top
}
const ApronExpressions = ['$top']

interface AnchorBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const AnchorBaseExpressions = ['$violations']

interface AnchorSingleFeetBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const AnchorSingleFeetBaseExpressions = ['$violations']

interface AnchorSinglePlatformBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const AnchorSinglePlatformBaseExpressions = ['$violations']

interface BellhouseBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const BellhouseBaseExpressions = ['$violations']

interface BellhouseSingleFeetBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const BellhouseSingleFeetBaseExpressions = ['$violations']

interface BellhouseSinglePlatformBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const BellhouseSinglePlatformBaseExpressions = ['$violations']

interface BellyStretchedBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const BellyStretchedBaseExpressions = ['$violations']

interface BrewerBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const BrewerBaseExpressions = ['$violations']

interface BrewerSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const BrewerSingleBaseExpressions = ['$violations']

interface CaseyBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const CaseyBaseExpressions = ['$violations']

interface CraftsmanBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const CraftsmanBaseExpressions = ['$violations']

interface CraftsmanSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const CraftsmanSingleBaseExpressions = ['$violations']

interface CrescentBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const CrescentBaseExpressions = ['$violations']

interface CrescentSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const CrescentSingleBaseExpressions = ['$violations']

interface DanaBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const DanaBaseExpressions = ['$violations']

interface DanaSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const DanaSingleBaseExpressions = ['$violations']

interface FranklinBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const FranklinBaseExpressions = ['$violations']

interface FranklinSingleFeetBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const FranklinSingleFeetBaseExpressions = ['$violations']

interface FranklinSinglePlatformBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const FranklinSinglePlatformBaseExpressions = ['$violations']

interface MantisBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const MantisBaseExpressions = ['$violations']

interface MarksBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const MarksBaseExpressions = ['$violations']

interface MeredithBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const MeredithBaseExpressions = ['$violations']

interface MeredithSingleFeetBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const MeredithSingleFeetBaseExpressions = ['$violations']

interface MeredithSinglePlatformBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const MeredithSinglePlatformBaseExpressions = ['$violations']

interface OswaldBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const OswaldBaseExpressions = ['$violations']

interface OswaldSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const OswaldSingleBaseExpressions = ['$violations']

interface PeruStretchedBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const PeruStretchedBaseExpressions = ['$violations']

interface RishBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const RishBaseExpressions = ['$violations']

interface RishSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const RishSingleBaseExpressions = ['$violations']

interface RogersBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const RogersBaseExpressions = ['$violations']

interface RogersSinglePlatformBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const RogersSinglePlatformBaseExpressions = ['$violations']

interface TamaraBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const TamaraBaseExpressions = ['$violations']

interface TamaraSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const TamaraSingleBaseExpressions = ['$violations']

interface TuscanBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const TuscanBaseExpressions = ['$violations']

interface TuscanSingleFeetBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const TuscanSingleFeetBaseExpressions = ['$violations']

interface TuscanSinglePlatformBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const TuscanSinglePlatformBaseExpressions = ['$violations']

interface WaldenBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const WaldenBaseExpressions = ['$violations']

interface WaldenSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const WaldenSingleBaseExpressions = ['$violations']

interface XBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const XBaseExpressions = ['$violations']

interface XSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const XSingleBaseExpressions = ['$violations']

interface AnglePictureFrameBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const AnglePictureFrameBaseExpressions = ['$violations']

interface AnglePictureFrameSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const AnglePictureFrameSingleBaseExpressions = ['$violations']

interface AnglePictureFrameCTCBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const AnglePictureFrameCTCBaseExpressions = ['$violations']

interface ArchBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const ArchBaseExpressions = ['$violations']

interface ArchSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const ArchSingleBaseExpressions = ['$violations']

interface BoxFrameBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const BoxFrameBaseExpressions = ['$violations']

interface ConnectedXBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const ConnectedXBaseExpressions = ['$violations']

interface SlimConnectedXBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const SlimConnectedXBaseExpressions = ['$violations']

interface SlimConnectedXSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const SlimConnectedXSingleBaseExpressions = ['$violations']

interface ReflectionBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const ReflectionBaseExpressions = ['$violations']

interface ReflectionCTCBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const ReflectionCTCBaseExpressions = ['$violations']

interface SinglePostBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const SinglePostBaseExpressions = ['$violations']

interface SinglePostSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const SinglePostSingleBaseExpressions = ['$violations']

interface XMetalBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const XMetalBaseExpressions = ['$violations']

interface XMetalSingleBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const XMetalSingleBaseExpressions = ['$violations']

interface IvyBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const IvyBaseExpressions = ['$violations']

interface DremorTurnedBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const DremorTurnedBaseExpressions = ['$violations']

interface HerricksonTurnedBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const HerricksonTurnedBaseExpressions = ['$violations']

interface MidModernTaperBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const MidModernTaperBaseExpressions = ['$violations']

interface NarrowEnglishTurnedBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const NarrowEnglishTurnedBaseExpressions = ['$violations']

interface OldEnglishTurnedBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const OldEnglishTurnedBaseExpressions = ['$violations']

interface SlagleTurnedBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const SlagleTurnedBaseExpressions = ['$violations']

interface TraditionalBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const TraditionalBaseExpressions = ['$violations']

interface TraditionalFlushBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const TraditionalFlushBaseExpressions = ['$violations']

interface ReededBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const ReededBaseExpressions = ['$violations']

interface HershBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const HershBaseExpressions = ['$violations']

interface TriflectionBaseExpressions {
  readonly $violations: ReadonlyArray<
    Violation<'customBaseFinishNeedsPersonalizedQuote' | 'baseFourLegMustHaveAprons' | 'supportsCrossbrace'>
  >
}
const TriflectionBaseExpressions = ['$violations']

interface RectangleTopExpressions {
  readonly $violations: ReadonlyArray<
    Violation<
      | 'lengthLargerThanWidth'
      | 'baseStyleNotAvailableForThisTop'
      | 'baseTypeMustHaveStyles'
      | 'leafAmountNotAvailableForThisLeafType'
      | 'lengthMightNotBeAvailableForThisTop'
      | 'widthMaybeTooBigForDoor'
      | 'thicknessTypeMightNotBeAvailableForThisTop'
      | 'customTopFinishNeedsPersonalizedQuote'
      | 'customLeafSizeNeedsPersonalizedQuote'
      | 'lengthTooShortForDoubleBase'
      | 'lengthTooShortForPerimeterOrDropInLeaf'
      | 'edgeStyleAvailableForThisTop'
      | 'beveledTopNeverRolled'
      | 'roundedCorners'
    >
  >
}
const RectangleTopExpressions = ['$violations']

interface SquareTopExpressions {
  readonly $violations: ReadonlyArray<
    Violation<
      | 'lengthLargerThanWidth'
      | 'baseStyleNotAvailableForThisTop'
      | 'baseTypeMustHaveStyles'
      | 'leafAmountNotAvailableForThisLeafType'
      | 'lengthMightNotBeAvailableForThisTop'
      | 'widthMaybeTooBigForDoor'
      | 'thicknessTypeMightNotBeAvailableForThisTop'
      | 'customTopFinishNeedsPersonalizedQuote'
      | 'customLeafSizeNeedsPersonalizedQuote'
      | 'lengthTooShortForDoubleBase'
      | 'lengthTooShortForPerimeterOrDropInLeaf'
      | 'edgeStyleAvailableForThisTop'
      | 'beveledTopNeverRolled'
      | 'roundedCorners'
    >
  >
}
const SquareTopExpressions = ['$violations']

interface RoundTopExpressions {
  readonly $violations: ReadonlyArray<
    Violation<
      | 'lengthLargerThanWidth'
      | 'baseStyleNotAvailableForThisTop'
      | 'baseTypeMustHaveStyles'
      | 'leafAmountNotAvailableForThisLeafType'
      | 'lengthMightNotBeAvailableForThisTop'
      | 'widthMaybeTooBigForDoor'
      | 'thicknessTypeMightNotBeAvailableForThisTop'
      | 'customTopFinishNeedsPersonalizedQuote'
      | 'customLeafSizeNeedsPersonalizedQuote'
      | 'lengthTooShortForDoubleBase'
      | 'lengthTooShortForPerimeterOrDropInLeaf'
      | 'edgeStyleAvailableForThisTop'
      | 'beveledTopNeverRolled'
      | 'roundedCorners'
    >
  >
}
const RoundTopExpressions = ['$violations']

interface EllipticalOvalTopExpressions {
  readonly $violations: ReadonlyArray<
    Violation<
      | 'lengthLargerThanWidth'
      | 'baseStyleNotAvailableForThisTop'
      | 'baseTypeMustHaveStyles'
      | 'leafAmountNotAvailableForThisLeafType'
      | 'lengthMightNotBeAvailableForThisTop'
      | 'widthMaybeTooBigForDoor'
      | 'thicknessTypeMightNotBeAvailableForThisTop'
      | 'customTopFinishNeedsPersonalizedQuote'
      | 'customLeafSizeNeedsPersonalizedQuote'
      | 'lengthTooShortForDoubleBase'
      | 'lengthTooShortForPerimeterOrDropInLeaf'
      | 'edgeStyleAvailableForThisTop'
      | 'beveledTopNeverRolled'
      | 'roundedCorners'
    >
  >
}
const EllipticalOvalTopExpressions = ['$violations']

interface RacetrackOvalTopExpressions {
  readonly $violations: ReadonlyArray<
    Violation<
      | 'lengthLargerThanWidth'
      | 'baseStyleNotAvailableForThisTop'
      | 'baseTypeMustHaveStyles'
      | 'leafAmountNotAvailableForThisLeafType'
      | 'lengthMightNotBeAvailableForThisTop'
      | 'widthMaybeTooBigForDoor'
      | 'thicknessTypeMightNotBeAvailableForThisTop'
      | 'customTopFinishNeedsPersonalizedQuote'
      | 'customLeafSizeNeedsPersonalizedQuote'
      | 'lengthTooShortForDoubleBase'
      | 'lengthTooShortForPerimeterOrDropInLeaf'
      | 'edgeStyleAvailableForThisTop'
      | 'beveledTopNeverRolled'
      | 'roundedCorners'
    >
  >
}
const RacetrackOvalTopExpressions = ['$violations']

interface BoatShapeTopExpressions {
  readonly $violations: ReadonlyArray<
    Violation<
      | 'lengthLargerThanWidth'
      | 'baseStyleNotAvailableForThisTop'
      | 'baseTypeMustHaveStyles'
      | 'leafAmountNotAvailableForThisLeafType'
      | 'lengthMightNotBeAvailableForThisTop'
      | 'widthMaybeTooBigForDoor'
      | 'thicknessTypeMightNotBeAvailableForThisTop'
      | 'customTopFinishNeedsPersonalizedQuote'
      | 'customLeafSizeNeedsPersonalizedQuote'
      | 'lengthTooShortForDoubleBase'
      | 'lengthTooShortForPerimeterOrDropInLeaf'
      | 'edgeStyleAvailableForThisTop'
      | 'beveledTopNeverRolled'
      | 'roundedCorners'
    >
  >
}
const BoatShapeTopExpressions = ['$violations']

export type $Table = $DomainEntity<Table> & TableExpressions & RootEntityExpressions
export const $Table: $DomainEntityReflection<$Table> = new $DomainEntityReflection('Table', [
  ...TableExpressions,
  ...RootEntityExpressions,
])

export type $RectangleTop = $DomainEntity<RectangleTop> &
  RectangleTopExpressions &
  TopExpressions &
  TopWithWidthAndLengthExpressions
export const $RectangleTop: $DomainEntityReflection<$RectangleTop> = new $DomainEntityReflection('RectangleTop', [
  ...RectangleTopExpressions,
  ...TopExpressions,
  ...TopWithWidthAndLengthExpressions,
])

export type $SquareTop = $DomainEntity<SquareTop> & SquareTopExpressions & TopExpressions & TopWithSideExpressions
export const $SquareTop: $DomainEntityReflection<$SquareTop> = new $DomainEntityReflection('SquareTop', [
  ...SquareTopExpressions,
  ...TopExpressions,
  ...TopWithSideExpressions,
])

export type $RoundTop = $DomainEntity<RoundTop> & RoundTopExpressions & TopExpressions & TopWithDiameterExpressions
export const $RoundTop: $DomainEntityReflection<$RoundTop> = new $DomainEntityReflection('RoundTop', [
  ...RoundTopExpressions,
  ...TopExpressions,
  ...TopWithDiameterExpressions,
])

export type $EllipticalOvalTop = $DomainEntity<EllipticalOvalTop> &
  EllipticalOvalTopExpressions &
  TopExpressions &
  TopWithWidthAndLengthExpressions
export const $EllipticalOvalTop: $DomainEntityReflection<$EllipticalOvalTop> = new $DomainEntityReflection(
  'EllipticalOvalTop',
  [...EllipticalOvalTopExpressions, ...TopExpressions, ...TopWithWidthAndLengthExpressions]
)

export type $RacetrackOvalTop = $DomainEntity<RacetrackOvalTop> &
  RacetrackOvalTopExpressions &
  TopExpressions &
  TopWithWidthAndLengthExpressions
export const $RacetrackOvalTop: $DomainEntityReflection<$RacetrackOvalTop> = new $DomainEntityReflection(
  'RacetrackOvalTop',
  [...RacetrackOvalTopExpressions, ...TopExpressions, ...TopWithWidthAndLengthExpressions]
)

export type $BoatShapeTop = $DomainEntity<BoatShapeTop> &
  BoatShapeTopExpressions &
  TopExpressions &
  TopWithWidthAndLengthExpressions
export const $BoatShapeTop: $DomainEntityReflection<$BoatShapeTop> = new $DomainEntityReflection('BoatShapeTop', [
  ...BoatShapeTopExpressions,
  ...TopExpressions,
  ...TopWithWidthAndLengthExpressions,
])

export type $AnchorBase = $DomainEntity<AnchorBase> & AnchorBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $AnchorBase: $DomainEntityReflection<$AnchorBase> = new $DomainEntityReflection('AnchorBase', [
  ...AnchorBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $AnchorSingleFeetBase = $DomainEntity<AnchorSingleFeetBase> &
  AnchorSingleFeetBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $AnchorSingleFeetBase: $DomainEntityReflection<$AnchorSingleFeetBase> = new $DomainEntityReflection(
  'AnchorSingleFeetBase',
  [...AnchorSingleFeetBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $AnchorSinglePlatformBase = $DomainEntity<AnchorSinglePlatformBase> &
  AnchorSinglePlatformBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $AnchorSinglePlatformBase: $DomainEntityReflection<$AnchorSinglePlatformBase> =
  new $DomainEntityReflection('AnchorSinglePlatformBase', [
    ...AnchorSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions,
  ])

export type $BellhouseBase = $DomainEntity<BellhouseBase> &
  BellhouseBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $BellhouseBase: $DomainEntityReflection<$BellhouseBase> = new $DomainEntityReflection('BellhouseBase', [
  ...BellhouseBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $BellhouseSingleFeetBase = $DomainEntity<BellhouseSingleFeetBase> &
  BellhouseSingleFeetBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $BellhouseSingleFeetBase: $DomainEntityReflection<$BellhouseSingleFeetBase> = new $DomainEntityReflection(
  'BellhouseSingleFeetBase',
  [...BellhouseSingleFeetBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $BellhouseSinglePlatformBase = $DomainEntity<BellhouseSinglePlatformBase> &
  BellhouseSinglePlatformBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $BellhouseSinglePlatformBase: $DomainEntityReflection<$BellhouseSinglePlatformBase> =
  new $DomainEntityReflection('BellhouseSinglePlatformBase', [
    ...BellhouseSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions,
  ])

export type $BellyStretchedBase = $DomainEntity<BellyStretchedBase> &
  BellyStretchedBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $BellyStretchedBase: $DomainEntityReflection<$BellyStretchedBase> = new $DomainEntityReflection(
  'BellyStretchedBase',
  [...BellyStretchedBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $BrewerBase = $DomainEntity<BrewerBase> & BrewerBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $BrewerBase: $DomainEntityReflection<$BrewerBase> = new $DomainEntityReflection('BrewerBase', [
  ...BrewerBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $BrewerSingleBase = $DomainEntity<BrewerSingleBase> &
  BrewerSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $BrewerSingleBase: $DomainEntityReflection<$BrewerSingleBase> = new $DomainEntityReflection(
  'BrewerSingleBase',
  [...BrewerSingleBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $CaseyBase = $DomainEntity<CaseyBase> & CaseyBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $CaseyBase: $DomainEntityReflection<$CaseyBase> = new $DomainEntityReflection('CaseyBase', [
  ...CaseyBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $CraftsmanBase = $DomainEntity<CraftsmanBase> &
  CraftsmanBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $CraftsmanBase: $DomainEntityReflection<$CraftsmanBase> = new $DomainEntityReflection('CraftsmanBase', [
  ...CraftsmanBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $CraftsmanSingleBase = $DomainEntity<CraftsmanSingleBase> &
  CraftsmanSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $CraftsmanSingleBase: $DomainEntityReflection<$CraftsmanSingleBase> = new $DomainEntityReflection(
  'CraftsmanSingleBase',
  [...CraftsmanSingleBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $CrescentBase = $DomainEntity<CrescentBase> &
  CrescentBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $CrescentBase: $DomainEntityReflection<$CrescentBase> = new $DomainEntityReflection('CrescentBase', [
  ...CrescentBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $CrescentSingleBase = $DomainEntity<CrescentSingleBase> &
  CrescentSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $CrescentSingleBase: $DomainEntityReflection<$CrescentSingleBase> = new $DomainEntityReflection(
  'CrescentSingleBase',
  [...CrescentSingleBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $DanaBase = $DomainEntity<DanaBase> & DanaBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $DanaBase: $DomainEntityReflection<$DanaBase> = new $DomainEntityReflection('DanaBase', [
  ...DanaBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $DanaSingleBase = $DomainEntity<DanaSingleBase> &
  DanaSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $DanaSingleBase: $DomainEntityReflection<$DanaSingleBase> = new $DomainEntityReflection('DanaSingleBase', [
  ...DanaSingleBaseExpressions,
  ...BaseExpressions,
  ...BaseSingleLegExpressions,
])

export type $FranklinBase = $DomainEntity<FranklinBase> &
  FranklinBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $FranklinBase: $DomainEntityReflection<$FranklinBase> = new $DomainEntityReflection('FranklinBase', [
  ...FranklinBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $FranklinSingleFeetBase = $DomainEntity<FranklinSingleFeetBase> &
  FranklinSingleFeetBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $FranklinSingleFeetBase: $DomainEntityReflection<$FranklinSingleFeetBase> = new $DomainEntityReflection(
  'FranklinSingleFeetBase',
  [...FranklinSingleFeetBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $FranklinSinglePlatformBase = $DomainEntity<FranklinSinglePlatformBase> &
  FranklinSinglePlatformBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $FranklinSinglePlatformBase: $DomainEntityReflection<$FranklinSinglePlatformBase> =
  new $DomainEntityReflection('FranklinSinglePlatformBase', [
    ...FranklinSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions,
  ])

export type $MantisBase = $DomainEntity<MantisBase> & MantisBaseExpressions & BaseExpressions & BaseSingleLegExpressions
export const $MantisBase: $DomainEntityReflection<$MantisBase> = new $DomainEntityReflection('MantisBase', [
  ...MantisBaseExpressions,
  ...BaseExpressions,
  ...BaseSingleLegExpressions,
])

export type $MarksBase = $DomainEntity<MarksBase> & MarksBaseExpressions & BaseExpressions & BaseSingleLegExpressions
export const $MarksBase: $DomainEntityReflection<$MarksBase> = new $DomainEntityReflection('MarksBase', [
  ...MarksBaseExpressions,
  ...BaseExpressions,
  ...BaseSingleLegExpressions,
])

export type $MeredithBase = $DomainEntity<MeredithBase> &
  MeredithBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $MeredithBase: $DomainEntityReflection<$MeredithBase> = new $DomainEntityReflection('MeredithBase', [
  ...MeredithBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $MeredithSingleFeetBase = $DomainEntity<MeredithSingleFeetBase> &
  MeredithSingleFeetBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $MeredithSingleFeetBase: $DomainEntityReflection<$MeredithSingleFeetBase> = new $DomainEntityReflection(
  'MeredithSingleFeetBase',
  [...MeredithSingleFeetBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $MeredithSinglePlatformBase = $DomainEntity<MeredithSinglePlatformBase> &
  MeredithSinglePlatformBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $MeredithSinglePlatformBase: $DomainEntityReflection<$MeredithSinglePlatformBase> =
  new $DomainEntityReflection('MeredithSinglePlatformBase', [
    ...MeredithSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions,
  ])

export type $OswaldBase = $DomainEntity<OswaldBase> & OswaldBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $OswaldBase: $DomainEntityReflection<$OswaldBase> = new $DomainEntityReflection('OswaldBase', [
  ...OswaldBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $OswaldSingleBase = $DomainEntity<OswaldSingleBase> &
  OswaldSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $OswaldSingleBase: $DomainEntityReflection<$OswaldSingleBase> = new $DomainEntityReflection(
  'OswaldSingleBase',
  [...OswaldSingleBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $PeruStretchedBase = $DomainEntity<PeruStretchedBase> &
  PeruStretchedBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $PeruStretchedBase: $DomainEntityReflection<$PeruStretchedBase> = new $DomainEntityReflection(
  'PeruStretchedBase',
  [...PeruStretchedBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $RishBase = $DomainEntity<RishBase> & RishBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $RishBase: $DomainEntityReflection<$RishBase> = new $DomainEntityReflection('RishBase', [
  ...RishBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $RishSingleBase = $DomainEntity<RishSingleBase> &
  RishSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $RishSingleBase: $DomainEntityReflection<$RishSingleBase> = new $DomainEntityReflection('RishSingleBase', [
  ...RishSingleBaseExpressions,
  ...BaseExpressions,
  ...BaseSingleLegExpressions,
])

export type $RogersBase = $DomainEntity<RogersBase> & RogersBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $RogersBase: $DomainEntityReflection<$RogersBase> = new $DomainEntityReflection('RogersBase', [
  ...RogersBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $RogersSinglePlatformBase = $DomainEntity<RogersSinglePlatformBase> &
  RogersSinglePlatformBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $RogersSinglePlatformBase: $DomainEntityReflection<$RogersSinglePlatformBase> =
  new $DomainEntityReflection('RogersSinglePlatformBase', [
    ...RogersSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions,
  ])

export type $TamaraBase = $DomainEntity<TamaraBase> & TamaraBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $TamaraBase: $DomainEntityReflection<$TamaraBase> = new $DomainEntityReflection('TamaraBase', [
  ...TamaraBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $TamaraSingleBase = $DomainEntity<TamaraSingleBase> &
  TamaraSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $TamaraSingleBase: $DomainEntityReflection<$TamaraSingleBase> = new $DomainEntityReflection(
  'TamaraSingleBase',
  [...TamaraSingleBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $TuscanBase = $DomainEntity<TuscanBase> & TuscanBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $TuscanBase: $DomainEntityReflection<$TuscanBase> = new $DomainEntityReflection('TuscanBase', [
  ...TuscanBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $TuscanSingleFeetBase = $DomainEntity<TuscanSingleFeetBase> &
  TuscanSingleFeetBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $TuscanSingleFeetBase: $DomainEntityReflection<$TuscanSingleFeetBase> = new $DomainEntityReflection(
  'TuscanSingleFeetBase',
  [...TuscanSingleFeetBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $TuscanSinglePlatformBase = $DomainEntity<TuscanSinglePlatformBase> &
  TuscanSinglePlatformBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $TuscanSinglePlatformBase: $DomainEntityReflection<$TuscanSinglePlatformBase> =
  new $DomainEntityReflection('TuscanSinglePlatformBase', [
    ...TuscanSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions,
  ])

export type $WaldenBase = $DomainEntity<WaldenBase> & WaldenBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $WaldenBase: $DomainEntityReflection<$WaldenBase> = new $DomainEntityReflection('WaldenBase', [
  ...WaldenBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $WaldenSingleBase = $DomainEntity<WaldenSingleBase> &
  WaldenSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $WaldenSingleBase: $DomainEntityReflection<$WaldenSingleBase> = new $DomainEntityReflection(
  'WaldenSingleBase',
  [...WaldenSingleBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $AnglePictureFrameBase = $DomainEntity<AnglePictureFrameBase> &
  AnglePictureFrameBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $AnglePictureFrameBase: $DomainEntityReflection<$AnglePictureFrameBase> = new $DomainEntityReflection(
  'AnglePictureFrameBase',
  [...AnglePictureFrameBaseExpressions, ...BaseExpressions, ...BaseDoubleLegExpressions]
)

export type $XBase = $DomainEntity<XBase> & XBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $XBase: $DomainEntityReflection<$XBase> = new $DomainEntityReflection('XBase', [
  ...XBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $XSingleBase = $DomainEntity<XSingleBase> &
  XSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $XSingleBase: $DomainEntityReflection<$XSingleBase> = new $DomainEntityReflection('XSingleBase', [
  ...XSingleBaseExpressions,
  ...BaseExpressions,
  ...BaseSingleLegExpressions,
])

export type $AnglePictureFrameSingleBase = $DomainEntity<AnglePictureFrameSingleBase> &
  AnglePictureFrameSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $AnglePictureFrameSingleBase: $DomainEntityReflection<$AnglePictureFrameSingleBase> =
  new $DomainEntityReflection('AnglePictureFrameSingleBase', [
    ...AnglePictureFrameSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions,
  ])

export type $AnglePictureFrameCTCBase = $DomainEntity<AnglePictureFrameCTCBase> &
  AnglePictureFrameCTCBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $AnglePictureFrameCTCBase: $DomainEntityReflection<$AnglePictureFrameCTCBase> =
  new $DomainEntityReflection('AnglePictureFrameCTCBase', [
    ...AnglePictureFrameCTCBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions,
  ])

export type $ArchBase = $DomainEntity<ArchBase> & ArchBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $ArchBase: $DomainEntityReflection<$ArchBase> = new $DomainEntityReflection('ArchBase', [
  ...ArchBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $ArchSingleBase = $DomainEntity<ArchSingleBase> &
  ArchSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $ArchSingleBase: $DomainEntityReflection<$ArchSingleBase> = new $DomainEntityReflection('ArchSingleBase', [
  ...ArchSingleBaseExpressions,
  ...BaseExpressions,
  ...BaseSingleLegExpressions,
])

export type $BoxFrameBase = $DomainEntity<BoxFrameBase> &
  BoxFrameBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $BoxFrameBase: $DomainEntityReflection<$BoxFrameBase> = new $DomainEntityReflection('BoxFrameBase', [
  ...BoxFrameBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $ConnectedXBase = $DomainEntity<ConnectedXBase> &
  ConnectedXBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $ConnectedXBase: $DomainEntityReflection<$ConnectedXBase> = new $DomainEntityReflection('ConnectedXBase', [
  ...ConnectedXBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $SlimConnectedXBase = $DomainEntity<SlimConnectedXBase> &
  SlimConnectedXBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $SlimConnectedXBase: $DomainEntityReflection<$SlimConnectedXBase> = new $DomainEntityReflection(
  'SlimConnectedXBase',
  [...SlimConnectedXBaseExpressions, ...BaseExpressions, ...BaseDoubleLegExpressions]
)

export type $SlimConnectedXSingleBase = $DomainEntity<SlimConnectedXSingleBase> &
  SlimConnectedXSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $SlimConnectedXSingleBase: $DomainEntityReflection<$SlimConnectedXSingleBase> =
  new $DomainEntityReflection('SlimConnectedXSingleBase', [
    ...SlimConnectedXSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions,
  ])

export type $ReflectionBase = $DomainEntity<ReflectionBase> &
  ReflectionBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $ReflectionBase: $DomainEntityReflection<$ReflectionBase> = new $DomainEntityReflection('ReflectionBase', [
  ...ReflectionBaseExpressions,
  ...BaseExpressions,
  ...BaseSingleLegExpressions,
])

export type $ReflectionCTCBase = $DomainEntity<ReflectionCTCBase> &
  ReflectionCTCBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $ReflectionCTCBase: $DomainEntityReflection<$ReflectionCTCBase> = new $DomainEntityReflection(
  'ReflectionCTCBase',
  [...ReflectionCTCBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $SinglePostBase = $DomainEntity<SinglePostBase> &
  SinglePostBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $SinglePostBase: $DomainEntityReflection<$SinglePostBase> = new $DomainEntityReflection('SinglePostBase', [
  ...SinglePostBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $SinglePostSingleBase = $DomainEntity<SinglePostSingleBase> &
  SinglePostSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $SinglePostSingleBase: $DomainEntityReflection<$SinglePostSingleBase> = new $DomainEntityReflection(
  'SinglePostSingleBase',
  [...SinglePostSingleBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $XMetalBase = $DomainEntity<XMetalBase> & XMetalBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $XMetalBase: $DomainEntityReflection<$XMetalBase> = new $DomainEntityReflection('XMetalBase', [
  ...XMetalBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $XMetalSingleBase = $DomainEntity<XMetalSingleBase> &
  XMetalSingleBaseExpressions &
  BaseExpressions &
  BaseSingleLegExpressions
export const $XMetalSingleBase: $DomainEntityReflection<$XMetalSingleBase> = new $DomainEntityReflection(
  'XMetalSingleBase',
  [...XMetalSingleBaseExpressions, ...BaseExpressions, ...BaseSingleLegExpressions]
)

export type $IvyBase = $DomainEntity<IvyBase> &
  IvyBaseExpressions &
  BaseExpressions &
  BaseFourLegExpressions &
  BaseFourLegCombinedExpressions
export const $IvyBase: $DomainEntityReflection<$IvyBase> = new $DomainEntityReflection('IvyBase', [
  ...IvyBaseExpressions,
  ...BaseExpressions,
  ...BaseFourLegExpressions,
  ...BaseFourLegCombinedExpressions,
])

export type $DremorTurnedBase = $DomainEntity<DremorTurnedBase> &
  DremorTurnedBaseExpressions &
  BaseExpressions &
  BaseFourLegExpressions &
  BaseFourLegSeparateExpressions
export const $DremorTurnedBase: $DomainEntityReflection<$DremorTurnedBase> = new $DomainEntityReflection(
  'DremorTurnedBase',
  [...DremorTurnedBaseExpressions, ...BaseExpressions, ...BaseFourLegExpressions, ...BaseFourLegSeparateExpressions]
)

export type $HerricksonTurnedBase = $DomainEntity<HerricksonTurnedBase> &
  HerricksonTurnedBaseExpressions &
  BaseExpressions &
  BaseFourLegExpressions &
  BaseFourLegSeparateExpressions
export const $HerricksonTurnedBase: $DomainEntityReflection<$HerricksonTurnedBase> = new $DomainEntityReflection(
  'HerricksonTurnedBase',
  [...HerricksonTurnedBaseExpressions, ...BaseExpressions, ...BaseFourLegExpressions, ...BaseFourLegSeparateExpressions]
)

export type $MidModernTaperBase = $DomainEntity<MidModernTaperBase> &
  MidModernTaperBaseExpressions &
  BaseExpressions &
  BaseFourLegExpressions &
  BaseFourLegSeparateExpressions
export const $MidModernTaperBase: $DomainEntityReflection<$MidModernTaperBase> = new $DomainEntityReflection(
  'MidModernTaperBase',
  [...MidModernTaperBaseExpressions, ...BaseExpressions, ...BaseFourLegExpressions, ...BaseFourLegSeparateExpressions]
)

export type $NarrowEnglishTurnedBase = $DomainEntity<NarrowEnglishTurnedBase> &
  NarrowEnglishTurnedBaseExpressions &
  BaseExpressions &
  BaseFourLegExpressions &
  BaseFourLegSeparateExpressions
export const $NarrowEnglishTurnedBase: $DomainEntityReflection<$NarrowEnglishTurnedBase> = new $DomainEntityReflection(
  'NarrowEnglishTurnedBase',
  [
    ...NarrowEnglishTurnedBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegSeparateExpressions,
  ]
)

export type $OldEnglishTurnedBase = $DomainEntity<OldEnglishTurnedBase> &
  OldEnglishTurnedBaseExpressions &
  BaseExpressions &
  BaseFourLegExpressions &
  BaseFourLegSeparateExpressions
export const $OldEnglishTurnedBase: $DomainEntityReflection<$OldEnglishTurnedBase> = new $DomainEntityReflection(
  'OldEnglishTurnedBase',
  [...OldEnglishTurnedBaseExpressions, ...BaseExpressions, ...BaseFourLegExpressions, ...BaseFourLegSeparateExpressions]
)

export type $SlagleTurnedBase = $DomainEntity<SlagleTurnedBase> &
  SlagleTurnedBaseExpressions &
  BaseExpressions &
  BaseFourLegExpressions &
  BaseFourLegSeparateExpressions
export const $SlagleTurnedBase: $DomainEntityReflection<$SlagleTurnedBase> = new $DomainEntityReflection(
  'SlagleTurnedBase',
  [...SlagleTurnedBaseExpressions, ...BaseExpressions, ...BaseFourLegExpressions, ...BaseFourLegSeparateExpressions]
)

export type $TraditionalBase = $DomainEntity<TraditionalBase> &
  TraditionalBaseExpressions &
  BaseExpressions &
  BaseFourLegExpressions &
  BaseFourLegSeparateExpressions
export const $TraditionalBase: $DomainEntityReflection<$TraditionalBase> = new $DomainEntityReflection(
  'TraditionalBase',
  [...TraditionalBaseExpressions, ...BaseExpressions, ...BaseFourLegExpressions, ...BaseFourLegSeparateExpressions]
)

export type $TraditionalFlushBase = $DomainEntity<TraditionalFlushBase> &
  TraditionalFlushBaseExpressions &
  BaseExpressions &
  BaseFourLegExpressions &
  BaseFourLegSeparateExpressions
export const $TraditionalFlushBase: $DomainEntityReflection<$TraditionalFlushBase> = new $DomainEntityReflection(
  'TraditionalFlushBase',
  [...TraditionalFlushBaseExpressions, ...BaseExpressions, ...BaseFourLegExpressions, ...BaseFourLegSeparateExpressions]
)

export type $ReededBase = $DomainEntity<ReededBase> & ReededBaseExpressions & BaseExpressions & BaseSingleLegExpressions
export const $ReededBase: $DomainEntityReflection<$ReededBase> = new $DomainEntityReflection('ReededBase', [
  ...ReededBaseExpressions,
  ...BaseExpressions,
  ...BaseSingleLegExpressions,
])

export type $HershBase = $DomainEntity<HershBase> & HershBaseExpressions & BaseExpressions & BaseDoubleLegExpressions
export const $HershBase: $DomainEntityReflection<$HershBase> = new $DomainEntityReflection('HershBase', [
  ...HershBaseExpressions,
  ...BaseExpressions,
  ...BaseDoubleLegExpressions,
])

export type $TriflectionBase = $DomainEntity<TriflectionBase> &
  TriflectionBaseExpressions &
  BaseExpressions &
  BaseDoubleLegExpressions
export const $TriflectionBase: $DomainEntityReflection<$TriflectionBase> = new $DomainEntityReflection(
  'TriflectionBase',
  [...TriflectionBaseExpressions, ...BaseExpressions, ...BaseDoubleLegExpressions]
)

export type $ApronBasic = $DomainEntity<ApronBasic> & ApronBasicExpressions & ApronExpressions
export const $ApronBasic: $DomainEntityReflection<$ApronBasic> = new $DomainEntityReflection('ApronBasic', [
  ...ApronBasicExpressions,
  ...ApronExpressions,
])

export type $ApronNone = $DomainEntity<ApronNone> & ApronExpressions
export const $ApronNone: $DomainEntityReflection<$ApronNone> = new $DomainEntityReflection('ApronNone', [
  ...ApronExpressions,
])

export type $BenchBasic = $DomainEntity<BenchBasic> & BenchBasicExpressions & BenchExpressions
export const $BenchBasic: $DomainEntityReflection<$BenchBasic> = new $DomainEntityReflection('BenchBasic', [
  ...BenchBasicExpressions,
  ...BenchExpressions,
])

export type $AnyDomainEntity =
  | $Table
  | $RectangleTop
  | $SquareTop
  | $RoundTop
  | $EllipticalOvalTop
  | $RacetrackOvalTop
  | $BoatShapeTop
  | $AnchorBase
  | $AnchorSingleFeetBase
  | $AnchorSinglePlatformBase
  | $BellhouseBase
  | $BellhouseSingleFeetBase
  | $BellhouseSinglePlatformBase
  | $BellyStretchedBase
  | $BrewerBase
  | $BrewerSingleBase
  | $CaseyBase
  | $CraftsmanBase
  | $CraftsmanSingleBase
  | $CrescentBase
  | $CrescentSingleBase
  | $DanaBase
  | $DanaSingleBase
  | $FranklinBase
  | $FranklinSingleFeetBase
  | $FranklinSinglePlatformBase
  | $MantisBase
  | $MarksBase
  | $MeredithBase
  | $MeredithSingleFeetBase
  | $MeredithSinglePlatformBase
  | $OswaldBase
  | $OswaldSingleBase
  | $PeruStretchedBase
  | $RishBase
  | $RishSingleBase
  | $RogersBase
  | $RogersSinglePlatformBase
  | $TamaraBase
  | $TamaraSingleBase
  | $TuscanBase
  | $TuscanSingleFeetBase
  | $TuscanSinglePlatformBase
  | $WaldenBase
  | $WaldenSingleBase
  | $AnglePictureFrameBase
  | $XBase
  | $XSingleBase
  | $AnglePictureFrameSingleBase
  | $AnglePictureFrameCTCBase
  | $ArchBase
  | $ArchSingleBase
  | $BoxFrameBase
  | $ConnectedXBase
  | $SlimConnectedXBase
  | $SlimConnectedXSingleBase
  | $ReflectionBase
  | $ReflectionCTCBase
  | $SinglePostBase
  | $SinglePostSingleBase
  | $XMetalBase
  | $XMetalSingleBase
  | $IvyBase
  | $DremorTurnedBase
  | $HerricksonTurnedBase
  | $MidModernTaperBase
  | $NarrowEnglishTurnedBase
  | $OldEnglishTurnedBase
  | $SlagleTurnedBase
  | $TraditionalBase
  | $TraditionalFlushBase
  | $ReededBase
  | $HershBase
  | $TriflectionBase
  | $ApronBasic
  | $ApronNone
  | $BenchBasic
export const $AnyDomainEntity: EnhancedAliasReflection<$AnyDomainEntity> = new EnhancedAliasReflection(
  '$AnyDomainEntity',
  [
    Table.type,
    RectangleTop.type,
    SquareTop.type,
    RoundTop.type,
    EllipticalOvalTop.type,
    RacetrackOvalTop.type,
    BoatShapeTop.type,
    AnchorBase.type,
    AnchorSingleFeetBase.type,
    AnchorSinglePlatformBase.type,
    BellhouseBase.type,
    BellhouseSingleFeetBase.type,
    BellhouseSinglePlatformBase.type,
    BellyStretchedBase.type,
    BrewerBase.type,
    BrewerSingleBase.type,
    CaseyBase.type,
    CraftsmanBase.type,
    CraftsmanSingleBase.type,
    CrescentBase.type,
    CrescentSingleBase.type,
    DanaBase.type,
    DanaSingleBase.type,
    FranklinBase.type,
    FranklinSingleFeetBase.type,
    FranklinSinglePlatformBase.type,
    MantisBase.type,
    MarksBase.type,
    MeredithBase.type,
    MeredithSingleFeetBase.type,
    MeredithSinglePlatformBase.type,
    OswaldBase.type,
    OswaldSingleBase.type,
    PeruStretchedBase.type,
    RishBase.type,
    RishSingleBase.type,
    RogersBase.type,
    RogersSinglePlatformBase.type,
    TamaraBase.type,
    TamaraSingleBase.type,
    TuscanBase.type,
    TuscanSingleFeetBase.type,
    TuscanSinglePlatformBase.type,
    WaldenBase.type,
    WaldenSingleBase.type,
    AnglePictureFrameBase.type,
    XBase.type,
    XSingleBase.type,
    AnglePictureFrameSingleBase.type,
    AnglePictureFrameCTCBase.type,
    ArchBase.type,
    ArchSingleBase.type,
    BoxFrameBase.type,
    ConnectedXBase.type,
    SlimConnectedXBase.type,
    SlimConnectedXSingleBase.type,
    ReflectionBase.type,
    ReflectionCTCBase.type,
    SinglePostBase.type,
    SinglePostSingleBase.type,
    XMetalBase.type,
    XMetalSingleBase.type,
    IvyBase.type,
    DremorTurnedBase.type,
    HerricksonTurnedBase.type,
    MidModernTaperBase.type,
    NarrowEnglishTurnedBase.type,
    OldEnglishTurnedBase.type,
    SlagleTurnedBase.type,
    TraditionalBase.type,
    TraditionalFlushBase.type,
    ReededBase.type,
    HershBase.type,
    TriflectionBase.type,
    ApronBasic.type,
    ApronNone.type,
    BenchBasic.type,
  ]
)

export type $RootEntity = $Table
export const $RootEntity: EnhancedAliasReflection<$RootEntity> = new EnhancedAliasReflection('$RootEntity', [
  Table.type,
])

export type $Top = $RectangleTop | $SquareTop | $RoundTop | $EllipticalOvalTop | $RacetrackOvalTop | $BoatShapeTop
export const $Top: EnhancedAliasReflection<$Top> = new EnhancedAliasReflection('$Top', [
  RectangleTop.type,
  SquareTop.type,
  RoundTop.type,
  EllipticalOvalTop.type,
  RacetrackOvalTop.type,
  BoatShapeTop.type,
])

export type $Base =
  | $AnchorBase
  | $AnchorSingleFeetBase
  | $AnchorSinglePlatformBase
  | $BellhouseBase
  | $BellhouseSingleFeetBase
  | $BellhouseSinglePlatformBase
  | $BellyStretchedBase
  | $BrewerBase
  | $BrewerSingleBase
  | $CaseyBase
  | $CraftsmanBase
  | $CraftsmanSingleBase
  | $CrescentBase
  | $CrescentSingleBase
  | $DanaBase
  | $DanaSingleBase
  | $FranklinBase
  | $FranklinSingleFeetBase
  | $FranklinSinglePlatformBase
  | $MantisBase
  | $MarksBase
  | $MeredithBase
  | $MeredithSingleFeetBase
  | $MeredithSinglePlatformBase
  | $OswaldBase
  | $OswaldSingleBase
  | $PeruStretchedBase
  | $RishBase
  | $RishSingleBase
  | $RogersBase
  | $RogersSinglePlatformBase
  | $TamaraBase
  | $TamaraSingleBase
  | $TuscanBase
  | $TuscanSingleFeetBase
  | $TuscanSinglePlatformBase
  | $WaldenBase
  | $WaldenSingleBase
  | $XBase
  | $XSingleBase
  | $AnglePictureFrameBase
  | $AnglePictureFrameSingleBase
  | $AnglePictureFrameCTCBase
  | $ArchBase
  | $ArchSingleBase
  | $BoxFrameBase
  | $ConnectedXBase
  | $SlimConnectedXBase
  | $SlimConnectedXSingleBase
  | $ReflectionBase
  | $ReflectionCTCBase
  | $SinglePostBase
  | $SinglePostSingleBase
  | $XMetalBase
  | $XMetalSingleBase
  | $IvyBase
  | $DremorTurnedBase
  | $HerricksonTurnedBase
  | $MidModernTaperBase
  | $NarrowEnglishTurnedBase
  | $OldEnglishTurnedBase
  | $SlagleTurnedBase
  | $TraditionalBase
  | $TraditionalFlushBase
  | $ReededBase
  | $HershBase
  | $TriflectionBase
export const $Base: EnhancedAliasReflection<$Base> = new EnhancedAliasReflection('$Base', [
  AnchorBase.type,
  AnchorSingleFeetBase.type,
  AnchorSinglePlatformBase.type,
  BellhouseBase.type,
  BellhouseSingleFeetBase.type,
  BellhouseSinglePlatformBase.type,
  BellyStretchedBase.type,
  BrewerBase.type,
  BrewerSingleBase.type,
  CaseyBase.type,
  CraftsmanBase.type,
  CraftsmanSingleBase.type,
  CrescentBase.type,
  CrescentSingleBase.type,
  DanaBase.type,
  DanaSingleBase.type,
  FranklinBase.type,
  FranklinSingleFeetBase.type,
  FranklinSinglePlatformBase.type,
  MantisBase.type,
  MarksBase.type,
  MeredithBase.type,
  MeredithSingleFeetBase.type,
  MeredithSinglePlatformBase.type,
  OswaldBase.type,
  OswaldSingleBase.type,
  PeruStretchedBase.type,
  RishBase.type,
  RishSingleBase.type,
  RogersBase.type,
  RogersSinglePlatformBase.type,
  TamaraBase.type,
  TamaraSingleBase.type,
  TuscanBase.type,
  TuscanSingleFeetBase.type,
  TuscanSinglePlatformBase.type,
  WaldenBase.type,
  WaldenSingleBase.type,
  XBase.type,
  XSingleBase.type,
  AnglePictureFrameBase.type,
  AnglePictureFrameSingleBase.type,
  AnglePictureFrameCTCBase.type,
  ArchBase.type,
  ArchSingleBase.type,
  BoxFrameBase.type,
  ConnectedXBase.type,
  SlimConnectedXBase.type,
  SlimConnectedXSingleBase.type,
  ReflectionBase.type,
  ReflectionCTCBase.type,
  SinglePostBase.type,
  SinglePostSingleBase.type,
  XMetalBase.type,
  XMetalSingleBase.type,
  IvyBase.type,
  DremorTurnedBase.type,
  HerricksonTurnedBase.type,
  MidModernTaperBase.type,
  NarrowEnglishTurnedBase.type,
  OldEnglishTurnedBase.type,
  SlagleTurnedBase.type,
  TraditionalBase.type,
  TraditionalFlushBase.type,
  ReededBase.type,
  HershBase.type,
  TriflectionBase.type,
])

export type $Apron = $ApronBasic | $ApronNone
export const $Apron: EnhancedAliasReflection<$Apron> = new EnhancedAliasReflection('$Apron', [
  ApronBasic.type,
  ApronNone.type,
])

export type $Bench = $BenchBasic
export const $Bench: EnhancedAliasReflection<$Bench> = new EnhancedAliasReflection('$Bench', [BenchBasic.type])

export type $TopOval = $EllipticalOvalTop | $RacetrackOvalTop
export const $TopOval: EnhancedAliasReflection<$TopOval> = new EnhancedAliasReflection('$TopOval', [
  EllipticalOvalTop.type,
  RacetrackOvalTop.type,
])

export type $TopWithSide = $SquareTop
export const $TopWithSide: EnhancedAliasReflection<$TopWithSide> = new EnhancedAliasReflection('$TopWithSide', [
  SquareTop.type,
])

export type $TopWithWidthAndLength = $RectangleTop | $EllipticalOvalTop | $RacetrackOvalTop | $BoatShapeTop
export const $TopWithWidthAndLength: EnhancedAliasReflection<$TopWithWidthAndLength> = new EnhancedAliasReflection(
  '$TopWithWidthAndLength',
  [RectangleTop.type, EllipticalOvalTop.type, RacetrackOvalTop.type, BoatShapeTop.type]
)

export type $TopWithDiameter = $RoundTop
export const $TopWithDiameter: EnhancedAliasReflection<$TopWithDiameter> = new EnhancedAliasReflection(
  '$TopWithDiameter',
  [RoundTop.type]
)

export type $TopWithRolledThickness = $RectangleTop | $SquareTop
export const $TopWithRolledThickness: EnhancedAliasReflection<$TopWithRolledThickness> = new EnhancedAliasReflection(
  '$TopWithRolledThickness',
  [RectangleTop.type, SquareTop.type]
)

export type $BasePedestal =
  | $AnchorBase
  | $AnchorSingleFeetBase
  | $AnchorSinglePlatformBase
  | $BellhouseBase
  | $BellhouseSingleFeetBase
  | $BellhouseSinglePlatformBase
  | $BellyStretchedBase
  | $BrewerBase
  | $BrewerSingleBase
  | $CaseyBase
  | $CraftsmanBase
  | $CraftsmanSingleBase
  | $CrescentBase
  | $CrescentSingleBase
  | $DanaBase
  | $DanaSingleBase
  | $FranklinBase
  | $FranklinSingleFeetBase
  | $FranklinSinglePlatformBase
  | $MarksBase
  | $MeredithBase
  | $MeredithSingleFeetBase
  | $MeredithSinglePlatformBase
  | $OswaldBase
  | $OswaldSingleBase
  | $PeruStretchedBase
  | $RishBase
  | $RishSingleBase
  | $RogersBase
  | $RogersSinglePlatformBase
  | $TamaraBase
  | $TamaraSingleBase
  | $TuscanBase
  | $TuscanSingleFeetBase
  | $TuscanSinglePlatformBase
  | $WaldenBase
  | $WaldenSingleBase
  | $XBase
  | $XSingleBase
  | $ReededBase
  | $HershBase
export const $BasePedestal: EnhancedAliasReflection<$BasePedestal> = new EnhancedAliasReflection('$BasePedestal', [
  AnchorBase.type,
  AnchorSingleFeetBase.type,
  AnchorSinglePlatformBase.type,
  BellhouseBase.type,
  BellhouseSingleFeetBase.type,
  BellhouseSinglePlatformBase.type,
  BellyStretchedBase.type,
  BrewerBase.type,
  BrewerSingleBase.type,
  CaseyBase.type,
  CraftsmanBase.type,
  CraftsmanSingleBase.type,
  CrescentBase.type,
  CrescentSingleBase.type,
  DanaBase.type,
  DanaSingleBase.type,
  FranklinBase.type,
  FranklinSingleFeetBase.type,
  FranklinSinglePlatformBase.type,
  MarksBase.type,
  MeredithBase.type,
  MeredithSingleFeetBase.type,
  MeredithSinglePlatformBase.type,
  OswaldBase.type,
  OswaldSingleBase.type,
  PeruStretchedBase.type,
  RishBase.type,
  RishSingleBase.type,
  RogersBase.type,
  RogersSinglePlatformBase.type,
  TamaraBase.type,
  TamaraSingleBase.type,
  TuscanBase.type,
  TuscanSingleFeetBase.type,
  TuscanSinglePlatformBase.type,
  WaldenBase.type,
  WaldenSingleBase.type,
  XBase.type,
  XSingleBase.type,
  ReededBase.type,
  HershBase.type,
])

export type $BaseMetal =
  | $MantisBase
  | $AnglePictureFrameBase
  | $AnglePictureFrameSingleBase
  | $AnglePictureFrameCTCBase
  | $ArchBase
  | $ArchSingleBase
  | $BoxFrameBase
  | $ConnectedXBase
  | $SlimConnectedXBase
  | $SlimConnectedXSingleBase
  | $ReflectionBase
  | $ReflectionCTCBase
  | $SinglePostBase
  | $SinglePostSingleBase
  | $XMetalBase
  | $XMetalSingleBase
  | $TriflectionBase
export const $BaseMetal: EnhancedAliasReflection<$BaseMetal> = new EnhancedAliasReflection('$BaseMetal', [
  MantisBase.type,
  AnglePictureFrameBase.type,
  AnglePictureFrameSingleBase.type,
  AnglePictureFrameCTCBase.type,
  ArchBase.type,
  ArchSingleBase.type,
  BoxFrameBase.type,
  ConnectedXBase.type,
  SlimConnectedXBase.type,
  SlimConnectedXSingleBase.type,
  ReflectionBase.type,
  ReflectionCTCBase.type,
  SinglePostBase.type,
  SinglePostSingleBase.type,
  XMetalBase.type,
  XMetalSingleBase.type,
  TriflectionBase.type,
])

export type $BaseFourLeg =
  | $IvyBase
  | $DremorTurnedBase
  | $HerricksonTurnedBase
  | $MidModernTaperBase
  | $NarrowEnglishTurnedBase
  | $OldEnglishTurnedBase
  | $SlagleTurnedBase
  | $TraditionalBase
  | $TraditionalFlushBase
export const $BaseFourLeg: EnhancedAliasReflection<$BaseFourLeg> = new EnhancedAliasReflection('$BaseFourLeg', [
  IvyBase.type,
  DremorTurnedBase.type,
  HerricksonTurnedBase.type,
  MidModernTaperBase.type,
  NarrowEnglishTurnedBase.type,
  OldEnglishTurnedBase.type,
  SlagleTurnedBase.type,
  TraditionalBase.type,
  TraditionalFlushBase.type,
])

export type $BaseSingleLeg =
  | $BellyStretchedBase
  | $BrewerSingleBase
  | $AnchorSingleFeetBase
  | $AnchorSinglePlatformBase
  | $BellhouseSingleFeetBase
  | $BellhouseSinglePlatformBase
  | $CraftsmanSingleBase
  | $CrescentSingleBase
  | $DanaSingleBase
  | $FranklinSingleFeetBase
  | $FranklinSinglePlatformBase
  | $MantisBase
  | $MarksBase
  | $MeredithSingleFeetBase
  | $MeredithSinglePlatformBase
  | $OswaldSingleBase
  | $PeruStretchedBase
  | $RishSingleBase
  | $RogersSinglePlatformBase
  | $TamaraSingleBase
  | $TuscanSingleFeetBase
  | $TuscanSinglePlatformBase
  | $WaldenSingleBase
  | $XSingleBase
  | $AnglePictureFrameSingleBase
  | $AnglePictureFrameCTCBase
  | $ArchSingleBase
  | $SlimConnectedXSingleBase
  | $ReflectionBase
  | $ReflectionCTCBase
  | $SinglePostSingleBase
  | $XMetalSingleBase
  | $ReededBase
export const $BaseSingleLeg: EnhancedAliasReflection<$BaseSingleLeg> = new EnhancedAliasReflection('$BaseSingleLeg', [
  BellyStretchedBase.type,
  BrewerSingleBase.type,
  AnchorSingleFeetBase.type,
  AnchorSinglePlatformBase.type,
  BellhouseSingleFeetBase.type,
  BellhouseSinglePlatformBase.type,
  CraftsmanSingleBase.type,
  CrescentSingleBase.type,
  DanaSingleBase.type,
  FranklinSingleFeetBase.type,
  FranklinSinglePlatformBase.type,
  MantisBase.type,
  MarksBase.type,
  MeredithSingleFeetBase.type,
  MeredithSinglePlatformBase.type,
  OswaldSingleBase.type,
  PeruStretchedBase.type,
  RishSingleBase.type,
  RogersSinglePlatformBase.type,
  TamaraSingleBase.type,
  TuscanSingleFeetBase.type,
  TuscanSinglePlatformBase.type,
  WaldenSingleBase.type,
  XSingleBase.type,
  AnglePictureFrameSingleBase.type,
  AnglePictureFrameCTCBase.type,
  ArchSingleBase.type,
  SlimConnectedXSingleBase.type,
  ReflectionBase.type,
  ReflectionCTCBase.type,
  SinglePostSingleBase.type,
  XMetalSingleBase.type,
  ReededBase.type,
])

export type $BaseDoubleLeg =
  | $AnchorBase
  | $BellhouseBase
  | $BrewerBase
  | $CaseyBase
  | $CraftsmanBase
  | $CrescentBase
  | $DanaBase
  | $FranklinBase
  | $MeredithBase
  | $OswaldBase
  | $RishBase
  | $RogersBase
  | $TamaraBase
  | $TuscanBase
  | $WaldenBase
  | $XBase
  | $AnglePictureFrameBase
  | $ArchBase
  | $BoxFrameBase
  | $ConnectedXBase
  | $SlimConnectedXBase
  | $SinglePostBase
  | $XMetalBase
  | $HershBase
  | $TriflectionBase
export const $BaseDoubleLeg: EnhancedAliasReflection<$BaseDoubleLeg> = new EnhancedAliasReflection('$BaseDoubleLeg', [
  AnchorBase.type,
  BellhouseBase.type,
  BrewerBase.type,
  CaseyBase.type,
  CraftsmanBase.type,
  CrescentBase.type,
  DanaBase.type,
  FranklinBase.type,
  MeredithBase.type,
  OswaldBase.type,
  RishBase.type,
  RogersBase.type,
  TamaraBase.type,
  TuscanBase.type,
  WaldenBase.type,
  XBase.type,
  AnglePictureFrameBase.type,
  ArchBase.type,
  BoxFrameBase.type,
  ConnectedXBase.type,
  SlimConnectedXBase.type,
  SinglePostBase.type,
  XMetalBase.type,
  HershBase.type,
  TriflectionBase.type,
])

export type $BaseWithPlatform =
  | $AnchorSinglePlatformBase
  | $BellhouseSinglePlatformBase
  | $BellyStretchedBase
  | $FranklinSinglePlatformBase
  | $MeredithSinglePlatformBase
  | $TuscanSinglePlatformBase
  | $PeruStretchedBase
  | $RogersSinglePlatformBase
export const $BaseWithPlatform: EnhancedAliasReflection<$BaseWithPlatform> = new EnhancedAliasReflection(
  '$BaseWithPlatform',
  [
    AnchorSinglePlatformBase.type,
    BellhouseSinglePlatformBase.type,
    BellyStretchedBase.type,
    FranklinSinglePlatformBase.type,
    MeredithSinglePlatformBase.type,
    TuscanSinglePlatformBase.type,
    PeruStretchedBase.type,
    RogersSinglePlatformBase.type,
  ]
)

export type $BaseFourLegCombined = $IvyBase
export const $BaseFourLegCombined: EnhancedAliasReflection<$BaseFourLegCombined> = new EnhancedAliasReflection(
  '$BaseFourLegCombined',
  [IvyBase.type]
)

export type $BaseFourLegSeparate =
  | $DremorTurnedBase
  | $HerricksonTurnedBase
  | $MidModernTaperBase
  | $NarrowEnglishTurnedBase
  | $OldEnglishTurnedBase
  | $SlagleTurnedBase
  | $TraditionalBase
  | $TraditionalFlushBase
export const $BaseFourLegSeparate: EnhancedAliasReflection<$BaseFourLegSeparate> = new EnhancedAliasReflection(
  '$BaseFourLegSeparate',
  [
    DremorTurnedBase.type,
    HerricksonTurnedBase.type,
    MidModernTaperBase.type,
    NarrowEnglishTurnedBase.type,
    OldEnglishTurnedBase.type,
    SlagleTurnedBase.type,
    TraditionalBase.type,
    TraditionalFlushBase.type,
  ]
)

export type $TopWithSquareCorners = $RectangleTop | $SquareTop
export const $TopWithSquareCorners: EnhancedAliasReflection<$TopWithSquareCorners> = new EnhancedAliasReflection(
  '$TopWithSquareCorners',
  [RectangleTop.type, SquareTop.type]
)

export type $TopWithRoundedCorners = $RoundTop | $EllipticalOvalTop | $RacetrackOvalTop | $BoatShapeTop
export const $TopWithRoundedCorners: EnhancedAliasReflection<$TopWithRoundedCorners> = new EnhancedAliasReflection(
  '$TopWithRoundedCorners',
  [RoundTop.type, EllipticalOvalTop.type, RacetrackOvalTop.type, BoatShapeTop.type]
)

export type $StretchedBase = $BellyStretchedBase | $PeruStretchedBase
export const $StretchedBase: EnhancedAliasReflection<$StretchedBase> = new EnhancedAliasReflection('$StretchedBase', [
  BellyStretchedBase.type,
  PeruStretchedBase.type,
])

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type $Map = {
  Table: $Table
  RectangleTop: $RectangleTop
  SquareTop: $SquareTop
  RoundTop: $RoundTop
  EllipticalOvalTop: $EllipticalOvalTop
  RacetrackOvalTop: $RacetrackOvalTop
  BoatShapeTop: $BoatShapeTop
  AnchorBase: $AnchorBase
  AnchorSingleFeetBase: $AnchorSingleFeetBase
  AnchorSinglePlatformBase: $AnchorSinglePlatformBase
  BellhouseBase: $BellhouseBase
  BellhouseSingleFeetBase: $BellhouseSingleFeetBase
  BellhouseSinglePlatformBase: $BellhouseSinglePlatformBase
  BellyStretchedBase: $BellyStretchedBase
  BrewerBase: $BrewerBase
  BrewerSingleBase: $BrewerSingleBase
  CaseyBase: $CaseyBase
  CraftsmanBase: $CraftsmanBase
  CraftsmanSingleBase: $CraftsmanSingleBase
  CrescentBase: $CrescentBase
  CrescentSingleBase: $CrescentSingleBase
  DanaBase: $DanaBase
  DanaSingleBase: $DanaSingleBase
  FranklinBase: $FranklinBase
  FranklinSingleFeetBase: $FranklinSingleFeetBase
  FranklinSinglePlatformBase: $FranklinSinglePlatformBase
  MantisBase: $MantisBase
  MarksBase: $MarksBase
  MeredithBase: $MeredithBase
  MeredithSingleFeetBase: $MeredithSingleFeetBase
  MeredithSinglePlatformBase: $MeredithSinglePlatformBase
  OswaldBase: $OswaldBase
  OswaldSingleBase: $OswaldSingleBase
  PeruStretchedBase: $PeruStretchedBase
  RishBase: $RishBase
  RishSingleBase: $RishSingleBase
  RogersBase: $RogersBase
  RogersSinglePlatformBase: $RogersSinglePlatformBase
  TamaraBase: $TamaraBase
  TamaraSingleBase: $TamaraSingleBase
  TuscanBase: $TuscanBase
  TuscanSingleFeetBase: $TuscanSingleFeetBase
  TuscanSinglePlatformBase: $TuscanSinglePlatformBase
  WaldenBase: $WaldenBase
  WaldenSingleBase: $WaldenSingleBase
  AnglePictureFrameBase: $AnglePictureFrameBase
  XBase: $XBase
  XSingleBase: $XSingleBase
  AnglePictureFrameSingleBase: $AnglePictureFrameSingleBase
  AnglePictureFrameCTCBase: $AnglePictureFrameCTCBase
  ArchBase: $ArchBase
  ArchSingleBase: $ArchSingleBase
  BoxFrameBase: $BoxFrameBase
  ConnectedXBase: $ConnectedXBase
  SlimConnectedXBase: $SlimConnectedXBase
  SlimConnectedXSingleBase: $SlimConnectedXSingleBase
  ReflectionBase: $ReflectionBase
  ReflectionCTCBase: $ReflectionCTCBase
  SinglePostBase: $SinglePostBase
  SinglePostSingleBase: $SinglePostSingleBase
  XMetalBase: $XMetalBase
  XMetalSingleBase: $XMetalSingleBase
  IvyBase: $IvyBase
  DremorTurnedBase: $DremorTurnedBase
  HerricksonTurnedBase: $HerricksonTurnedBase
  MidModernTaperBase: $MidModernTaperBase
  NarrowEnglishTurnedBase: $NarrowEnglishTurnedBase
  OldEnglishTurnedBase: $OldEnglishTurnedBase
  SlagleTurnedBase: $SlagleTurnedBase
  TraditionalBase: $TraditionalBase
  TraditionalFlushBase: $TraditionalFlushBase
  ReededBase: $ReededBase
  HershBase: $HershBase
  TriflectionBase: $TriflectionBase
  ApronBasic: $ApronBasic
  ApronNone: $ApronNone
  BenchBasic: $BenchBasic
  AnyDomainEntity: $AnyDomainEntity
  RootEntity: $RootEntity
  Top: $Top
  Base: $Base
  Apron: $Apron
  Bench: $Bench
  TopOval: $TopOval
  TopWithSide: $TopWithSide
  TopWithWidthAndLength: $TopWithWidthAndLength
  TopWithDiameter: $TopWithDiameter
  TopWithRolledThickness: $TopWithRolledThickness
  BasePedestal: $BasePedestal
  BaseMetal: $BaseMetal
  BaseFourLeg: $BaseFourLeg
  BaseSingleLeg: $BaseSingleLeg
  BaseDoubleLeg: $BaseDoubleLeg
  BaseWithPlatform: $BaseWithPlatform
  BaseFourLegCombined: $BaseFourLegCombined
  BaseFourLegSeparate: $BaseFourLegSeparate
  TopWithSquareCorners: $TopWithSquareCorners
  TopWithRoundedCorners: $TopWithRoundedCorners
  StretchedBase: $StretchedBase
}

export const $entityReflections = {
  Table: $Table,
  RectangleTop: $RectangleTop,
  SquareTop: $SquareTop,
  RoundTop: $RoundTop,
  EllipticalOvalTop: $EllipticalOvalTop,
  RacetrackOvalTop: $RacetrackOvalTop,
  BoatShapeTop: $BoatShapeTop,
  AnchorBase: $AnchorBase,
  AnchorSingleFeetBase: $AnchorSingleFeetBase,
  AnchorSinglePlatformBase: $AnchorSinglePlatformBase,
  BellhouseBase: $BellhouseBase,
  BellhouseSingleFeetBase: $BellhouseSingleFeetBase,
  BellhouseSinglePlatformBase: $BellhouseSinglePlatformBase,
  BellyStretchedBase: $BellyStretchedBase,
  BrewerBase: $BrewerBase,
  BrewerSingleBase: $BrewerSingleBase,
  CaseyBase: $CaseyBase,
  CraftsmanBase: $CraftsmanBase,
  CraftsmanSingleBase: $CraftsmanSingleBase,
  CrescentBase: $CrescentBase,
  CrescentSingleBase: $CrescentSingleBase,
  DanaBase: $DanaBase,
  DanaSingleBase: $DanaSingleBase,
  FranklinBase: $FranklinBase,
  FranklinSingleFeetBase: $FranklinSingleFeetBase,
  FranklinSinglePlatformBase: $FranklinSinglePlatformBase,
  MantisBase: $MantisBase,
  MarksBase: $MarksBase,
  MeredithBase: $MeredithBase,
  MeredithSingleFeetBase: $MeredithSingleFeetBase,
  MeredithSinglePlatformBase: $MeredithSinglePlatformBase,
  OswaldBase: $OswaldBase,
  OswaldSingleBase: $OswaldSingleBase,
  PeruStretchedBase: $PeruStretchedBase,
  RishBase: $RishBase,
  RishSingleBase: $RishSingleBase,
  RogersBase: $RogersBase,
  RogersSinglePlatformBase: $RogersSinglePlatformBase,
  TamaraBase: $TamaraBase,
  TamaraSingleBase: $TamaraSingleBase,
  TuscanBase: $TuscanBase,
  TuscanSingleFeetBase: $TuscanSingleFeetBase,
  TuscanSinglePlatformBase: $TuscanSinglePlatformBase,
  WaldenBase: $WaldenBase,
  WaldenSingleBase: $WaldenSingleBase,
  AnglePictureFrameBase: $AnglePictureFrameBase,
  XBase: $XBase,
  XSingleBase: $XSingleBase,
  AnglePictureFrameSingleBase: $AnglePictureFrameSingleBase,
  AnglePictureFrameCTCBase: $AnglePictureFrameCTCBase,
  ArchBase: $ArchBase,
  ArchSingleBase: $ArchSingleBase,
  BoxFrameBase: $BoxFrameBase,
  ConnectedXBase: $ConnectedXBase,
  SlimConnectedXBase: $SlimConnectedXBase,
  SlimConnectedXSingleBase: $SlimConnectedXSingleBase,
  ReflectionBase: $ReflectionBase,
  ReflectionCTCBase: $ReflectionCTCBase,
  SinglePostBase: $SinglePostBase,
  SinglePostSingleBase: $SinglePostSingleBase,
  XMetalBase: $XMetalBase,
  XMetalSingleBase: $XMetalSingleBase,
  IvyBase: $IvyBase,
  DremorTurnedBase: $DremorTurnedBase,
  HerricksonTurnedBase: $HerricksonTurnedBase,
  MidModernTaperBase: $MidModernTaperBase,
  NarrowEnglishTurnedBase: $NarrowEnglishTurnedBase,
  OldEnglishTurnedBase: $OldEnglishTurnedBase,
  SlagleTurnedBase: $SlagleTurnedBase,
  TraditionalBase: $TraditionalBase,
  TraditionalFlushBase: $TraditionalFlushBase,
  ReededBase: $ReededBase,
  HershBase: $HershBase,
  TriflectionBase: $TriflectionBase,
  ApronBasic: $ApronBasic,
  ApronNone: $ApronNone,
  BenchBasic: $BenchBasic,
}

declare global {
  interface EnhancedModel {
    readonly $Table: $Table
    readonly $RectangleTop: $RectangleTop
    readonly $SquareTop: $SquareTop
    readonly $RoundTop: $RoundTop
    readonly $EllipticalOvalTop: $EllipticalOvalTop
    readonly $RacetrackOvalTop: $RacetrackOvalTop
    readonly $BoatShapeTop: $BoatShapeTop
    readonly $AnchorBase: $AnchorBase
    readonly $AnchorSingleFeetBase: $AnchorSingleFeetBase
    readonly $AnchorSinglePlatformBase: $AnchorSinglePlatformBase
    readonly $BellhouseBase: $BellhouseBase
    readonly $BellhouseSingleFeetBase: $BellhouseSingleFeetBase
    readonly $BellhouseSinglePlatformBase: $BellhouseSinglePlatformBase
    readonly $BellyStretchedBase: $BellyStretchedBase
    readonly $BrewerBase: $BrewerBase
    readonly $BrewerSingleBase: $BrewerSingleBase
    readonly $CaseyBase: $CaseyBase
    readonly $CraftsmanBase: $CraftsmanBase
    readonly $CraftsmanSingleBase: $CraftsmanSingleBase
    readonly $CrescentBase: $CrescentBase
    readonly $CrescentSingleBase: $CrescentSingleBase
    readonly $DanaBase: $DanaBase
    readonly $DanaSingleBase: $DanaSingleBase
    readonly $FranklinBase: $FranklinBase
    readonly $FranklinSingleFeetBase: $FranklinSingleFeetBase
    readonly $FranklinSinglePlatformBase: $FranklinSinglePlatformBase
    readonly $MantisBase: $MantisBase
    readonly $MarksBase: $MarksBase
    readonly $MeredithBase: $MeredithBase
    readonly $MeredithSingleFeetBase: $MeredithSingleFeetBase
    readonly $MeredithSinglePlatformBase: $MeredithSinglePlatformBase
    readonly $OswaldBase: $OswaldBase
    readonly $OswaldSingleBase: $OswaldSingleBase
    readonly $PeruStretchedBase: $PeruStretchedBase
    readonly $RishBase: $RishBase
    readonly $RishSingleBase: $RishSingleBase
    readonly $RogersBase: $RogersBase
    readonly $RogersSinglePlatformBase: $RogersSinglePlatformBase
    readonly $TamaraBase: $TamaraBase
    readonly $TamaraSingleBase: $TamaraSingleBase
    readonly $TuscanBase: $TuscanBase
    readonly $TuscanSingleFeetBase: $TuscanSingleFeetBase
    readonly $TuscanSinglePlatformBase: $TuscanSinglePlatformBase
    readonly $WaldenBase: $WaldenBase
    readonly $WaldenSingleBase: $WaldenSingleBase
    readonly $AnglePictureFrameBase: $AnglePictureFrameBase
    readonly $XBase: $XBase
    readonly $XSingleBase: $XSingleBase
    readonly $AnglePictureFrameSingleBase: $AnglePictureFrameSingleBase
    readonly $AnglePictureFrameCTCBase: $AnglePictureFrameCTCBase
    readonly $ArchBase: $ArchBase
    readonly $ArchSingleBase: $ArchSingleBase
    readonly $BoxFrameBase: $BoxFrameBase
    readonly $ConnectedXBase: $ConnectedXBase
    readonly $SlimConnectedXBase: $SlimConnectedXBase
    readonly $SlimConnectedXSingleBase: $SlimConnectedXSingleBase
    readonly $ReflectionBase: $ReflectionBase
    readonly $ReflectionCTCBase: $ReflectionCTCBase
    readonly $SinglePostBase: $SinglePostBase
    readonly $SinglePostSingleBase: $SinglePostSingleBase
    readonly $XMetalBase: $XMetalBase
    readonly $XMetalSingleBase: $XMetalSingleBase
    readonly $IvyBase: $IvyBase
    readonly $DremorTurnedBase: $DremorTurnedBase
    readonly $HerricksonTurnedBase: $HerricksonTurnedBase
    readonly $MidModernTaperBase: $MidModernTaperBase
    readonly $NarrowEnglishTurnedBase: $NarrowEnglishTurnedBase
    readonly $OldEnglishTurnedBase: $OldEnglishTurnedBase
    readonly $SlagleTurnedBase: $SlagleTurnedBase
    readonly $TraditionalBase: $TraditionalBase
    readonly $TraditionalFlushBase: $TraditionalFlushBase
    readonly $ReededBase: $ReededBase
    readonly $HershBase: $HershBase
    readonly $TriflectionBase: $TriflectionBase
    readonly $ApronBasic: $ApronBasic
    readonly $ApronNone: $ApronNone
    readonly $BenchBasic: $BenchBasic

    readonly $AnyDomainEntity: $AnyDomainEntity
    readonly $RootEntity: $RootEntity
    readonly $Top: $Top
    readonly $Base: $Base
    readonly $Apron: $Apron
    readonly $Bench: $Bench
    readonly $TopOval: $TopOval
    readonly $TopWithSide: $TopWithSide
    readonly $TopWithWidthAndLength: $TopWithWidthAndLength
    readonly $TopWithDiameter: $TopWithDiameter
    readonly $TopWithRolledThickness: $TopWithRolledThickness
    readonly $BasePedestal: $BasePedestal
    readonly $BaseMetal: $BaseMetal
    readonly $BaseFourLeg: $BaseFourLeg
    readonly $BaseSingleLeg: $BaseSingleLeg
    readonly $BaseDoubleLeg: $BaseDoubleLeg
    readonly $BaseWithPlatform: $BaseWithPlatform
    readonly $BaseFourLegCombined: $BaseFourLegCombined
    readonly $BaseFourLegSeparate: $BaseFourLegSeparate
    readonly $TopWithSquareCorners: $TopWithSquareCorners
    readonly $TopWithRoundedCorners: $TopWithRoundedCorners
    readonly $StretchedBase: $StretchedBase
  }
}
